/* tslint:disable */
/* eslint-disable */
/**
 * Identity Service API
 * Documentation Launchpad Service API v1.0
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface BasicAuthCredentialsResource
 */
export interface BasicAuthCredentialsResource {
    /**
     * 
     * @type {number}
     * @memberof BasicAuthCredentialsResource
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof BasicAuthCredentialsResource
     */
    'user'?: string;
    /**
     * 
     * @type {string}
     * @memberof BasicAuthCredentialsResource
     */
    'password'?: string;
}
/**
 * 
 * @export
 * @interface CompanyFeaturesResource
 */
export interface CompanyFeaturesResource {
    /**
     * 
     * @type {{ [key: string]: { [key: string]: string; }; }}
     * @memberof CompanyFeaturesResource
     */
    'featuresByPlan'?: { [key: string]: { [key: string]: string; }; };
    /**
     * 
     * @type {string}
     * @memberof CompanyFeaturesResource
     */
    'companyPlan'?: CompanyFeaturesResourceCompanyPlanEnum;
}

export const CompanyFeaturesResourceFeaturesByPlanEnum = {
    No: 'NO',
    Yes: 'YES',
    Optional: 'OPTIONAL',
    Community: 'COMMUNITY',
    OnDemand: 'ON_DEMAND',
    Email: 'EMAIL',
    CustomerSuccessManagement: 'CUSTOMER_SUCCESS_MANAGEMENT'
} as const;

export type CompanyFeaturesResourceFeaturesByPlanEnum = typeof CompanyFeaturesResourceFeaturesByPlanEnum[keyof typeof CompanyFeaturesResourceFeaturesByPlanEnum];
export const CompanyFeaturesResourceCompanyPlanEnum = {
    Trial: 'TRIAL',
    Pro: 'PRO',
    Enterprise: 'ENTERPRISE'
} as const;

export type CompanyFeaturesResourceCompanyPlanEnum = typeof CompanyFeaturesResourceCompanyPlanEnum[keyof typeof CompanyFeaturesResourceCompanyPlanEnum];

/**
 * 
 * @export
 * @interface CompanyResource
 */
export interface CompanyResource {
    /**
     * 
     * @type {number}
     * @memberof CompanyResource
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyResource
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof CompanyResource
     */
    'phone'?: number;
    /**
     * 
     * @type {SubscriptionResource}
     * @memberof CompanyResource
     */
    'subscription'?: SubscriptionResource;
    /**
     * 
     * @type {CompanyFeaturesResource}
     * @memberof CompanyResource
     */
    'companyFeatures'?: CompanyFeaturesResource;
    /**
     * 
     * @type {Array<TagResource>}
     * @memberof CompanyResource
     */
    'tags'?: Array<TagResource>;
}
/**
 * 
 * @export
 * @interface ConsensusResource
 */
export interface ConsensusResource {
    /**
     * 
     * @type {string}
     * @memberof ConsensusResource
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConsensusResource
     */
    'type'?: ConsensusResourceTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ConsensusResource
     */
    'responseRatio'?: number;
    /**
     * 
     * @type {number}
     * @memberof ConsensusResource
     */
    'pending'?: number;
    /**
     * 
     * @type {number}
     * @memberof ConsensusResource
     */
    'answers'?: number;
    /**
     * 
     * @type {Array<PairStringLong>}
     * @memberof ConsensusResource
     */
    'result'?: Array<PairStringLong>;
}

export const ConsensusResourceTypeEnum = {
    Info: 'INFO',
    Warning: 'WARNING',
    Alert: 'ALERT'
} as const;

export type ConsensusResourceTypeEnum = typeof ConsensusResourceTypeEnum[keyof typeof ConsensusResourceTypeEnum];

/**
 * 
 * @export
 * @interface DockerServicePropertyResource
 */
export interface DockerServicePropertyResource {
    /**
     * 
     * @type {number}
     * @memberof DockerServicePropertyResource
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DockerServicePropertyResource
     */
    'image'?: string;
    /**
     * 
     * @type {string}
     * @memberof DockerServicePropertyResource
     */
    'version'?: string;
    /**
     * 
     * @type {string}
     * @memberof DockerServicePropertyResource
     */
    'pullImageSecret'?: string;
    /**
     * 
     * @type {string}
     * @memberof DockerServicePropertyResource
     */
    'command'?: string;
    /**
     * 
     * @type {string}
     * @memberof DockerServicePropertyResource
     */
    'args'?: string;
}
/**
 * 
 * @export
 * @interface EnvironmentResource
 */
export interface EnvironmentResource {
    /**
     * 
     * @type {number}
     * @memberof EnvironmentResource
     */
    'id'?: number;
    /**
     * 
     * @type {EnvironmentResource}
     * @memberof EnvironmentResource
     */
    'precedentEnvironment'?: EnvironmentResource;
    /**
     * 
     * @type {boolean}
     * @memberof EnvironmentResource
     */
    'canDelete'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EnvironmentResource
     */
    'name'?: string;
    /**
     * 
     * @type {Array<ReleaseResource>}
     * @memberof EnvironmentResource
     */
    'releases'?: Array<ReleaseResource>;
    /**
     * 
     * @type {string}
     * @memberof EnvironmentResource
     */
    'domain'?: string;
    /**
     * 
     * @type {Array<TagResource>}
     * @memberof EnvironmentResource
     */
    'tags'?: Array<TagResource>;
    /**
     * 
     * @type {string}
     * @memberof EnvironmentResource
     */
    'namespace'?: string;
    /**
     * 
     * @type {string}
     * @memberof EnvironmentResource
     */
    'projectName'?: string;
    /**
     * 
     * @type {ProviderResource}
     * @memberof EnvironmentResource
     */
    'provider'?: ProviderResource;
}
/**
 * 
 * @export
 * @interface EnvironmentVariableResource
 */
export interface EnvironmentVariableResource {
    /**
     * 
     * @type {number}
     * @memberof EnvironmentVariableResource
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof EnvironmentVariableResource
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof EnvironmentVariableResource
     */
    'value'?: string;
    /**
     * 
     * @type {SecretResource}
     * @memberof EnvironmentVariableResource
     */
    'secret'?: SecretResource;
    /**
     * 
     * @type {ParameterResource}
     * @memberof EnvironmentVariableResource
     */
    'parameter'?: ParameterResource;
}
/**
 * 
 * @export
 * @interface GrafanaDataSourceServicePropertyResource
 */
export interface GrafanaDataSourceServicePropertyResource {
    /**
     * 
     * @type {number}
     * @memberof GrafanaDataSourceServicePropertyResource
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof GrafanaDataSourceServicePropertyResource
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GrafanaDataSourceServicePropertyResource
     */
    'source'?: string;
    /**
     * 
     * @type {string}
     * @memberof GrafanaDataSourceServicePropertyResource
     */
    'access'?: string;
}
/**
 * 
 * @export
 * @interface IdentityResource
 */
export interface IdentityResource {
    /**
     * 
     * @type {number}
     * @memberof IdentityResource
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof IdentityResource
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityResource
     */
    'enabled'?: boolean;
    /**
     * 
     * @type {Array<RoleResource>}
     * @memberof IdentityResource
     */
    'roles'?: Array<RoleResource>;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityResource
     */
    'superUser'?: boolean;
}
/**
 * 
 * @export
 * @interface InviteResource
 */
export interface InviteResource {
    /**
     * 
     * @type {number}
     * @memberof InviteResource
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof InviteResource
     */
    'email'?: string;
}
/**
 * 
 * @export
 * @interface K8sServicePropertyEnvironmentResource
 */
export interface K8sServicePropertyEnvironmentResource {
    /**
     * 
     * @type {number}
     * @memberof K8sServicePropertyEnvironmentResource
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof K8sServicePropertyEnvironmentResource
     */
    'propertyId'?: number;
    /**
     * 
     * @type {number}
     * @memberof K8sServicePropertyEnvironmentResource
     */
    'environmentId'?: number;
    /**
     * 
     * @type {number}
     * @memberof K8sServicePropertyEnvironmentResource
     */
    'replicaCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof K8sServicePropertyEnvironmentResource
     */
    'cpuLimit'?: number;
    /**
     * 
     * @type {number}
     * @memberof K8sServicePropertyEnvironmentResource
     */
    'memoryLimit'?: number;
    /**
     * 
     * @type {number}
     * @memberof K8sServicePropertyEnvironmentResource
     */
    'cpuRequest'?: number;
    /**
     * 
     * @type {number}
     * @memberof K8sServicePropertyEnvironmentResource
     */
    'memoryRequest'?: number;
}
/**
 * 
 * @export
 * @interface K8sServicePropertyResource
 */
export interface K8sServicePropertyResource {
    /**
     * 
     * @type {number}
     * @memberof K8sServicePropertyResource
     */
    'id'?: number;
    /**
     * 
     * @type {Set<K8sServicePropertyEnvironmentResource>}
     * @memberof K8sServicePropertyResource
     */
    'values'?: Set<K8sServicePropertyEnvironmentResource>;
    /**
     * 
     * @type {Set<EnvironmentResource>}
     * @memberof K8sServicePropertyResource
     */
    'environments'?: Set<EnvironmentResource>;
}
/**
 * 
 * @export
 * @interface KeyEnriched
 */
export interface KeyEnriched {
    /**
     * 
     * @type {string}
     * @memberof KeyEnriched
     */
    'keyName'?: string;
    /**
     * 
     * @type {string}
     * @memberof KeyEnriched
     */
    'alias'?: string;
    /**
     * 
     * @type {{ [key: string]: Set<string>; }}
     * @memberof KeyEnriched
     */
    'valuesByEnvironment'?: { [key: string]: Set<string>; };
}
/**
 * 
 * @export
 * @interface LivenessProbeServicePropertyResource
 */
export interface LivenessProbeServicePropertyResource {
    /**
     * 
     * @type {number}
     * @memberof LivenessProbeServicePropertyResource
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof LivenessProbeServicePropertyResource
     */
    'livenessType'?: LivenessProbeServicePropertyResourceLivenessTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof LivenessProbeServicePropertyResource
     */
    'livenessInitialDelaySeconds'?: number;
    /**
     * 
     * @type {number}
     * @memberof LivenessProbeServicePropertyResource
     */
    'livenessPeriodSeconds'?: number;
    /**
     * 
     * @type {number}
     * @memberof LivenessProbeServicePropertyResource
     */
    'livenessTimeoutSeconds'?: number;
    /**
     * 
     * @type {number}
     * @memberof LivenessProbeServicePropertyResource
     */
    'livenessSuccessThreshold'?: number;
    /**
     * 
     * @type {number}
     * @memberof LivenessProbeServicePropertyResource
     */
    'livenessFailureThreshold'?: number;
    /**
     * 
     * @type {string}
     * @memberof LivenessProbeServicePropertyResource
     */
    'livenessPath'?: string;
    /**
     * 
     * @type {number}
     * @memberof LivenessProbeServicePropertyResource
     */
    'livenessPort'?: number;
    /**
     * 
     * @type {string}
     * @memberof LivenessProbeServicePropertyResource
     */
    'livenessScheme'?: LivenessProbeServicePropertyResourceLivenessSchemeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof LivenessProbeServicePropertyResource
     */
    'livenessCommand'?: Array<string>;
}

export const LivenessProbeServicePropertyResourceLivenessTypeEnum = {
    Http: 'http',
    Tcp: 'tcp',
    Exec: 'exec'
} as const;

export type LivenessProbeServicePropertyResourceLivenessTypeEnum = typeof LivenessProbeServicePropertyResourceLivenessTypeEnum[keyof typeof LivenessProbeServicePropertyResourceLivenessTypeEnum];
export const LivenessProbeServicePropertyResourceLivenessSchemeEnum = {
    Http: 'http',
    Https: 'https'
} as const;

export type LivenessProbeServicePropertyResourceLivenessSchemeEnum = typeof LivenessProbeServicePropertyResourceLivenessSchemeEnum[keyof typeof LivenessProbeServicePropertyResourceLivenessSchemeEnum];

/**
 * 
 * @export
 * @interface MessageResource
 */
export interface MessageResource {
    /**
     * 
     * @type {number}
     * @memberof MessageResource
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof MessageResource
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof MessageResource
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof MessageResource
     */
    'MESSAGE_TYPE'?: MessageResourceMESSAGETYPEEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof MessageResource
     */
    'options'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof MessageResource
     */
    'type'?: MessageResourceTypeEnum;
}

export const MessageResourceMESSAGETYPEEnum = {
    Info: 'INFO',
    Warning: 'WARNING',
    Alert: 'ALERT'
} as const;

export type MessageResourceMESSAGETYPEEnum = typeof MessageResourceMESSAGETYPEEnum[keyof typeof MessageResourceMESSAGETYPEEnum];
export const MessageResourceTypeEnum = {
    Info: 'INFO',
    Warning: 'WARNING',
    Alert: 'ALERT'
} as const;

export type MessageResourceTypeEnum = typeof MessageResourceTypeEnum[keyof typeof MessageResourceTypeEnum];

/**
 * 
 * @export
 * @interface MountResource
 */
export interface MountResource {
    /**
     * 
     * @type {number}
     * @memberof MountResource
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof MountResource
     */
    'pathExpression'?: string;
    /**
     * 
     * @type {string}
     * @memberof MountResource
     */
    'mount'?: string;
}
/**
 * 
 * @export
 * @interface PageIdentityResource
 */
export interface PageIdentityResource {
    /**
     * 
     * @type {number}
     * @memberof PageIdentityResource
     */
    'totalElements'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageIdentityResource
     */
    'totalPages'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PageIdentityResource
     */
    'first'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageIdentityResource
     */
    'last'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PageIdentityResource
     */
    'size'?: number;
    /**
     * 
     * @type {Array<IdentityResource>}
     * @memberof PageIdentityResource
     */
    'content'?: Array<IdentityResource>;
    /**
     * 
     * @type {number}
     * @memberof PageIdentityResource
     */
    'number'?: number;
    /**
     * 
     * @type {SortObject}
     * @memberof PageIdentityResource
     */
    'sort'?: SortObject;
    /**
     * 
     * @type {number}
     * @memberof PageIdentityResource
     */
    'numberOfElements'?: number;
    /**
     * 
     * @type {PageableObject}
     * @memberof PageIdentityResource
     */
    'pageable'?: PageableObject;
    /**
     * 
     * @type {boolean}
     * @memberof PageIdentityResource
     */
    'empty'?: boolean;
}
/**
 * 
 * @export
 * @interface PageableObject
 */
export interface PageableObject {
    /**
     * 
     * @type {number}
     * @memberof PageableObject
     */
    'offset'?: number;
    /**
     * 
     * @type {SortObject}
     * @memberof PageableObject
     */
    'sort'?: SortObject;
    /**
     * 
     * @type {boolean}
     * @memberof PageableObject
     */
    'unpaged'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageableObject
     */
    'paged'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PageableObject
     */
    'pageNumber'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageableObject
     */
    'pageSize'?: number;
}
/**
 * 
 * @export
 * @interface PairObjectLong
 */
export interface PairObjectLong {
    /**
     * 
     * @type {number}
     * @memberof PairObjectLong
     */
    'size'?: number;
    /**
     * 
     * @type {any}
     * @memberof PairObjectLong
     */
    'value0'?: any;
    /**
     * 
     * @type {number}
     * @memberof PairObjectLong
     */
    'value1'?: number;
    /**
     * 
     * @type {any}
     * @memberof PairObjectLong
     */
    'at0'?: any;
    /**
     * 
     * @type {PairObjectObject}
     * @memberof PairObjectLong
     */
    'at1'?: PairObjectObject;
}
/**
 * 
 * @export
 * @interface PairObjectObject
 */
export interface PairObjectObject {
    /**
     * 
     * @type {number}
     * @memberof PairObjectObject
     */
    'size'?: number;
    /**
     * 
     * @type {any}
     * @memberof PairObjectObject
     */
    'value0'?: any;
    /**
     * 
     * @type {any}
     * @memberof PairObjectObject
     */
    'value1'?: any;
    /**
     * 
     * @type {any}
     * @memberof PairObjectObject
     */
    'at0'?: any;
    /**
     * 
     * @type {any}
     * @memberof PairObjectObject
     */
    'at1'?: any;
}
/**
 * 
 * @export
 * @interface PairStringLong
 */
export interface PairStringLong {
    /**
     * 
     * @type {number}
     * @memberof PairStringLong
     */
    'size'?: number;
    /**
     * 
     * @type {string}
     * @memberof PairStringLong
     */
    'value0'?: string;
    /**
     * 
     * @type {number}
     * @memberof PairStringLong
     */
    'value1'?: number;
    /**
     * 
     * @type {PairObjectLong}
     * @memberof PairStringLong
     */
    'at0'?: PairObjectLong;
    /**
     * 
     * @type {PairStringObject}
     * @memberof PairStringLong
     */
    'at1'?: PairStringObject;
}
/**
 * 
 * @export
 * @interface PairStringObject
 */
export interface PairStringObject {
    /**
     * 
     * @type {number}
     * @memberof PairStringObject
     */
    'size'?: number;
    /**
     * 
     * @type {string}
     * @memberof PairStringObject
     */
    'value0'?: string;
    /**
     * 
     * @type {any}
     * @memberof PairStringObject
     */
    'value1'?: any;
    /**
     * 
     * @type {PairObjectObject}
     * @memberof PairStringObject
     */
    'at0'?: PairObjectObject;
    /**
     * 
     * @type {any}
     * @memberof PairStringObject
     */
    'at1'?: any;
}
/**
 * 
 * @export
 * @interface ParameterEnvironmentValueResource
 */
export interface ParameterEnvironmentValueResource {
    /**
     * 
     * @type {number}
     * @memberof ParameterEnvironmentValueResource
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof ParameterEnvironmentValueResource
     */
    'parameterId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ParameterEnvironmentValueResource
     */
    'environmentId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ParameterEnvironmentValueResource
     */
    'value'?: string;
}
/**
 * 
 * @export
 * @interface ParameterResource
 */
export interface ParameterResource {
    /**
     * 
     * @type {number}
     * @memberof ParameterResource
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ParameterResource
     */
    'key'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ParameterResource
     */
    'canDelete'?: boolean;
}
/**
 * 
 * @export
 * @interface PathServicePropertyResource
 */
export interface PathServicePropertyResource {
    /**
     * 
     * @type {number}
     * @memberof PathServicePropertyResource
     */
    'id'?: number;
    /**
     * 
     * @type {PortMappingServicePropertyResource}
     * @memberof PathServicePropertyResource
     */
    'portMappingServicePropertyResource'?: PortMappingServicePropertyResource;
    /**
     * 
     * @type {string}
     * @memberof PathServicePropertyResource
     */
    'host'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PathServicePropertyResource
     */
    'redirectWWW'?: boolean;
    /**
     * 
     * @type {BasicAuthCredentialsResource}
     * @memberof PathServicePropertyResource
     */
    'basicAuthCredentials'?: BasicAuthCredentialsResource;
    /**
     * 
     * @type {string}
     * @memberof PathServicePropertyResource
     */
    'path'?: string;
}
/**
 * 
 * @export
 * @interface PortMappingServicePropertyResource
 */
export interface PortMappingServicePropertyResource {
    /**
     * 
     * @type {number}
     * @memberof PortMappingServicePropertyResource
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof PortMappingServicePropertyResource
     */
    'port'?: number;
    /**
     * 
     * @type {number}
     * @memberof PortMappingServicePropertyResource
     */
    'containerPort'?: number;
    /**
     * 
     * @type {string}
     * @memberof PortMappingServicePropertyResource
     */
    'flowType'?: PortMappingServicePropertyResourceFlowTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PortMappingServicePropertyResource
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PortMappingServicePropertyResource
     */
    'canDelete'?: boolean;
}

export const PortMappingServicePropertyResourceFlowTypeEnum = {
    Http: 'http',
    Https: 'https',
    Tcp: 'tcp',
    Passthrough: 'passthrough',
    Udp: 'udp'
} as const;

export type PortMappingServicePropertyResourceFlowTypeEnum = typeof PortMappingServicePropertyResourceFlowTypeEnum[keyof typeof PortMappingServicePropertyResourceFlowTypeEnum];

/**
 * 
 * @export
 * @interface PrivilegeResource
 */
export interface PrivilegeResource {
    /**
     * 
     * @type {number}
     * @memberof PrivilegeResource
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PrivilegeResource
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface ProjectIconResource
 */
export interface ProjectIconResource {
    /**
     * 
     * @type {number}
     * @memberof ProjectIconResource
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProjectIconResource
     */
    'path'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectIconResource
     */
    'type'?: string;
}
/**
 * 
 * @export
 * @interface ProjectOptionsResource
 */
export interface ProjectOptionsResource {
    /**
     * 
     * @type {boolean}
     * @memberof ProjectOptionsResource
     */
    'isDownloadEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectOptionsResource
     */
    'isDeployEnabled'?: boolean;
}
/**
 * 
 * @export
 * @interface ProjectResource
 */
export interface ProjectResource {
    /**
     * 
     * @type {number}
     * @memberof ProjectResource
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProjectResource
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectResource
     */
    'shortName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectResource
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProjectResource
     */
    'versionMajor'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProjectResource
     */
    'versionMinor'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProjectResource
     */
    'versionPatch'?: number;
    /**
     * 
     * @type {IdentityResource}
     * @memberof ProjectResource
     */
    'owner'?: IdentityResource;
    /**
     * 
     * @type {string}
     * @memberof ProjectResource
     */
    'adminUrl'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProjectResource
     */
    'recipes'?: Array<string>;
}
/**
 * 
 * @export
 * @interface ProjectThemeResource
 */
export interface ProjectThemeResource {
    /**
     * 
     * @type {string}
     * @memberof ProjectThemeResource
     */
    'themeColor'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectThemeResource
     */
    'themeBackgroundColor'?: string;
    /**
     * 
     * @type {ProjectIconResource}
     * @memberof ProjectThemeResource
     */
    'favIcon'?: ProjectIconResource;
    /**
     * 
     * @type {ProjectIconResource}
     * @memberof ProjectThemeResource
     */
    'appleTouchIcon'?: ProjectIconResource;
    /**
     * 
     * @type {ProjectIconResource}
     * @memberof ProjectThemeResource
     */
    'logo'?: ProjectIconResource;
    /**
     * 
     * @type {ProjectIconResource}
     * @memberof ProjectThemeResource
     */
    'icon'?: ProjectIconResource;
    /**
     * 
     * @type {ProjectIconResource}
     * @memberof ProjectThemeResource
     */
    'icon512'?: ProjectIconResource;
    /**
     * 
     * @type {ProjectIconResource}
     * @memberof ProjectThemeResource
     */
    'icon192'?: ProjectIconResource;
    /**
     * 
     * @type {ProjectIconResource}
     * @memberof ProjectThemeResource
     */
    'maskableIcon'?: ProjectIconResource;
    /**
     * 
     * @type {string}
     * @memberof ProjectThemeResource
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectThemeResource
     */
    'shortName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectThemeResource
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface PrometheusServicePropertyResource
 */
export interface PrometheusServicePropertyResource {
    /**
     * 
     * @type {number}
     * @memberof PrometheusServicePropertyResource
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PrometheusServicePropertyResource
     */
    'path'?: string;
}
/**
 * 
 * @export
 * @interface ProviderResource
 */
export interface ProviderResource {
    /**
     * 
     * @type {number}
     * @memberof ProviderResource
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProviderResource
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderResource
     */
    'isPublic'?: boolean;
}
/**
 * 
 * @export
 * @interface ReadinessProbeServicePropertyResource
 */
export interface ReadinessProbeServicePropertyResource {
    /**
     * 
     * @type {number}
     * @memberof ReadinessProbeServicePropertyResource
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReadinessProbeServicePropertyResource
     */
    'readinessType'?: ReadinessProbeServicePropertyResourceReadinessTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ReadinessProbeServicePropertyResource
     */
    'readinessInitialDelaySeconds'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReadinessProbeServicePropertyResource
     */
    'readinessPeriodSeconds'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReadinessProbeServicePropertyResource
     */
    'readinessTimeoutSeconds'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReadinessProbeServicePropertyResource
     */
    'readinessSuccessThreshold'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReadinessProbeServicePropertyResource
     */
    'readinessFailureThreshold'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReadinessProbeServicePropertyResource
     */
    'readinessPath'?: string;
    /**
     * 
     * @type {number}
     * @memberof ReadinessProbeServicePropertyResource
     */
    'readinessPort'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReadinessProbeServicePropertyResource
     */
    'readinessScheme'?: ReadinessProbeServicePropertyResourceReadinessSchemeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReadinessProbeServicePropertyResource
     */
    'readinessCommand'?: Array<string>;
}

export const ReadinessProbeServicePropertyResourceReadinessTypeEnum = {
    Http: 'http',
    Tcp: 'tcp',
    Exec: 'exec'
} as const;

export type ReadinessProbeServicePropertyResourceReadinessTypeEnum = typeof ReadinessProbeServicePropertyResourceReadinessTypeEnum[keyof typeof ReadinessProbeServicePropertyResourceReadinessTypeEnum];
export const ReadinessProbeServicePropertyResourceReadinessSchemeEnum = {
    Http: 'http',
    Https: 'https'
} as const;

export type ReadinessProbeServicePropertyResourceReadinessSchemeEnum = typeof ReadinessProbeServicePropertyResourceReadinessSchemeEnum[keyof typeof ReadinessProbeServicePropertyResourceReadinessSchemeEnum];

/**
 * 
 * @export
 * @interface ReleaseResource
 */
export interface ReleaseResource {
    /**
     * 
     * @type {number}
     * @memberof ReleaseResource
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReleaseResource
     */
    'tag'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReleaseResource
     */
    'logs'?: string;
}
/**
 * 
 * @export
 * @interface RoleResource
 */
export interface RoleResource {
    /**
     * 
     * @type {number}
     * @memberof RoleResource
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof RoleResource
     */
    'name'?: string;
    /**
     * 
     * @type {Array<PrivilegeResource>}
     * @memberof RoleResource
     */
    'privileges'?: Array<PrivilegeResource>;
    /**
     * 
     * @type {boolean}
     * @memberof RoleResource
     */
    'public'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RoleResource
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface SecretResource
 */
export interface SecretResource {
    /**
     * 
     * @type {number}
     * @memberof SecretResource
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof SecretResource
     */
    'key'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SecretResource
     */
    'canDelete'?: boolean;
}
/**
 * 
 * @export
 * @interface SecurityServicePropertyResource
 */
export interface SecurityServicePropertyResource {
    /**
     * 
     * @type {number}
     * @memberof SecurityServicePropertyResource
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof SecurityServicePropertyResource
     */
    'runAsUser'?: string;
    /**
     * 
     * @type {string}
     * @memberof SecurityServicePropertyResource
     */
    'runAsGroup'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SecurityServicePropertyResource
     */
    'runAsNonRoot'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SecurityServicePropertyResource
     */
    'privileged'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SecurityServicePropertyResource
     */
    'allowPrivilegeEscalation'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SecurityServicePropertyResource
     */
    'readOnlyRootFilesystem'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SecurityServicePropertyResource
     */
    'procMount'?: SecurityServicePropertyResourceProcMountEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof SecurityServicePropertyResource
     */
    'addCapabilities'?: Array<SecurityServicePropertyResourceAddCapabilitiesEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SecurityServicePropertyResource
     */
    'dropCapabilities'?: Array<SecurityServicePropertyResourceDropCapabilitiesEnum>;
    /**
     * 
     * @type {string}
     * @memberof SecurityServicePropertyResource
     */
    'seLinuxLevel'?: string;
    /**
     * 
     * @type {string}
     * @memberof SecurityServicePropertyResource
     */
    'seLinuxRole'?: string;
    /**
     * 
     * @type {string}
     * @memberof SecurityServicePropertyResource
     */
    'seLinuxType'?: string;
    /**
     * 
     * @type {string}
     * @memberof SecurityServicePropertyResource
     */
    'seLinuxUser'?: string;
    /**
     * 
     * @type {string}
     * @memberof SecurityServicePropertyResource
     */
    'seccompProfileType'?: SecurityServicePropertyResourceSeccompProfileTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SecurityServicePropertyResource
     */
    'seccompLocalhostProfile'?: string;
}

export const SecurityServicePropertyResourceProcMountEnum = {
    Default: 'Default',
    Unmasked: 'Unmasked'
} as const;

export type SecurityServicePropertyResourceProcMountEnum = typeof SecurityServicePropertyResourceProcMountEnum[keyof typeof SecurityServicePropertyResourceProcMountEnum];
export const SecurityServicePropertyResourceAddCapabilitiesEnum = {
    All: 'ALL',
    NetBindService: 'NET_BIND_SERVICE',
    IpcLock: 'IPC_LOCK',
    SysTime: 'SYS_TIME',
    SysAdmin: 'SYS_ADMIN',
    AuditWrite: 'AUDIT_WRITE',
    Chown: 'CHOWN',
    DacOverride: 'DAC_OVERRIDE',
    Fowner: 'FOWNER',
    Fsetid: 'FSETID',
    Kill: 'KILL',
    Mknod: 'MKNOD',
    NetRaw: 'NET_RAW',
    Setfcap: 'SETFCAP',
    Setgid: 'SETGID',
    Setuid: 'SETUID',
    Setpcap: 'SETPCAP',
    SysChroot: 'SYS_CHROOT',
    SysPtrace: 'SYS_PTRACE',
    SysModule: 'SYS_MODULE',
    SysNice: 'SYS_NICE',
    SysResource: 'SYS_RESOURCE',
    SysTtyConfig: 'SYS_TTY_CONFIG'
} as const;

export type SecurityServicePropertyResourceAddCapabilitiesEnum = typeof SecurityServicePropertyResourceAddCapabilitiesEnum[keyof typeof SecurityServicePropertyResourceAddCapabilitiesEnum];
export const SecurityServicePropertyResourceDropCapabilitiesEnum = {
    All: 'ALL',
    NetBindService: 'NET_BIND_SERVICE',
    IpcLock: 'IPC_LOCK',
    SysTime: 'SYS_TIME',
    SysAdmin: 'SYS_ADMIN',
    AuditWrite: 'AUDIT_WRITE',
    Chown: 'CHOWN',
    DacOverride: 'DAC_OVERRIDE',
    Fowner: 'FOWNER',
    Fsetid: 'FSETID',
    Kill: 'KILL',
    Mknod: 'MKNOD',
    NetRaw: 'NET_RAW',
    Setfcap: 'SETFCAP',
    Setgid: 'SETGID',
    Setuid: 'SETUID',
    Setpcap: 'SETPCAP',
    SysChroot: 'SYS_CHROOT',
    SysPtrace: 'SYS_PTRACE',
    SysModule: 'SYS_MODULE',
    SysNice: 'SYS_NICE',
    SysResource: 'SYS_RESOURCE',
    SysTtyConfig: 'SYS_TTY_CONFIG'
} as const;

export type SecurityServicePropertyResourceDropCapabilitiesEnum = typeof SecurityServicePropertyResourceDropCapabilitiesEnum[keyof typeof SecurityServicePropertyResourceDropCapabilitiesEnum];
export const SecurityServicePropertyResourceSeccompProfileTypeEnum = {
    RuntimeDefault: 'RuntimeDefault',
    Localhost: 'Localhost',
    Unconfined: 'Unconfined'
} as const;

export type SecurityServicePropertyResourceSeccompProfileTypeEnum = typeof SecurityServicePropertyResourceSeccompProfileTypeEnum[keyof typeof SecurityServicePropertyResourceSeccompProfileTypeEnum];

/**
 * 
 * @export
 * @interface ServiceParametersMatrixResource
 */
export interface ServiceParametersMatrixResource {
    /**
     * 
     * @type {Set<ParameterResource>}
     * @memberof ServiceParametersMatrixResource
     */
    'parameters'?: Set<ParameterResource>;
    /**
     * 
     * @type {Set<EnvironmentResource>}
     * @memberof ServiceParametersMatrixResource
     */
    'environments'?: Set<EnvironmentResource>;
    /**
     * 
     * @type {Array<ParameterEnvironmentValueResource>}
     * @memberof ServiceParametersMatrixResource
     */
    'values'?: Array<ParameterEnvironmentValueResource>;
}
/**
 * 
 * @export
 * @interface ServicePropertyResource
 */
export interface ServicePropertyResource {
    /**
     * 
     * @type {number}
     * @memberof ServicePropertyResource
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServicePropertyResource
     */
    'type'?: string;
}
/**
 * 
 * @export
 * @interface ServicePropertyTypeResource
 */
export interface ServicePropertyTypeResource {
    /**
     * 
     * @type {string}
     * @memberof ServicePropertyTypeResource
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof ServicePropertyTypeResource
     */
    'maxCount'?: number;
}
/**
 * 
 * @export
 * @interface ServiceResource
 */
export interface ServiceResource {
    /**
     * 
     * @type {number}
     * @memberof ServiceResource
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServiceResource
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceResource
     */
    'description'?: string;
    /**
     * 
     * @type {Array<ServiceResource>}
     * @memberof ServiceResource
     */
    'dependencies'?: Array<ServiceResource>;
    /**
     * 
     * @type {Array<ServiceResource>}
     * @memberof ServiceResource
     */
    'otherDependencies'?: Array<ServiceResource>;
    /**
     * 
     * @type {boolean}
     * @memberof ServiceResource
     */
    'canDelete'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ServiceResource
     */
    'type'?: ServiceResourceTypeEnum;
}

export const ServiceResourceTypeEnum = {
    Backend: 'BACKEND',
    Gui: 'GUI'
} as const;

export type ServiceResourceTypeEnum = typeof ServiceResourceTypeEnum[keyof typeof ServiceResourceTypeEnum];

/**
 * 
 * @export
 * @interface SortObject
 */
export interface SortObject {
    /**
     * 
     * @type {boolean}
     * @memberof SortObject
     */
    'empty'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SortObject
     */
    'unsorted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SortObject
     */
    'sorted'?: boolean;
}
/**
 * 
 * @export
 * @interface SubscriptionResource
 */
export interface SubscriptionResource {
    /**
     * 
     * @type {number}
     * @memberof SubscriptionResource
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionResource
     */
    'issueDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionResource
     */
    'endDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionResource
     */
    'type'?: SubscriptionResourceTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionResource
     */
    'subscriptionDisabled'?: boolean;
}

export const SubscriptionResourceTypeEnum = {
    Trial: 'TRIAL',
    Pro: 'PRO',
    Enterprise: 'ENTERPRISE'
} as const;

export type SubscriptionResourceTypeEnum = typeof SubscriptionResourceTypeEnum[keyof typeof SubscriptionResourceTypeEnum];

/**
 * 
 * @export
 * @interface TagResource
 */
export interface TagResource {
    /**
     * 
     * @type {number}
     * @memberof TagResource
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TagResource
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface UploadMaskableIconRequest
 */
export interface UploadMaskableIconRequest {
    /**
     * 
     * @type {File}
     * @memberof UploadMaskableIconRequest
     */
    'file': File;
}
/**
 * 
 * @export
 * @interface UserResource
 */
export interface UserResource {
    /**
     * 
     * @type {number}
     * @memberof UserResource
     */
    'id'?: number;
    /**
     * 
     * @type {IdentityResource}
     * @memberof UserResource
     */
    'identityResource'?: IdentityResource;
    /**
     * 
     * @type {string}
     * @memberof UserResource
     */
    'title'?: UserResourceTitleEnum;
    /**
     * 
     * @type {string}
     * @memberof UserResource
     */
    'state'?: UserResourceStateEnum;
    /**
     * 
     * @type {string}
     * @memberof UserResource
     */
    'firstname'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserResource
     */
    'lastname'?: string;
}

export const UserResourceTitleEnum = {
    SoftwareEngineer: 'SOFTWARE_ENGINEER',
    Freelance: 'FREELANCE',
    Entrepreneur: 'ENTREPRENEUR',
    Architect: 'ARCHITECT',
    ChiefTechnologyOfficer: 'CHIEF_TECHNOLOGY_OFFICER',
    Other: 'OTHER'
} as const;

export type UserResourceTitleEnum = typeof UserResourceTitleEnum[keyof typeof UserResourceTitleEnum];
export const UserResourceStateEnum = {
    Created: 'CREATED',
    Activated: 'ACTIVATED'
} as const;

export type UserResourceStateEnum = typeof UserResourceStateEnum[keyof typeof UserResourceStateEnum];

/**
 * 
 * @export
 * @interface VolumeResource
 */
export interface VolumeResource {
    /**
     * 
     * @type {number}
     * @memberof VolumeResource
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof VolumeResource
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof VolumeResource
     */
    'mount'?: string;
    /**
     * 
     * @type {string}
     * @memberof VolumeResource
     */
    'size'?: string;
}

/**
 * AdminControllerApi - axios parameter creator
 * @export
 */
export const AdminControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} serviceId 
         * @param {string} key 
         * @param {string} [value] 
         * @param {number} [secretId] 
         * @param {number} [parameterId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEnvironmentVariable: async (serviceId: number, key: string, value?: string, secretId?: number, parameterId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('createEnvironmentVariable', 'serviceId', serviceId)
            // verify required parameter 'key' is not null or undefined
            assertParamExists('createEnvironmentVariable', 'key', key)
            const localVarPath = `/admin/service/{serviceId}/env`
                .replace(`{${"serviceId"}}`, encodeURIComponent(String(serviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }

            if (value !== undefined) {
                localVarQueryParameter['value'] = value;
            }

            if (secretId !== undefined) {
                localVarQueryParameter['secret_id'] = secretId;
            }

            if (parameterId !== undefined) {
                localVarQueryParameter['parameter_id'] = parameterId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} propertyId 
         * @param {number} environmentId 
         * @param {number} replicaCount 
         * @param {number} cpuLimit 
         * @param {number} memoryLimit 
         * @param {number} cpuRequest 
         * @param {number} memoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createK8sServicePropertyEnvironment: async (propertyId: number, environmentId: number, replicaCount: number, cpuLimit: number, memoryLimit: number, cpuRequest: number, memoryRequest: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyId' is not null or undefined
            assertParamExists('createK8sServicePropertyEnvironment', 'propertyId', propertyId)
            // verify required parameter 'environmentId' is not null or undefined
            assertParamExists('createK8sServicePropertyEnvironment', 'environmentId', environmentId)
            // verify required parameter 'replicaCount' is not null or undefined
            assertParamExists('createK8sServicePropertyEnvironment', 'replicaCount', replicaCount)
            // verify required parameter 'cpuLimit' is not null or undefined
            assertParamExists('createK8sServicePropertyEnvironment', 'cpuLimit', cpuLimit)
            // verify required parameter 'memoryLimit' is not null or undefined
            assertParamExists('createK8sServicePropertyEnvironment', 'memoryLimit', memoryLimit)
            // verify required parameter 'cpuRequest' is not null or undefined
            assertParamExists('createK8sServicePropertyEnvironment', 'cpuRequest', cpuRequest)
            // verify required parameter 'memoryRequest' is not null or undefined
            assertParamExists('createK8sServicePropertyEnvironment', 'memoryRequest', memoryRequest)
            const localVarPath = `/admin/k8sproperty/{propertyId}/environment/{environmentId}`
                .replace(`{${"propertyId"}}`, encodeURIComponent(String(propertyId)))
                .replace(`{${"environmentId"}}`, encodeURIComponent(String(environmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (replicaCount !== undefined) {
                localVarQueryParameter['replicaCount'] = replicaCount;
            }

            if (cpuLimit !== undefined) {
                localVarQueryParameter['cpuLimit'] = cpuLimit;
            }

            if (memoryLimit !== undefined) {
                localVarQueryParameter['memoryLimit'] = memoryLimit;
            }

            if (cpuRequest !== undefined) {
                localVarQueryParameter['cpuRequest'] = cpuRequest;
            }

            if (memoryRequest !== undefined) {
                localVarQueryParameter['memoryRequest'] = memoryRequest;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {string} pathExpression 
         * @param {string} mount 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMount: async (serviceId: number, pathExpression: string, mount: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('createMount', 'serviceId', serviceId)
            // verify required parameter 'pathExpression' is not null or undefined
            assertParamExists('createMount', 'pathExpression', pathExpression)
            // verify required parameter 'mount' is not null or undefined
            assertParamExists('createMount', 'mount', mount)
            const localVarPath = `/admin/service/{serviceId}/mount`
                .replace(`{${"serviceId"}}`, encodeURIComponent(String(serviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pathExpression !== undefined) {
                localVarQueryParameter['pathExpression'] = pathExpression;
            }

            if (mount !== undefined) {
                localVarQueryParameter['mount'] = mount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createParameter: async (serviceId: number, key: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('createParameter', 'serviceId', serviceId)
            // verify required parameter 'key' is not null or undefined
            assertParamExists('createParameter', 'key', key)
            const localVarPath = `/admin/service/{serviceId}/parameter`
                .replace(`{${"serviceId"}}`, encodeURIComponent(String(serviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} parameterId 
         * @param {number} environmentId 
         * @param {string} value 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createParameterEnvironmentValue: async (parameterId: number, environmentId: number, value: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'parameterId' is not null or undefined
            assertParamExists('createParameterEnvironmentValue', 'parameterId', parameterId)
            // verify required parameter 'environmentId' is not null or undefined
            assertParamExists('createParameterEnvironmentValue', 'environmentId', environmentId)
            // verify required parameter 'value' is not null or undefined
            assertParamExists('createParameterEnvironmentValue', 'value', value)
            const localVarPath = `/admin/parameter/{parameterId}/environment/{environmentId}/value`
                .replace(`{${"parameterId"}}`, encodeURIComponent(String(parameterId)))
                .replace(`{${"environmentId"}}`, encodeURIComponent(String(environmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (value !== undefined) {
                localVarQueryParameter['value'] = value;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} projectId 
         * @param {Array<string>} names 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPrivileges: async (projectId: number, names: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('createPrivileges', 'projectId', projectId)
            // verify required parameter 'names' is not null or undefined
            assertParamExists('createPrivileges', 'names', names)
            const localVarPath = `/admin/project/{projectId}/privileges`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (names) {
                localVarQueryParameter['names'] = names;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {string} name 
         * @param {string} description 
         * @param {string} [adminUrl] 
         * @param {string} [shortname] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProject: async (userId: number, name: string, description: string, adminUrl?: string, shortname?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('createProject', 'userId', userId)
            // verify required parameter 'name' is not null or undefined
            assertParamExists('createProject', 'name', name)
            // verify required parameter 'description' is not null or undefined
            assertParamExists('createProject', 'description', description)
            const localVarPath = `/admin/user/{userId}/project`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (description !== undefined) {
                localVarQueryParameter['description'] = description;
            }

            if (adminUrl !== undefined) {
                localVarQueryParameter['adminUrl'] = adminUrl;
            }

            if (shortname !== undefined) {
                localVarQueryParameter['shortname'] = shortname;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} projectId 
         * @param {string} name 
         * @param {boolean} isPublic 
         * @param {Array<number>} privileges 
         * @param {string} description 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRole: async (projectId: number, name: string, isPublic: boolean, privileges: Array<number>, description: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('createRole', 'projectId', projectId)
            // verify required parameter 'name' is not null or undefined
            assertParamExists('createRole', 'name', name)
            // verify required parameter 'isPublic' is not null or undefined
            assertParamExists('createRole', 'isPublic', isPublic)
            // verify required parameter 'privileges' is not null or undefined
            assertParamExists('createRole', 'privileges', privileges)
            // verify required parameter 'description' is not null or undefined
            assertParamExists('createRole', 'description', description)
            const localVarPath = `/admin/project/{projectId}/role`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (isPublic !== undefined) {
                localVarQueryParameter['isPublic'] = isPublic;
            }

            if (privileges) {
                localVarQueryParameter['privileges'] = privileges;
            }

            if (description !== undefined) {
                localVarQueryParameter['description'] = description;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSecret: async (serviceId: number, key: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('createSecret', 'serviceId', serviceId)
            // verify required parameter 'key' is not null or undefined
            assertParamExists('createSecret', 'key', key)
            const localVarPath = `/admin/service/{serviceId}/secret`
                .replace(`{${"serviceId"}}`, encodeURIComponent(String(serviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} projectId 
         * @param {string} name 
         * @param {string} description 
         * @param {CreateServiceTypeEnum} type 
         * @param {Array<number>} [dependencies] 
         * @param {Array<number>} [otherDependencies] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createService: async (projectId: number, name: string, description: string, type: CreateServiceTypeEnum, dependencies?: Array<number>, otherDependencies?: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('createService', 'projectId', projectId)
            // verify required parameter 'name' is not null or undefined
            assertParamExists('createService', 'name', name)
            // verify required parameter 'description' is not null or undefined
            assertParamExists('createService', 'description', description)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('createService', 'type', type)
            const localVarPath = `/admin/project/{projectId}/service`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (description !== undefined) {
                localVarQueryParameter['description'] = description;
            }

            if (dependencies) {
                localVarQueryParameter['dependencies'] = dependencies;
            }

            if (otherDependencies) {
                localVarQueryParameter['otherDependencies'] = otherDependencies;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} companyId 
         * @param {Array<string>} names 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTags: async (companyId: number, names: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('createTags', 'companyId', companyId)
            // verify required parameter 'names' is not null or undefined
            assertParamExists('createTags', 'names', names)
            const localVarPath = `/admin/company/{companyId}/tags`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (names) {
                localVarQueryParameter['names'] = names;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {string} name 
         * @param {string} size 
         * @param {string} mount 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVolume: async (serviceId: number, name: string, size: string, mount: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('createVolume', 'serviceId', serviceId)
            // verify required parameter 'name' is not null or undefined
            assertParamExists('createVolume', 'name', name)
            // verify required parameter 'size' is not null or undefined
            assertParamExists('createVolume', 'size', size)
            // verify required parameter 'mount' is not null or undefined
            assertParamExists('createVolume', 'mount', mount)
            const localVarPath = `/admin/service/{serviceId}/volume`
                .replace(`{${"serviceId"}}`, encodeURIComponent(String(serviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (mount !== undefined) {
                localVarQueryParameter['mount'] = mount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEnvironment: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteEnvironment', 'id', id)
            const localVarPath = `/admin/environment/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} environmentVariableId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEnvironmentVariable: async (environmentVariableId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'environmentVariableId' is not null or undefined
            assertParamExists('deleteEnvironmentVariable', 'environmentVariableId', environmentVariableId)
            const localVarPath = `/admin/environmentVariable/{environmentVariableId}`
                .replace(`{${"environmentVariableId"}}`, encodeURIComponent(String(environmentVariableId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} mountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMount: async (mountId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mountId' is not null or undefined
            assertParamExists('deleteMount', 'mountId', mountId)
            const localVarPath = `/admin/mount/{mountId}`
                .replace(`{${"mountId"}}`, encodeURIComponent(String(mountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} parameterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteParameter: async (parameterId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'parameterId' is not null or undefined
            assertParamExists('deleteParameter', 'parameterId', parameterId)
            const localVarPath = `/admin/parameter/{parameterId}`
                .replace(`{${"parameterId"}}`, encodeURIComponent(String(parameterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProperty: async (propertyId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyId' is not null or undefined
            assertParamExists('deleteProperty', 'propertyId', propertyId)
            const localVarPath = `/admin/property/{propertyId}`
                .replace(`{${"propertyId"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} secretId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSecret: async (secretId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'secretId' is not null or undefined
            assertParamExists('deleteSecret', 'secretId', secretId)
            const localVarPath = `/admin/secret/{secretId}`
                .replace(`{${"secretId"}}`, encodeURIComponent(String(secretId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteService: async (serviceId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('deleteService', 'serviceId', serviceId)
            const localVarPath = `/admin/service/{serviceId}`
                .replace(`{${"serviceId"}}`, encodeURIComponent(String(serviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} volumeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVolume: async (volumeId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'volumeId' is not null or undefined
            assertParamExists('deleteVolume', 'volumeId', volumeId)
            const localVarPath = `/admin/volume/{volumeId}`
                .replace(`{${"volumeId"}}`, encodeURIComponent(String(volumeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyAdmins: async (companyId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('getCompanyAdmins', 'companyId', companyId)
            const localVarPath = `/admin/company/{companyId}/admins`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyInvites: async (companyId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('getCompanyInvites', 'companyId', companyId)
            const localVarPath = `/admin/company/{companyId}/invites`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyMembers: async (companyId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('getCompanyMembers', 'companyId', companyId)
            const localVarPath = `/admin/company/{companyId}/members`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyProjects: async (companyId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('getCompanyProjects', 'companyId', companyId)
            const localVarPath = `/admin/company/{companyId}/projects`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyRecipes: async (companyId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('getCompanyRecipes', 'companyId', companyId)
            const localVarPath = `/admin/company/{companyId}/recipes`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDockerServiceProperty: async (propertyId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyId' is not null or undefined
            assertParamExists('getDockerServiceProperty', 'propertyId', propertyId)
            const localVarPath = `/admin/dockerproperty/{propertyId}`
                .replace(`{${"propertyId"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnvironments: async (projectId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getEnvironments', 'projectId', projectId)
            const localVarPath = `/admin/project/{projectId}/environments`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGrafanaDataSourceServiceProperty: async (propertyId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyId' is not null or undefined
            assertParamExists('getGrafanaDataSourceServiceProperty', 'propertyId', propertyId)
            const localVarPath = `/admin/grafanadatasourceproperty/{propertyId}`
                .replace(`{${"propertyId"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getK8sServiceProperty: async (propertyId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyId' is not null or undefined
            assertParamExists('getK8sServiceProperty', 'propertyId', propertyId)
            const localVarPath = `/admin/k8sproperty/{propertyId}`
                .replace(`{${"propertyId"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLivenessProbeServiceProperty: async (propertyId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyId' is not null or undefined
            assertParamExists('getLivenessProbeServiceProperty', 'propertyId', propertyId)
            const localVarPath = `/admin/livenessprobeproperty/{propertyId}`
                .replace(`{${"propertyId"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessages: async (userId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getMessages', 'userId', userId)
            const localVarPath = `/admin/user/{userId}/messages`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPathServiceProperty: async (propertyId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyId' is not null or undefined
            assertParamExists('getPathServiceProperty', 'propertyId', propertyId)
            const localVarPath = `/admin/pathproperty/{propertyId}`
                .replace(`{${"propertyId"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortMappingServiceProperty: async (propertyId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyId' is not null or undefined
            assertParamExists('getPortMappingServiceProperty', 'propertyId', propertyId)
            const localVarPath = `/admin/portmappingproperty/{propertyId}`
                .replace(`{${"propertyId"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectInvites: async (projectId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getProjectInvites', 'projectId', projectId)
            const localVarPath = `/admin/project/{projectId}/invites`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectMembers: async (projectId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getProjectMembers', 'projectId', projectId)
            const localVarPath = `/admin/project/{projectId}/members`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectOptions: async (projectId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getProjectOptions', 'projectId', projectId)
            const localVarPath = `/admin/project/{projectId}/options`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectPrivileges: async (projectId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getProjectPrivileges', 'projectId', projectId)
            const localVarPath = `/admin/project/{projectId}/privileges`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectRoles: async (projectId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getProjectRoles', 'projectId', projectId)
            const localVarPath = `/admin/project/{projectId}/roles`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectServices: async (projectId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getProjectServices', 'projectId', projectId)
            const localVarPath = `/admin/project/{projectId}/services`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectTheme: async (projectId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getProjectTheme', 'projectId', projectId)
            const localVarPath = `/admin/project/{projectId}/theme`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrometheusServiceProperty: async (propertyId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyId' is not null or undefined
            assertParamExists('getPrometheusServiceProperty', 'propertyId', propertyId)
            const localVarPath = `/admin/prometheusproperty/{propertyId}`
                .replace(`{${"propertyId"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReadinessProbeServiceProperty: async (propertyId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyId' is not null or undefined
            assertParamExists('getReadinessProbeServiceProperty', 'propertyId', propertyId)
            const localVarPath = `/admin/readinessprobeproperty/{propertyId}`
                .replace(`{${"propertyId"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} projectId 
         * @param {Array<string>} recipes 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecipe: async (projectId: number, recipes: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getRecipe', 'projectId', projectId)
            // verify required parameter 'recipes' is not null or undefined
            assertParamExists('getRecipe', 'recipes', recipes)
            const localVarPath = `/admin/project/{projectId}/recipe`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (recipes) {
                localVarQueryParameter['recipes'] = recipes;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} releaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReleaseConsensus: async (releaseId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'releaseId' is not null or undefined
            assertParamExists('getReleaseConsensus', 'releaseId', releaseId)
            const localVarPath = `/admin/release/{releaseId}/consensus`
                .replace(`{${"releaseId"}}`, encodeURIComponent(String(releaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSecurityServiceProperty: async (propertyId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyId' is not null or undefined
            assertParamExists('getSecurityServiceProperty', 'propertyId', propertyId)
            const localVarPath = `/admin/securityproperty/{propertyId}`
                .replace(`{${"propertyId"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceEnvironmentVariables: async (serviceId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('getServiceEnvironmentVariables', 'serviceId', serviceId)
            const localVarPath = `/admin/service/{serviceId}/environmentvariables`
                .replace(`{${"serviceId"}}`, encodeURIComponent(String(serviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceExpressionKeyEnvironmentMatrix: async (serviceId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('getServiceExpressionKeyEnvironmentMatrix', 'serviceId', serviceId)
            const localVarPath = `/admin/services/{serviceId}/expression-keys-environment-matrix`
                .replace(`{${"serviceId"}}`, encodeURIComponent(String(serviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceMounts: async (serviceId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('getServiceMounts', 'serviceId', serviceId)
            const localVarPath = `/admin/service/{serviceId}/mounts`
                .replace(`{${"serviceId"}}`, encodeURIComponent(String(serviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceParameters: async (serviceId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('getServiceParameters', 'serviceId', serviceId)
            const localVarPath = `/admin/service/{serviceId}/parameters`
                .replace(`{${"serviceId"}}`, encodeURIComponent(String(serviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceParametersMatrix: async (serviceId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('getServiceParametersMatrix', 'serviceId', serviceId)
            const localVarPath = `/admin/service/{serviceId}/parametersmatrix`
                .replace(`{${"serviceId"}}`, encodeURIComponent(String(serviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceProperties: async (serviceId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('getServiceProperties', 'serviceId', serviceId)
            const localVarPath = `/admin/service/{serviceId}/properties`
                .replace(`{${"serviceId"}}`, encodeURIComponent(String(serviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceSecrets: async (serviceId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('getServiceSecrets', 'serviceId', serviceId)
            const localVarPath = `/admin/service/{serviceId}/secrets`
                .replace(`{${"serviceId"}}`, encodeURIComponent(String(serviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceVolumes: async (serviceId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('getServiceVolumes', 'serviceId', serviceId)
            const localVarPath = `/admin/service/{serviceId}/volumes`
                .replace(`{${"serviceId"}}`, encodeURIComponent(String(serviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCompany: async (userId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserCompany', 'userId', userId)
            const localVarPath = `/admin/user/{userId}/company`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserProjects: async (userId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserProjects', 'userId', userId)
            const localVarPath = `/admin/user/{userId}/projects`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {number} messageId 
         * @param {string} message 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAnswer: async (userId: number, messageId: number, message: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('postAnswer', 'userId', userId)
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('postAnswer', 'messageId', messageId)
            // verify required parameter 'message' is not null or undefined
            assertParamExists('postAnswer', 'message', message)
            const localVarPath = `/admin/user/{userId}message/{messageId}/answer`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"messageId"}}`, encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (message !== undefined) {
                localVarQueryParameter['message'] = message;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} companyId 
         * @param {string} email 
         * @param {string} language 
         * @param {string} registerEmail 
         * @param {string} acceptEmail 
         * @param {string} from 
         * @param {string} registerUrl 
         * @param {string} redirectUrl 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCompanyInvite: async (companyId: number, email: string, language: string, registerEmail: string, acceptEmail: string, from: string, registerUrl: string, redirectUrl: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('postCompanyInvite', 'companyId', companyId)
            // verify required parameter 'email' is not null or undefined
            assertParamExists('postCompanyInvite', 'email', email)
            // verify required parameter 'language' is not null or undefined
            assertParamExists('postCompanyInvite', 'language', language)
            // verify required parameter 'registerEmail' is not null or undefined
            assertParamExists('postCompanyInvite', 'registerEmail', registerEmail)
            // verify required parameter 'acceptEmail' is not null or undefined
            assertParamExists('postCompanyInvite', 'acceptEmail', acceptEmail)
            // verify required parameter 'from' is not null or undefined
            assertParamExists('postCompanyInvite', 'from', from)
            // verify required parameter 'registerUrl' is not null or undefined
            assertParamExists('postCompanyInvite', 'registerUrl', registerUrl)
            // verify required parameter 'redirectUrl' is not null or undefined
            assertParamExists('postCompanyInvite', 'redirectUrl', redirectUrl)
            const localVarPath = `/admin/company/{companyId}/invite`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }

            if (registerEmail !== undefined) {
                localVarQueryParameter['registerEmail'] = registerEmail;
            }

            if (acceptEmail !== undefined) {
                localVarQueryParameter['acceptEmail'] = acceptEmail;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }

            if (registerUrl !== undefined) {
                localVarQueryParameter['registerUrl'] = registerUrl;
            }

            if (redirectUrl !== undefined) {
                localVarQueryParameter['redirectUrl'] = redirectUrl;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {string} image 
         * @param {string} version 
         * @param {string} [pullImageSecret] 
         * @param {string} [command] 
         * @param {string} [args] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDockerServiceProperty: async (serviceId: number, image: string, version: string, pullImageSecret?: string, command?: string, args?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('postDockerServiceProperty', 'serviceId', serviceId)
            // verify required parameter 'image' is not null or undefined
            assertParamExists('postDockerServiceProperty', 'image', image)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('postDockerServiceProperty', 'version', version)
            const localVarPath = `/admin/service/{serviceId}/docker`
                .replace(`{${"serviceId"}}`, encodeURIComponent(String(serviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (image !== undefined) {
                localVarQueryParameter['image'] = image;
            }

            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }

            if (pullImageSecret !== undefined) {
                localVarQueryParameter['pullImageSecret'] = pullImageSecret;
            }

            if (command !== undefined) {
                localVarQueryParameter['command'] = command;
            }

            if (args !== undefined) {
                localVarQueryParameter['args'] = args;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} projectId 
         * @param {string} name 
         * @param {string} domain 
         * @param {number} providerId 
         * @param {number} [precedentEnvironment] 
         * @param {Array<number>} [tags] 
         * @param {string} [namespace] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postEnvironment: async (projectId: number, name: string, domain: string, providerId: number, precedentEnvironment?: number, tags?: Array<number>, namespace?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('postEnvironment', 'projectId', projectId)
            // verify required parameter 'name' is not null or undefined
            assertParamExists('postEnvironment', 'name', name)
            // verify required parameter 'domain' is not null or undefined
            assertParamExists('postEnvironment', 'domain', domain)
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('postEnvironment', 'providerId', providerId)
            const localVarPath = `/admin/project/{projectId}/environment`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (precedentEnvironment !== undefined) {
                localVarQueryParameter['precedentEnvironment'] = precedentEnvironment;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (domain !== undefined) {
                localVarQueryParameter['domain'] = domain;
            }

            if (tags) {
                localVarQueryParameter['tags'] = tags;
            }

            if (namespace !== undefined) {
                localVarQueryParameter['namespace'] = namespace;
            }

            if (providerId !== undefined) {
                localVarQueryParameter['providerId'] = providerId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {string} name 
         * @param {string} source 
         * @param {string} access 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postGrafanaDataSourceServiceProperty: async (serviceId: number, name: string, source: string, access: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('postGrafanaDataSourceServiceProperty', 'serviceId', serviceId)
            // verify required parameter 'name' is not null or undefined
            assertParamExists('postGrafanaDataSourceServiceProperty', 'name', name)
            // verify required parameter 'source' is not null or undefined
            assertParamExists('postGrafanaDataSourceServiceProperty', 'source', source)
            // verify required parameter 'access' is not null or undefined
            assertParamExists('postGrafanaDataSourceServiceProperty', 'access', access)
            const localVarPath = `/admin/service/{serviceId}/grafanadatasource`
                .replace(`{${"serviceId"}}`, encodeURIComponent(String(serviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }

            if (access !== undefined) {
                localVarQueryParameter['access'] = access;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} projectId 
         * @param {string} email 
         * @param {string} language 
         * @param {string} registerEmail 
         * @param {string} acceptEmail 
         * @param {string} from 
         * @param {string} registerUrl 
         * @param {string} redirectUrl 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postInvite: async (projectId: number, email: string, language: string, registerEmail: string, acceptEmail: string, from: string, registerUrl: string, redirectUrl: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('postInvite', 'projectId', projectId)
            // verify required parameter 'email' is not null or undefined
            assertParamExists('postInvite', 'email', email)
            // verify required parameter 'language' is not null or undefined
            assertParamExists('postInvite', 'language', language)
            // verify required parameter 'registerEmail' is not null or undefined
            assertParamExists('postInvite', 'registerEmail', registerEmail)
            // verify required parameter 'acceptEmail' is not null or undefined
            assertParamExists('postInvite', 'acceptEmail', acceptEmail)
            // verify required parameter 'from' is not null or undefined
            assertParamExists('postInvite', 'from', from)
            // verify required parameter 'registerUrl' is not null or undefined
            assertParamExists('postInvite', 'registerUrl', registerUrl)
            // verify required parameter 'redirectUrl' is not null or undefined
            assertParamExists('postInvite', 'redirectUrl', redirectUrl)
            const localVarPath = `/admin/project/{projectId}/invite`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }

            if (registerEmail !== undefined) {
                localVarQueryParameter['registerEmail'] = registerEmail;
            }

            if (acceptEmail !== undefined) {
                localVarQueryParameter['acceptEmail'] = acceptEmail;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }

            if (registerUrl !== undefined) {
                localVarQueryParameter['registerUrl'] = registerUrl;
            }

            if (redirectUrl !== undefined) {
                localVarQueryParameter['redirectUrl'] = redirectUrl;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postK8sServiceProperty: async (serviceId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('postK8sServiceProperty', 'serviceId', serviceId)
            const localVarPath = `/admin/service/{serviceId}/k8s`
                .replace(`{${"serviceId"}}`, encodeURIComponent(String(serviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {PostLivenessServicePropertyLivenessTypeEnum} livenessType 
         * @param {number} [livenessInitialDelaySeconds] 
         * @param {number} [livenessPeriodSeconds] 
         * @param {number} [livenessTimeoutSeconds] 
         * @param {number} [livenessSuccessThreshold] 
         * @param {number} [livenessFailureThreshold] 
         * @param {string} [livenessPath] 
         * @param {number} [livenessPort] 
         * @param {PostLivenessServicePropertyLivenessSchemeEnum} [livenessScheme] 
         * @param {Array<string>} [livenessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postLivenessServiceProperty: async (serviceId: number, livenessType: PostLivenessServicePropertyLivenessTypeEnum, livenessInitialDelaySeconds?: number, livenessPeriodSeconds?: number, livenessTimeoutSeconds?: number, livenessSuccessThreshold?: number, livenessFailureThreshold?: number, livenessPath?: string, livenessPort?: number, livenessScheme?: PostLivenessServicePropertyLivenessSchemeEnum, livenessCommand?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('postLivenessServiceProperty', 'serviceId', serviceId)
            // verify required parameter 'livenessType' is not null or undefined
            assertParamExists('postLivenessServiceProperty', 'livenessType', livenessType)
            const localVarPath = `/admin/service/{serviceId}/livenesssprobe`
                .replace(`{${"serviceId"}}`, encodeURIComponent(String(serviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (livenessType !== undefined) {
                localVarQueryParameter['livenessType'] = livenessType;
            }

            if (livenessInitialDelaySeconds !== undefined) {
                localVarQueryParameter['livenessInitialDelaySeconds'] = livenessInitialDelaySeconds;
            }

            if (livenessPeriodSeconds !== undefined) {
                localVarQueryParameter['livenessPeriodSeconds'] = livenessPeriodSeconds;
            }

            if (livenessTimeoutSeconds !== undefined) {
                localVarQueryParameter['livenessTimeoutSeconds'] = livenessTimeoutSeconds;
            }

            if (livenessSuccessThreshold !== undefined) {
                localVarQueryParameter['livenessSuccessThreshold'] = livenessSuccessThreshold;
            }

            if (livenessFailureThreshold !== undefined) {
                localVarQueryParameter['livenessFailureThreshold'] = livenessFailureThreshold;
            }

            if (livenessPath !== undefined) {
                localVarQueryParameter['livenessPath'] = livenessPath;
            }

            if (livenessPort !== undefined) {
                localVarQueryParameter['livenessPort'] = livenessPort;
            }

            if (livenessScheme !== undefined) {
                localVarQueryParameter['livenessScheme'] = livenessScheme;
            }

            if (livenessCommand) {
                localVarQueryParameter['livenessCommand'] = livenessCommand;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {string} path 
         * @param {string} host 
         * @param {boolean} redirectWWW 
         * @param {number} portMappingPropertyid 
         * @param {string} [basicAuthUser] 
         * @param {string} [basicAuthPassword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPathServiceProperty: async (serviceId: number, path: string, host: string, redirectWWW: boolean, portMappingPropertyid: number, basicAuthUser?: string, basicAuthPassword?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('postPathServiceProperty', 'serviceId', serviceId)
            // verify required parameter 'path' is not null or undefined
            assertParamExists('postPathServiceProperty', 'path', path)
            // verify required parameter 'host' is not null or undefined
            assertParamExists('postPathServiceProperty', 'host', host)
            // verify required parameter 'redirectWWW' is not null or undefined
            assertParamExists('postPathServiceProperty', 'redirectWWW', redirectWWW)
            // verify required parameter 'portMappingPropertyid' is not null or undefined
            assertParamExists('postPathServiceProperty', 'portMappingPropertyid', portMappingPropertyid)
            const localVarPath = `/admin/service/{serviceId}/path`
                .replace(`{${"serviceId"}}`, encodeURIComponent(String(serviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }

            if (host !== undefined) {
                localVarQueryParameter['host'] = host;
            }

            if (redirectWWW !== undefined) {
                localVarQueryParameter['redirectWWW'] = redirectWWW;
            }

            if (portMappingPropertyid !== undefined) {
                localVarQueryParameter['portMappingPropertyid'] = portMappingPropertyid;
            }

            if (basicAuthUser !== undefined) {
                localVarQueryParameter['basicAuthUser'] = basicAuthUser;
            }

            if (basicAuthPassword !== undefined) {
                localVarQueryParameter['basicAuthPassword'] = basicAuthPassword;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {number} port 
         * @param {number} containerPort 
         * @param {PostPortMappingServicePropertyFlowTypeEnum} flowType 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPortMappingServiceProperty: async (serviceId: number, port: number, containerPort: number, flowType: PostPortMappingServicePropertyFlowTypeEnum, name: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('postPortMappingServiceProperty', 'serviceId', serviceId)
            // verify required parameter 'port' is not null or undefined
            assertParamExists('postPortMappingServiceProperty', 'port', port)
            // verify required parameter 'containerPort' is not null or undefined
            assertParamExists('postPortMappingServiceProperty', 'containerPort', containerPort)
            // verify required parameter 'flowType' is not null or undefined
            assertParamExists('postPortMappingServiceProperty', 'flowType', flowType)
            // verify required parameter 'name' is not null or undefined
            assertParamExists('postPortMappingServiceProperty', 'name', name)
            const localVarPath = `/admin/service/{serviceId}/portmapping`
                .replace(`{${"serviceId"}}`, encodeURIComponent(String(serviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (port !== undefined) {
                localVarQueryParameter['port'] = port;
            }

            if (containerPort !== undefined) {
                localVarQueryParameter['containerPort'] = containerPort;
            }

            if (flowType !== undefined) {
                localVarQueryParameter['flowType'] = flowType;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {string} path 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPrometheusServiceProperty: async (serviceId: number, path: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('postPrometheusServiceProperty', 'serviceId', serviceId)
            // verify required parameter 'path' is not null or undefined
            assertParamExists('postPrometheusServiceProperty', 'path', path)
            const localVarPath = `/admin/service/{serviceId}/prometheus`
                .replace(`{${"serviceId"}}`, encodeURIComponent(String(serviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {PostReadinessServicePropertyReadinessTypeEnum} readinessType 
         * @param {number} [readinessInitialDelaySeconds] 
         * @param {number} [readinessPeriodSeconds] 
         * @param {number} [readinessTimeoutSeconds] 
         * @param {number} [readinessSuccessThreshold] 
         * @param {number} [readinessFailureThreshold] 
         * @param {string} [readinessPath] 
         * @param {number} [readinessPort] 
         * @param {PostReadinessServicePropertyReadinessSchemeEnum} [readinessScheme] 
         * @param {Array<string>} [readinessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postReadinessServiceProperty: async (serviceId: number, readinessType: PostReadinessServicePropertyReadinessTypeEnum, readinessInitialDelaySeconds?: number, readinessPeriodSeconds?: number, readinessTimeoutSeconds?: number, readinessSuccessThreshold?: number, readinessFailureThreshold?: number, readinessPath?: string, readinessPort?: number, readinessScheme?: PostReadinessServicePropertyReadinessSchemeEnum, readinessCommand?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('postReadinessServiceProperty', 'serviceId', serviceId)
            // verify required parameter 'readinessType' is not null or undefined
            assertParamExists('postReadinessServiceProperty', 'readinessType', readinessType)
            const localVarPath = `/admin/service/{serviceId}/readinessprobe`
                .replace(`{${"serviceId"}}`, encodeURIComponent(String(serviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (readinessType !== undefined) {
                localVarQueryParameter['readinessType'] = readinessType;
            }

            if (readinessInitialDelaySeconds !== undefined) {
                localVarQueryParameter['readinessInitialDelaySeconds'] = readinessInitialDelaySeconds;
            }

            if (readinessPeriodSeconds !== undefined) {
                localVarQueryParameter['readinessPeriodSeconds'] = readinessPeriodSeconds;
            }

            if (readinessTimeoutSeconds !== undefined) {
                localVarQueryParameter['readinessTimeoutSeconds'] = readinessTimeoutSeconds;
            }

            if (readinessSuccessThreshold !== undefined) {
                localVarQueryParameter['readinessSuccessThreshold'] = readinessSuccessThreshold;
            }

            if (readinessFailureThreshold !== undefined) {
                localVarQueryParameter['readinessFailureThreshold'] = readinessFailureThreshold;
            }

            if (readinessPath !== undefined) {
                localVarQueryParameter['readinessPath'] = readinessPath;
            }

            if (readinessPort !== undefined) {
                localVarQueryParameter['readinessPort'] = readinessPort;
            }

            if (readinessScheme !== undefined) {
                localVarQueryParameter['readinessScheme'] = readinessScheme;
            }

            if (readinessCommand) {
                localVarQueryParameter['readinessCommand'] = readinessCommand;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} projectId 
         * @param {number} environmentId 
         * @param {number} major 
         * @param {number} minor 
         * @param {number} patch 
         * @param {string} cause 
         * @param {Array<string>} recipes 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRelease: async (projectId: number, environmentId: number, major: number, minor: number, patch: number, cause: string, recipes: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('postRelease', 'projectId', projectId)
            // verify required parameter 'environmentId' is not null or undefined
            assertParamExists('postRelease', 'environmentId', environmentId)
            // verify required parameter 'major' is not null or undefined
            assertParamExists('postRelease', 'major', major)
            // verify required parameter 'minor' is not null or undefined
            assertParamExists('postRelease', 'minor', minor)
            // verify required parameter 'patch' is not null or undefined
            assertParamExists('postRelease', 'patch', patch)
            // verify required parameter 'cause' is not null or undefined
            assertParamExists('postRelease', 'cause', cause)
            // verify required parameter 'recipes' is not null or undefined
            assertParamExists('postRelease', 'recipes', recipes)
            const localVarPath = `/admin/project/{projectId}/environment/{environmentId}/release`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"environmentId"}}`, encodeURIComponent(String(environmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (major !== undefined) {
                localVarQueryParameter['major'] = major;
            }

            if (minor !== undefined) {
                localVarQueryParameter['minor'] = minor;
            }

            if (patch !== undefined) {
                localVarQueryParameter['patch'] = patch;
            }

            if (cause !== undefined) {
                localVarQueryParameter['cause'] = cause;
            }

            if (recipes) {
                localVarQueryParameter['recipes'] = recipes;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {string} runAsUser 
         * @param {string} runAsGroup 
         * @param {boolean} [runAsNonRoot] 
         * @param {boolean} [privileged] 
         * @param {boolean} [allowPrivilegeEscalation] 
         * @param {boolean} [readOnlyRootFilesystem] 
         * @param {PostSecurityServicePropertyProcMountEnum} [procMount] 
         * @param {Array<PostSecurityServicePropertyAddCapabilitiesEnum>} [addCapabilities] 
         * @param {Array<PostSecurityServicePropertyDropCapabilitiesEnum>} [dropCapabilities] 
         * @param {string} [seLinuxLevel] 
         * @param {string} [seLinuxRole] 
         * @param {string} [seLinuxType] 
         * @param {string} [seLinuxUser] 
         * @param {PostSecurityServicePropertySeccompProfileTypeEnum} [seccompProfileType] 
         * @param {string} [seccompLocalhostProfile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postSecurityServiceProperty: async (serviceId: number, runAsUser: string, runAsGroup: string, runAsNonRoot?: boolean, privileged?: boolean, allowPrivilegeEscalation?: boolean, readOnlyRootFilesystem?: boolean, procMount?: PostSecurityServicePropertyProcMountEnum, addCapabilities?: Array<PostSecurityServicePropertyAddCapabilitiesEnum>, dropCapabilities?: Array<PostSecurityServicePropertyDropCapabilitiesEnum>, seLinuxLevel?: string, seLinuxRole?: string, seLinuxType?: string, seLinuxUser?: string, seccompProfileType?: PostSecurityServicePropertySeccompProfileTypeEnum, seccompLocalhostProfile?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('postSecurityServiceProperty', 'serviceId', serviceId)
            // verify required parameter 'runAsUser' is not null or undefined
            assertParamExists('postSecurityServiceProperty', 'runAsUser', runAsUser)
            // verify required parameter 'runAsGroup' is not null or undefined
            assertParamExists('postSecurityServiceProperty', 'runAsGroup', runAsGroup)
            const localVarPath = `/admin/service/{serviceId}/security`
                .replace(`{${"serviceId"}}`, encodeURIComponent(String(serviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (runAsUser !== undefined) {
                localVarQueryParameter['runAsUser'] = runAsUser;
            }

            if (runAsGroup !== undefined) {
                localVarQueryParameter['runAsGroup'] = runAsGroup;
            }

            if (runAsNonRoot !== undefined) {
                localVarQueryParameter['runAsNonRoot'] = runAsNonRoot;
            }

            if (privileged !== undefined) {
                localVarQueryParameter['privileged'] = privileged;
            }

            if (allowPrivilegeEscalation !== undefined) {
                localVarQueryParameter['allowPrivilegeEscalation'] = allowPrivilegeEscalation;
            }

            if (readOnlyRootFilesystem !== undefined) {
                localVarQueryParameter['readOnlyRootFilesystem'] = readOnlyRootFilesystem;
            }

            if (procMount !== undefined) {
                localVarQueryParameter['procMount'] = procMount;
            }

            if (addCapabilities) {
                localVarQueryParameter['addCapabilities'] = addCapabilities;
            }

            if (dropCapabilities) {
                localVarQueryParameter['dropCapabilities'] = dropCapabilities;
            }

            if (seLinuxLevel !== undefined) {
                localVarQueryParameter['seLinuxLevel'] = seLinuxLevel;
            }

            if (seLinuxRole !== undefined) {
                localVarQueryParameter['seLinuxRole'] = seLinuxRole;
            }

            if (seLinuxType !== undefined) {
                localVarQueryParameter['seLinuxType'] = seLinuxType;
            }

            if (seLinuxUser !== undefined) {
                localVarQueryParameter['seLinuxUser'] = seLinuxUser;
            }

            if (seccompProfileType !== undefined) {
                localVarQueryParameter['seccompProfileType'] = seccompProfileType;
            }

            if (seccompLocalhostProfile !== undefined) {
                localVarQueryParameter['seccompLocalhostProfile'] = seccompLocalhostProfile;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUser: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} projectId 
         * @param {number} releaseId 
         * @param {number} environmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promoteRelease: async (projectId: number, releaseId: number, environmentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('promoteRelease', 'projectId', projectId)
            // verify required parameter 'releaseId' is not null or undefined
            assertParamExists('promoteRelease', 'releaseId', releaseId)
            // verify required parameter 'environmentId' is not null or undefined
            assertParamExists('promoteRelease', 'environmentId', environmentId)
            const localVarPath = `/admin/project/{projectId}/release/{releaseId}/release`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"releaseId"}}`, encodeURIComponent(String(releaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (environmentId !== undefined) {
                localVarQueryParameter['environmentId'] = environmentId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {string} firstname 
         * @param {string} lastname 
         * @param {PutActivateCompanyUserTitleEnum} title 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putActivateCompanyUser: async (userId: number, firstname: string, lastname: string, title: PutActivateCompanyUserTitleEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('putActivateCompanyUser', 'userId', userId)
            // verify required parameter 'firstname' is not null or undefined
            assertParamExists('putActivateCompanyUser', 'firstname', firstname)
            // verify required parameter 'lastname' is not null or undefined
            assertParamExists('putActivateCompanyUser', 'lastname', lastname)
            // verify required parameter 'title' is not null or undefined
            assertParamExists('putActivateCompanyUser', 'title', title)
            const localVarPath = `/admin/user/{userId}/company/activate`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (firstname !== undefined) {
                localVarQueryParameter['firstname'] = firstname;
            }

            if (lastname !== undefined) {
                localVarQueryParameter['lastname'] = lastname;
            }

            if (title !== undefined) {
                localVarQueryParameter['title'] = title;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {string} companyName 
         * @param {string} firstname 
         * @param {string} lastname 
         * @param {PutActivateUserTitleEnum} title 
         * @param {number} [companyPhone] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putActivateUser: async (userId: number, companyName: string, firstname: string, lastname: string, title: PutActivateUserTitleEnum, companyPhone?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('putActivateUser', 'userId', userId)
            // verify required parameter 'companyName' is not null or undefined
            assertParamExists('putActivateUser', 'companyName', companyName)
            // verify required parameter 'firstname' is not null or undefined
            assertParamExists('putActivateUser', 'firstname', firstname)
            // verify required parameter 'lastname' is not null or undefined
            assertParamExists('putActivateUser', 'lastname', lastname)
            // verify required parameter 'title' is not null or undefined
            assertParamExists('putActivateUser', 'title', title)
            const localVarPath = `/admin/user/{userId}/activate`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (companyName !== undefined) {
                localVarQueryParameter['companyName'] = companyName;
            }

            if (companyPhone !== undefined) {
                localVarQueryParameter['companyPhone'] = companyPhone;
            }

            if (firstname !== undefined) {
                localVarQueryParameter['firstname'] = firstname;
            }

            if (lastname !== undefined) {
                localVarQueryParameter['lastname'] = lastname;
            }

            if (title !== undefined) {
                localVarQueryParameter['title'] = title;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} propertyId 
         * @param {string} image 
         * @param {string} version 
         * @param {string} [pullImageSecret] 
         * @param {string} [command] 
         * @param {string} [args] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putDockerServiceProperty: async (propertyId: number, image: string, version: string, pullImageSecret?: string, command?: string, args?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyId' is not null or undefined
            assertParamExists('putDockerServiceProperty', 'propertyId', propertyId)
            // verify required parameter 'image' is not null or undefined
            assertParamExists('putDockerServiceProperty', 'image', image)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('putDockerServiceProperty', 'version', version)
            const localVarPath = `/admin/dockerproperty/{propertyId}`
                .replace(`{${"propertyId"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (image !== undefined) {
                localVarQueryParameter['image'] = image;
            }

            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }

            if (pullImageSecret !== undefined) {
                localVarQueryParameter['pullImageSecret'] = pullImageSecret;
            }

            if (command !== undefined) {
                localVarQueryParameter['command'] = command;
            }

            if (args !== undefined) {
                localVarQueryParameter['args'] = args;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} environmentId 
         * @param {string} name 
         * @param {string} domain 
         * @param {number} provider 
         * @param {number} [precedentEnvironment] 
         * @param {Array<number>} [tags] 
         * @param {string} [namespace] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putEnvironment: async (environmentId: number, name: string, domain: string, provider: number, precedentEnvironment?: number, tags?: Array<number>, namespace?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'environmentId' is not null or undefined
            assertParamExists('putEnvironment', 'environmentId', environmentId)
            // verify required parameter 'name' is not null or undefined
            assertParamExists('putEnvironment', 'name', name)
            // verify required parameter 'domain' is not null or undefined
            assertParamExists('putEnvironment', 'domain', domain)
            // verify required parameter 'provider' is not null or undefined
            assertParamExists('putEnvironment', 'provider', provider)
            const localVarPath = `/admin/environment/{environmentId}`
                .replace(`{${"environmentId"}}`, encodeURIComponent(String(environmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (precedentEnvironment !== undefined) {
                localVarQueryParameter['precedentEnvironment'] = precedentEnvironment;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (domain !== undefined) {
                localVarQueryParameter['domain'] = domain;
            }

            if (tags) {
                localVarQueryParameter['tags'] = tags;
            }

            if (namespace !== undefined) {
                localVarQueryParameter['namespace'] = namespace;
            }

            if (provider !== undefined) {
                localVarQueryParameter['provider'] = provider;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} propertyId 
         * @param {string} name 
         * @param {string} source 
         * @param {string} access 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putGrafanaDataSourceServiceProperty: async (propertyId: number, name: string, source: string, access: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyId' is not null or undefined
            assertParamExists('putGrafanaDataSourceServiceProperty', 'propertyId', propertyId)
            // verify required parameter 'name' is not null or undefined
            assertParamExists('putGrafanaDataSourceServiceProperty', 'name', name)
            // verify required parameter 'source' is not null or undefined
            assertParamExists('putGrafanaDataSourceServiceProperty', 'source', source)
            // verify required parameter 'access' is not null or undefined
            assertParamExists('putGrafanaDataSourceServiceProperty', 'access', access)
            const localVarPath = `/admin/grafanadatasourceproperty/{propertyId}`
                .replace(`{${"propertyId"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }

            if (access !== undefined) {
                localVarQueryParameter['access'] = access;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} propertyId 
         * @param {PutLivenessProbeServicePropertyLivenessTypeEnum} livenessType 
         * @param {number} [livenessInitialDelaySeconds] 
         * @param {number} [livenessPeriodSeconds] 
         * @param {number} [livenessTimeoutSeconds] 
         * @param {number} [livenessSuccessThreshold] 
         * @param {number} [livenessFailureThreshold] 
         * @param {string} [livenessPath] 
         * @param {number} [livenessPort] 
         * @param {PutLivenessProbeServicePropertyLivenessSchemeEnum} [livenessScheme] 
         * @param {Array<string>} [livenessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putLivenessProbeServiceProperty: async (propertyId: number, livenessType: PutLivenessProbeServicePropertyLivenessTypeEnum, livenessInitialDelaySeconds?: number, livenessPeriodSeconds?: number, livenessTimeoutSeconds?: number, livenessSuccessThreshold?: number, livenessFailureThreshold?: number, livenessPath?: string, livenessPort?: number, livenessScheme?: PutLivenessProbeServicePropertyLivenessSchemeEnum, livenessCommand?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyId' is not null or undefined
            assertParamExists('putLivenessProbeServiceProperty', 'propertyId', propertyId)
            // verify required parameter 'livenessType' is not null or undefined
            assertParamExists('putLivenessProbeServiceProperty', 'livenessType', livenessType)
            const localVarPath = `/admin/livenessprobeproperty/{propertyId}`
                .replace(`{${"propertyId"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (livenessType !== undefined) {
                localVarQueryParameter['livenessType'] = livenessType;
            }

            if (livenessInitialDelaySeconds !== undefined) {
                localVarQueryParameter['livenessInitialDelaySeconds'] = livenessInitialDelaySeconds;
            }

            if (livenessPeriodSeconds !== undefined) {
                localVarQueryParameter['livenessPeriodSeconds'] = livenessPeriodSeconds;
            }

            if (livenessTimeoutSeconds !== undefined) {
                localVarQueryParameter['livenessTimeoutSeconds'] = livenessTimeoutSeconds;
            }

            if (livenessSuccessThreshold !== undefined) {
                localVarQueryParameter['livenessSuccessThreshold'] = livenessSuccessThreshold;
            }

            if (livenessFailureThreshold !== undefined) {
                localVarQueryParameter['livenessFailureThreshold'] = livenessFailureThreshold;
            }

            if (livenessPath !== undefined) {
                localVarQueryParameter['livenessPath'] = livenessPath;
            }

            if (livenessPort !== undefined) {
                localVarQueryParameter['livenessPort'] = livenessPort;
            }

            if (livenessScheme !== undefined) {
                localVarQueryParameter['livenessScheme'] = livenessScheme;
            }

            if (livenessCommand) {
                localVarQueryParameter['livenessCommand'] = livenessCommand;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} propertyId 
         * @param {string} path 
         * @param {string} host 
         * @param {boolean} redirectWWW 
         * @param {number} portMappingPropertyId 
         * @param {string} [basicAuthUser] 
         * @param {string} [basicAuthPassword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putPathServiceProperty: async (propertyId: number, path: string, host: string, redirectWWW: boolean, portMappingPropertyId: number, basicAuthUser?: string, basicAuthPassword?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyId' is not null or undefined
            assertParamExists('putPathServiceProperty', 'propertyId', propertyId)
            // verify required parameter 'path' is not null or undefined
            assertParamExists('putPathServiceProperty', 'path', path)
            // verify required parameter 'host' is not null or undefined
            assertParamExists('putPathServiceProperty', 'host', host)
            // verify required parameter 'redirectWWW' is not null or undefined
            assertParamExists('putPathServiceProperty', 'redirectWWW', redirectWWW)
            // verify required parameter 'portMappingPropertyId' is not null or undefined
            assertParamExists('putPathServiceProperty', 'portMappingPropertyId', portMappingPropertyId)
            const localVarPath = `/admin/pathproperty/{propertyId}`
                .replace(`{${"propertyId"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }

            if (host !== undefined) {
                localVarQueryParameter['host'] = host;
            }

            if (redirectWWW !== undefined) {
                localVarQueryParameter['redirectWWW'] = redirectWWW;
            }

            if (portMappingPropertyId !== undefined) {
                localVarQueryParameter['portMappingPropertyId'] = portMappingPropertyId;
            }

            if (basicAuthUser !== undefined) {
                localVarQueryParameter['basicAuthUser'] = basicAuthUser;
            }

            if (basicAuthPassword !== undefined) {
                localVarQueryParameter['basicAuthPassword'] = basicAuthPassword;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} propertyId 
         * @param {number} port 
         * @param {number} containerPort 
         * @param {PutPortMappingServicePropertyFlowTypeEnum} flowType 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putPortMappingServiceProperty: async (propertyId: number, port: number, containerPort: number, flowType: PutPortMappingServicePropertyFlowTypeEnum, name: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyId' is not null or undefined
            assertParamExists('putPortMappingServiceProperty', 'propertyId', propertyId)
            // verify required parameter 'port' is not null or undefined
            assertParamExists('putPortMappingServiceProperty', 'port', port)
            // verify required parameter 'containerPort' is not null or undefined
            assertParamExists('putPortMappingServiceProperty', 'containerPort', containerPort)
            // verify required parameter 'flowType' is not null or undefined
            assertParamExists('putPortMappingServiceProperty', 'flowType', flowType)
            // verify required parameter 'name' is not null or undefined
            assertParamExists('putPortMappingServiceProperty', 'name', name)
            const localVarPath = `/admin/portmappingproperty/{propertyId}`
                .replace(`{${"propertyId"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (port !== undefined) {
                localVarQueryParameter['port'] = port;
            }

            if (containerPort !== undefined) {
                localVarQueryParameter['containerPort'] = containerPort;
            }

            if (flowType !== undefined) {
                localVarQueryParameter['flowType'] = flowType;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} projectId 
         * @param {Array<string>} [recipes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putProjectRecipes: async (projectId: number, recipes?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('putProjectRecipes', 'projectId', projectId)
            const localVarPath = `/admin/company/{projectId}/recipes`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (recipes) {
                localVarQueryParameter['recipes'] = recipes;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} propertyId 
         * @param {string} path 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putPrometheusServiceProperty: async (propertyId: number, path: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyId' is not null or undefined
            assertParamExists('putPrometheusServiceProperty', 'propertyId', propertyId)
            // verify required parameter 'path' is not null or undefined
            assertParamExists('putPrometheusServiceProperty', 'path', path)
            const localVarPath = `/admin/prometheusproperty/{propertyId}`
                .replace(`{${"propertyId"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} propertyId 
         * @param {PutReadinessProbeServicePropertyReadinessTypeEnum} readinessType 
         * @param {number} [readinessInitialDelaySeconds] 
         * @param {number} [readinessPeriodSeconds] 
         * @param {number} [readinessTimeoutSeconds] 
         * @param {number} [readinessSuccessThreshold] 
         * @param {number} [readinessFailureThreshold] 
         * @param {string} [readinessPath] 
         * @param {number} [readinessPort] 
         * @param {PutReadinessProbeServicePropertyReadinessSchemeEnum} [readinessScheme] 
         * @param {Array<string>} [readinessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putReadinessProbeServiceProperty: async (propertyId: number, readinessType: PutReadinessProbeServicePropertyReadinessTypeEnum, readinessInitialDelaySeconds?: number, readinessPeriodSeconds?: number, readinessTimeoutSeconds?: number, readinessSuccessThreshold?: number, readinessFailureThreshold?: number, readinessPath?: string, readinessPort?: number, readinessScheme?: PutReadinessProbeServicePropertyReadinessSchemeEnum, readinessCommand?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyId' is not null or undefined
            assertParamExists('putReadinessProbeServiceProperty', 'propertyId', propertyId)
            // verify required parameter 'readinessType' is not null or undefined
            assertParamExists('putReadinessProbeServiceProperty', 'readinessType', readinessType)
            const localVarPath = `/admin/readinessprobeproperty/{propertyId}`
                .replace(`{${"propertyId"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (readinessType !== undefined) {
                localVarQueryParameter['readinessType'] = readinessType;
            }

            if (readinessInitialDelaySeconds !== undefined) {
                localVarQueryParameter['readinessInitialDelaySeconds'] = readinessInitialDelaySeconds;
            }

            if (readinessPeriodSeconds !== undefined) {
                localVarQueryParameter['readinessPeriodSeconds'] = readinessPeriodSeconds;
            }

            if (readinessTimeoutSeconds !== undefined) {
                localVarQueryParameter['readinessTimeoutSeconds'] = readinessTimeoutSeconds;
            }

            if (readinessSuccessThreshold !== undefined) {
                localVarQueryParameter['readinessSuccessThreshold'] = readinessSuccessThreshold;
            }

            if (readinessFailureThreshold !== undefined) {
                localVarQueryParameter['readinessFailureThreshold'] = readinessFailureThreshold;
            }

            if (readinessPath !== undefined) {
                localVarQueryParameter['readinessPath'] = readinessPath;
            }

            if (readinessPort !== undefined) {
                localVarQueryParameter['readinessPort'] = readinessPort;
            }

            if (readinessScheme !== undefined) {
                localVarQueryParameter['readinessScheme'] = readinessScheme;
            }

            if (readinessCommand) {
                localVarQueryParameter['readinessCommand'] = readinessCommand;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} propertyId 
         * @param {string} runAsUser 
         * @param {string} runAsGroup 
         * @param {boolean} [runAsNonRoot] 
         * @param {boolean} [privileged] 
         * @param {boolean} [allowPrivilegeEscalation] 
         * @param {boolean} [readOnlyRootFilesystem] 
         * @param {PutSecurityServicePropertyProcMountEnum} [procMount] 
         * @param {Array<PutSecurityServicePropertyAddCapabilitiesEnum>} [addCapabilities] 
         * @param {Array<PutSecurityServicePropertyDropCapabilitiesEnum>} [dropCapabilities] 
         * @param {string} [seLinuxLevel] 
         * @param {string} [seLinuxRole] 
         * @param {string} [seLinuxType] 
         * @param {string} [seLinuxUser] 
         * @param {PutSecurityServicePropertySeccompProfileTypeEnum} [seccompProfileType] 
         * @param {string} [seccompLocalhostProfile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putSecurityServiceProperty: async (propertyId: number, runAsUser: string, runAsGroup: string, runAsNonRoot?: boolean, privileged?: boolean, allowPrivilegeEscalation?: boolean, readOnlyRootFilesystem?: boolean, procMount?: PutSecurityServicePropertyProcMountEnum, addCapabilities?: Array<PutSecurityServicePropertyAddCapabilitiesEnum>, dropCapabilities?: Array<PutSecurityServicePropertyDropCapabilitiesEnum>, seLinuxLevel?: string, seLinuxRole?: string, seLinuxType?: string, seLinuxUser?: string, seccompProfileType?: PutSecurityServicePropertySeccompProfileTypeEnum, seccompLocalhostProfile?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyId' is not null or undefined
            assertParamExists('putSecurityServiceProperty', 'propertyId', propertyId)
            // verify required parameter 'runAsUser' is not null or undefined
            assertParamExists('putSecurityServiceProperty', 'runAsUser', runAsUser)
            // verify required parameter 'runAsGroup' is not null or undefined
            assertParamExists('putSecurityServiceProperty', 'runAsGroup', runAsGroup)
            const localVarPath = `/admin/securityproperty/{propertyId}`
                .replace(`{${"propertyId"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (runAsUser !== undefined) {
                localVarQueryParameter['runAsUser'] = runAsUser;
            }

            if (runAsGroup !== undefined) {
                localVarQueryParameter['runAsGroup'] = runAsGroup;
            }

            if (runAsNonRoot !== undefined) {
                localVarQueryParameter['runAsNonRoot'] = runAsNonRoot;
            }

            if (privileged !== undefined) {
                localVarQueryParameter['privileged'] = privileged;
            }

            if (allowPrivilegeEscalation !== undefined) {
                localVarQueryParameter['allowPrivilegeEscalation'] = allowPrivilegeEscalation;
            }

            if (readOnlyRootFilesystem !== undefined) {
                localVarQueryParameter['readOnlyRootFilesystem'] = readOnlyRootFilesystem;
            }

            if (procMount !== undefined) {
                localVarQueryParameter['procMount'] = procMount;
            }

            if (addCapabilities) {
                localVarQueryParameter['addCapabilities'] = addCapabilities;
            }

            if (dropCapabilities) {
                localVarQueryParameter['dropCapabilities'] = dropCapabilities;
            }

            if (seLinuxLevel !== undefined) {
                localVarQueryParameter['seLinuxLevel'] = seLinuxLevel;
            }

            if (seLinuxRole !== undefined) {
                localVarQueryParameter['seLinuxRole'] = seLinuxRole;
            }

            if (seLinuxType !== undefined) {
                localVarQueryParameter['seLinuxType'] = seLinuxType;
            }

            if (seLinuxUser !== undefined) {
                localVarQueryParameter['seLinuxUser'] = seLinuxUser;
            }

            if (seccompProfileType !== undefined) {
                localVarQueryParameter['seccompProfileType'] = seccompProfileType;
            }

            if (seccompLocalhostProfile !== undefined) {
                localVarQueryParameter['seccompLocalhostProfile'] = seccompLocalhostProfile;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} roleId 
         * @param {number} privilegeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setRolePrivilege: async (roleId: number, privilegeId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('setRolePrivilege', 'roleId', roleId)
            // verify required parameter 'privilegeId' is not null or undefined
            assertParamExists('setRolePrivilege', 'privilegeId', privilegeId)
            const localVarPath = `/admin/role/{roleId}/privilege`
                .replace(`{${"roleId"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (privilegeId !== undefined) {
                localVarQueryParameter['privilegeId'] = privilegeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} environmentVariableId 
         * @param {string} key 
         * @param {string} [value] 
         * @param {number} [secretId] 
         * @param {number} [parameterId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEnvironmentVariable: async (environmentVariableId: number, key: string, value?: string, secretId?: number, parameterId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'environmentVariableId' is not null or undefined
            assertParamExists('updateEnvironmentVariable', 'environmentVariableId', environmentVariableId)
            // verify required parameter 'key' is not null or undefined
            assertParamExists('updateEnvironmentVariable', 'key', key)
            const localVarPath = `/admin/environmentVariable/{environmentVariableId}`
                .replace(`{${"environmentVariableId"}}`, encodeURIComponent(String(environmentVariableId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }

            if (value !== undefined) {
                localVarQueryParameter['value'] = value;
            }

            if (secretId !== undefined) {
                localVarQueryParameter['secret_id'] = secretId;
            }

            if (parameterId !== undefined) {
                localVarQueryParameter['parameter_id'] = parameterId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} propertyId 
         * @param {number} replicaCount 
         * @param {number} cpuLimit 
         * @param {number} memoryLimit 
         * @param {number} cpuRequest 
         * @param {number} memoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateK8sServicePropertyEnvironment: async (propertyId: number, replicaCount: number, cpuLimit: number, memoryLimit: number, cpuRequest: number, memoryRequest: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyId' is not null or undefined
            assertParamExists('updateK8sServicePropertyEnvironment', 'propertyId', propertyId)
            // verify required parameter 'replicaCount' is not null or undefined
            assertParamExists('updateK8sServicePropertyEnvironment', 'replicaCount', replicaCount)
            // verify required parameter 'cpuLimit' is not null or undefined
            assertParamExists('updateK8sServicePropertyEnvironment', 'cpuLimit', cpuLimit)
            // verify required parameter 'memoryLimit' is not null or undefined
            assertParamExists('updateK8sServicePropertyEnvironment', 'memoryLimit', memoryLimit)
            // verify required parameter 'cpuRequest' is not null or undefined
            assertParamExists('updateK8sServicePropertyEnvironment', 'cpuRequest', cpuRequest)
            // verify required parameter 'memoryRequest' is not null or undefined
            assertParamExists('updateK8sServicePropertyEnvironment', 'memoryRequest', memoryRequest)
            const localVarPath = `/admin/k8sproperty/{propertyId}`
                .replace(`{${"propertyId"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (replicaCount !== undefined) {
                localVarQueryParameter['replicaCount'] = replicaCount;
            }

            if (cpuLimit !== undefined) {
                localVarQueryParameter['cpuLimit'] = cpuLimit;
            }

            if (memoryLimit !== undefined) {
                localVarQueryParameter['memoryLimit'] = memoryLimit;
            }

            if (cpuRequest !== undefined) {
                localVarQueryParameter['cpuRequest'] = cpuRequest;
            }

            if (memoryRequest !== undefined) {
                localVarQueryParameter['memoryRequest'] = memoryRequest;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} mountId 
         * @param {string} pathExpression 
         * @param {string} mount 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMount: async (mountId: number, pathExpression: string, mount: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mountId' is not null or undefined
            assertParamExists('updateMount', 'mountId', mountId)
            // verify required parameter 'pathExpression' is not null or undefined
            assertParamExists('updateMount', 'pathExpression', pathExpression)
            // verify required parameter 'mount' is not null or undefined
            assertParamExists('updateMount', 'mount', mount)
            const localVarPath = `/admin/mount/{mountId}`
                .replace(`{${"mountId"}}`, encodeURIComponent(String(mountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pathExpression !== undefined) {
                localVarQueryParameter['pathExpression'] = pathExpression;
            }

            if (mount !== undefined) {
                localVarQueryParameter['mount'] = mount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} parameterId 
         * @param {string} key 
         * @param {string} value 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateParameter: async (parameterId: number, key: string, value: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'parameterId' is not null or undefined
            assertParamExists('updateParameter', 'parameterId', parameterId)
            // verify required parameter 'key' is not null or undefined
            assertParamExists('updateParameter', 'key', key)
            // verify required parameter 'value' is not null or undefined
            assertParamExists('updateParameter', 'value', value)
            const localVarPath = `/admin/parameter/{parameterId}`
                .replace(`{${"parameterId"}}`, encodeURIComponent(String(parameterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }

            if (value !== undefined) {
                localVarQueryParameter['value'] = value;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} parameterEnvironmentValueId 
         * @param {string} value 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateParameterEnvironmentValue: async (parameterEnvironmentValueId: number, value: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'parameterEnvironmentValueId' is not null or undefined
            assertParamExists('updateParameterEnvironmentValue', 'parameterEnvironmentValueId', parameterEnvironmentValueId)
            // verify required parameter 'value' is not null or undefined
            assertParamExists('updateParameterEnvironmentValue', 'value', value)
            const localVarPath = `/admin/parameterEnvironmentValue/{parameterEnvironmentValueId}/value`
                .replace(`{${"parameterEnvironmentValueId"}}`, encodeURIComponent(String(parameterEnvironmentValueId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (value !== undefined) {
                localVarQueryParameter['value'] = value;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} projectId 
         * @param {string} description 
         * @param {string} [adminUrl] 
         * @param {string} [shortname] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProject: async (projectId: number, description: string, adminUrl?: string, shortname?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('updateProject', 'projectId', projectId)
            // verify required parameter 'description' is not null or undefined
            assertParamExists('updateProject', 'description', description)
            const localVarPath = `/admin/project/{projectId}`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (description !== undefined) {
                localVarQueryParameter['description'] = description;
            }

            if (adminUrl !== undefined) {
                localVarQueryParameter['adminUrl'] = adminUrl;
            }

            if (shortname !== undefined) {
                localVarQueryParameter['shortname'] = shortname;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} projectId 
         * @param {string} themeColor 
         * @param {string} themeBackgroundColor 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProjectTheme: async (projectId: number, themeColor: string, themeBackgroundColor: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('updateProjectTheme', 'projectId', projectId)
            // verify required parameter 'themeColor' is not null or undefined
            assertParamExists('updateProjectTheme', 'themeColor', themeColor)
            // verify required parameter 'themeBackgroundColor' is not null or undefined
            assertParamExists('updateProjectTheme', 'themeBackgroundColor', themeBackgroundColor)
            const localVarPath = `/admin/project/{projectId}/theme`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (themeColor !== undefined) {
                localVarQueryParameter['themeColor'] = themeColor;
            }

            if (themeBackgroundColor !== undefined) {
                localVarQueryParameter['themeBackgroundColor'] = themeBackgroundColor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} roleId 
         * @param {string} name 
         * @param {boolean} isPublic 
         * @param {Array<number>} privileges 
         * @param {string} description 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRole: async (roleId: number, name: string, isPublic: boolean, privileges: Array<number>, description: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('updateRole', 'roleId', roleId)
            // verify required parameter 'name' is not null or undefined
            assertParamExists('updateRole', 'name', name)
            // verify required parameter 'isPublic' is not null or undefined
            assertParamExists('updateRole', 'isPublic', isPublic)
            // verify required parameter 'privileges' is not null or undefined
            assertParamExists('updateRole', 'privileges', privileges)
            // verify required parameter 'description' is not null or undefined
            assertParamExists('updateRole', 'description', description)
            const localVarPath = `/admin/role/{roleId}`
                .replace(`{${"roleId"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (isPublic !== undefined) {
                localVarQueryParameter['isPublic'] = isPublic;
            }

            if (privileges) {
                localVarQueryParameter['privileges'] = privileges;
            }

            if (description !== undefined) {
                localVarQueryParameter['description'] = description;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} secretId 
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSecret: async (secretId: number, key: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'secretId' is not null or undefined
            assertParamExists('updateSecret', 'secretId', secretId)
            // verify required parameter 'key' is not null or undefined
            assertParamExists('updateSecret', 'key', key)
            const localVarPath = `/admin/secret/{secretId}`
                .replace(`{${"secretId"}}`, encodeURIComponent(String(secretId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {string} name 
         * @param {string} description 
         * @param {UpdateServiceTypeEnum} type 
         * @param {Array<number>} [dependencies] 
         * @param {Array<number>} [otherDependencies] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateService: async (serviceId: number, name: string, description: string, type: UpdateServiceTypeEnum, dependencies?: Array<number>, otherDependencies?: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('updateService', 'serviceId', serviceId)
            // verify required parameter 'name' is not null or undefined
            assertParamExists('updateService', 'name', name)
            // verify required parameter 'description' is not null or undefined
            assertParamExists('updateService', 'description', description)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('updateService', 'type', type)
            const localVarPath = `/admin/service/{serviceId}`
                .replace(`{${"serviceId"}}`, encodeURIComponent(String(serviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (description !== undefined) {
                localVarQueryParameter['description'] = description;
            }

            if (dependencies) {
                localVarQueryParameter['dependencies'] = dependencies;
            }

            if (otherDependencies) {
                localVarQueryParameter['otherDependencies'] = otherDependencies;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} volumeId 
         * @param {string} name 
         * @param {string} size 
         * @param {string} mount 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVolume: async (volumeId: number, name: string, size: string, mount: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'volumeId' is not null or undefined
            assertParamExists('updateVolume', 'volumeId', volumeId)
            // verify required parameter 'name' is not null or undefined
            assertParamExists('updateVolume', 'name', name)
            // verify required parameter 'size' is not null or undefined
            assertParamExists('updateVolume', 'size', size)
            // verify required parameter 'mount' is not null or undefined
            assertParamExists('updateVolume', 'mount', mount)
            const localVarPath = `/admin/volume/{volumeId}`
                .replace(`{${"volumeId"}}`, encodeURIComponent(String(volumeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (mount !== undefined) {
                localVarQueryParameter['mount'] = mount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} projectId 
         * @param {UploadMaskableIconRequest} [uploadMaskableIconRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAppletouchIcon: async (projectId: number, uploadMaskableIconRequest?: UploadMaskableIconRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('uploadAppletouchIcon', 'projectId', projectId)
            const localVarPath = `/admin/project/{projectId}/appletouchicon`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(uploadMaskableIconRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} projectId 
         * @param {UploadMaskableIconRequest} [uploadMaskableIconRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFavIcon: async (projectId: number, uploadMaskableIconRequest?: UploadMaskableIconRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('uploadFavIcon', 'projectId', projectId)
            const localVarPath = `/admin/project/{projectId}/favicon`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(uploadMaskableIconRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} projectId 
         * @param {UploadMaskableIconRequest} [uploadMaskableIconRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadIcon: async (projectId: number, uploadMaskableIconRequest?: UploadMaskableIconRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('uploadIcon', 'projectId', projectId)
            const localVarPath = `/admin/project/{projectId}/icon`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(uploadMaskableIconRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} projectId 
         * @param {UploadMaskableIconRequest} [uploadMaskableIconRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadLogo: async (projectId: number, uploadMaskableIconRequest?: UploadMaskableIconRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('uploadLogo', 'projectId', projectId)
            const localVarPath = `/admin/project/{projectId}/logo`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(uploadMaskableIconRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} projectId 
         * @param {UploadMaskableIconRequest} [uploadMaskableIconRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadMaskableIcon: async (projectId: number, uploadMaskableIconRequest?: UploadMaskableIconRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('uploadMaskableIcon', 'projectId', projectId)
            const localVarPath = `/admin/project/{projectId}/maskableicon`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(uploadMaskableIconRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        user: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} projectId 
         * @param {Array<string>} recipes 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyRecipe: async (projectId: number, recipes: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('verifyRecipe', 'projectId', projectId)
            // verify required parameter 'recipes' is not null or undefined
            assertParamExists('verifyRecipe', 'recipes', recipes)
            const localVarPath = `/admin/project/{projectId}/verify`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (recipes) {
                localVarQueryParameter['recipes'] = recipes;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminControllerApi - functional programming interface
 * @export
 */
export const AdminControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} serviceId 
         * @param {string} key 
         * @param {string} [value] 
         * @param {number} [secretId] 
         * @param {number} [parameterId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEnvironmentVariable(serviceId: number, key: string, value?: string, secretId?: number, parameterId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvironmentVariableResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEnvironmentVariable(serviceId, key, value, secretId, parameterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.createEnvironmentVariable']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} propertyId 
         * @param {number} environmentId 
         * @param {number} replicaCount 
         * @param {number} cpuLimit 
         * @param {number} memoryLimit 
         * @param {number} cpuRequest 
         * @param {number} memoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createK8sServicePropertyEnvironment(propertyId: number, environmentId: number, replicaCount: number, cpuLimit: number, memoryLimit: number, cpuRequest: number, memoryRequest: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<K8sServicePropertyEnvironmentResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createK8sServicePropertyEnvironment(propertyId, environmentId, replicaCount, cpuLimit, memoryLimit, cpuRequest, memoryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.createK8sServicePropertyEnvironment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {string} pathExpression 
         * @param {string} mount 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMount(serviceId: number, pathExpression: string, mount: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MountResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMount(serviceId, pathExpression, mount, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.createMount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createParameter(serviceId: number, key: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ParameterResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createParameter(serviceId, key, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.createParameter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} parameterId 
         * @param {number} environmentId 
         * @param {string} value 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createParameterEnvironmentValue(parameterId: number, environmentId: number, value: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ParameterEnvironmentValueResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createParameterEnvironmentValue(parameterId, environmentId, value, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.createParameterEnvironmentValue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} projectId 
         * @param {Array<string>} names 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPrivileges(projectId: number, names: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PrivilegeResource>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPrivileges(projectId, names, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.createPrivileges']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} userId 
         * @param {string} name 
         * @param {string} description 
         * @param {string} [adminUrl] 
         * @param {string} [shortname] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProject(userId: number, name: string, description: string, adminUrl?: string, shortname?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProject(userId, name, description, adminUrl, shortname, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.createProject']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} projectId 
         * @param {string} name 
         * @param {boolean} isPublic 
         * @param {Array<number>} privileges 
         * @param {string} description 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRole(projectId: number, name: string, isPublic: boolean, privileges: Array<number>, description: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRole(projectId, name, isPublic, privileges, description, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.createRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSecret(serviceId: number, key: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SecretResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSecret(serviceId, key, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.createSecret']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} projectId 
         * @param {string} name 
         * @param {string} description 
         * @param {CreateServiceTypeEnum} type 
         * @param {Array<number>} [dependencies] 
         * @param {Array<number>} [otherDependencies] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createService(projectId: number, name: string, description: string, type: CreateServiceTypeEnum, dependencies?: Array<number>, otherDependencies?: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createService(projectId, name, description, type, dependencies, otherDependencies, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.createService']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} companyId 
         * @param {Array<string>} names 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTags(companyId: number, names: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TagResource>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTags(companyId, names, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.createTags']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {string} name 
         * @param {string} size 
         * @param {string} mount 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createVolume(serviceId: number, name: string, size: string, mount: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VolumeResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createVolume(serviceId, name, size, mount, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.createVolume']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEnvironment(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEnvironment(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.deleteEnvironment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} environmentVariableId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEnvironmentVariable(environmentVariableId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEnvironmentVariable(environmentVariableId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.deleteEnvironmentVariable']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} mountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMount(mountId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMount(mountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.deleteMount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} parameterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteParameter(parameterId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteParameter(parameterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.deleteParameter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteProperty(propertyId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteProperty(propertyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.deleteProperty']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} secretId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSecret(secretId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSecret(secretId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.deleteSecret']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteService(serviceId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteService(serviceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.deleteService']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} volumeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteVolume(volumeId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteVolume(volumeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.deleteVolume']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyAdmins(companyId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserResource>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyAdmins(companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.getCompanyAdmins']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyInvites(companyId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InviteResource>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyInvites(companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.getCompanyInvites']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyMembers(companyId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserResource>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyMembers(companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.getCompanyMembers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyProjects(companyId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProjectResource>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyProjects(companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.getCompanyProjects']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyRecipes(companyId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyRecipes(companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.getCompanyRecipes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDockerServiceProperty(propertyId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DockerServicePropertyResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDockerServiceProperty(propertyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.getDockerServiceProperty']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEnvironments(projectId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EnvironmentResource>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEnvironments(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.getEnvironments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGrafanaDataSourceServiceProperty(propertyId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GrafanaDataSourceServicePropertyResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGrafanaDataSourceServiceProperty(propertyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.getGrafanaDataSourceServiceProperty']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getK8sServiceProperty(propertyId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<K8sServicePropertyResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getK8sServiceProperty(propertyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.getK8sServiceProperty']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLivenessProbeServiceProperty(propertyId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LivenessProbeServicePropertyResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLivenessProbeServiceProperty(propertyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.getLivenessProbeServiceProperty']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMessages(userId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MessageResource>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMessages(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.getMessages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPathServiceProperty(propertyId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PathServicePropertyResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPathServiceProperty(propertyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.getPathServiceProperty']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPortMappingServiceProperty(propertyId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PortMappingServicePropertyResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPortMappingServiceProperty(propertyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.getPortMappingServiceProperty']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjectInvites(projectId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InviteResource>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjectInvites(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.getProjectInvites']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjectMembers(projectId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserResource>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjectMembers(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.getProjectMembers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjectOptions(projectId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectOptionsResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjectOptions(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.getProjectOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjectPrivileges(projectId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PrivilegeResource>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjectPrivileges(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.getProjectPrivileges']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjectRoles(projectId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RoleResource>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjectRoles(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.getProjectRoles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjectServices(projectId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ServiceResource>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjectServices(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.getProjectServices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjectTheme(projectId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectThemeResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjectTheme(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.getProjectTheme']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPrometheusServiceProperty(propertyId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrometheusServicePropertyResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrometheusServiceProperty(propertyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.getPrometheusServiceProperty']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReadinessProbeServiceProperty(propertyId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReadinessProbeServicePropertyResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReadinessProbeServiceProperty(propertyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.getReadinessProbeServiceProperty']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} projectId 
         * @param {Array<string>} recipes 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRecipe(projectId: number, recipes: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRecipe(projectId, recipes, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.getRecipe']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} releaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReleaseConsensus(releaseId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConsensusResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReleaseConsensus(releaseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.getReleaseConsensus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSecurityServiceProperty(propertyId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SecurityServicePropertyResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSecurityServiceProperty(propertyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.getSecurityServiceProperty']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getServiceEnvironmentVariables(serviceId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EnvironmentVariableResource>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getServiceEnvironmentVariables(serviceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.getServiceEnvironmentVariables']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getServiceExpressionKeyEnvironmentMatrix(serviceId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: KeyEnriched; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getServiceExpressionKeyEnvironmentMatrix(serviceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.getServiceExpressionKeyEnvironmentMatrix']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getServiceMounts(serviceId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MountResource>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getServiceMounts(serviceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.getServiceMounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getServiceParameters(serviceId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ParameterResource>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getServiceParameters(serviceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.getServiceParameters']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getServiceParametersMatrix(serviceId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceParametersMatrixResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getServiceParametersMatrix(serviceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.getServiceParametersMatrix']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getServiceProperties(serviceId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ServicePropertyResource>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getServiceProperties(serviceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.getServiceProperties']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getServiceSecrets(serviceId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SecretResource>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getServiceSecrets(serviceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.getServiceSecrets']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getServiceVolumes(serviceId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VolumeResource>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getServiceVolumes(serviceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.getServiceVolumes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserCompany(userId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserCompany(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.getUserCompany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserProjects(userId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProjectResource>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserProjects(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.getUserProjects']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} userId 
         * @param {number} messageId 
         * @param {string} message 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAnswer(userId: number, messageId: number, message: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAnswer(userId, messageId, message, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.postAnswer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} companyId 
         * @param {string} email 
         * @param {string} language 
         * @param {string} registerEmail 
         * @param {string} acceptEmail 
         * @param {string} from 
         * @param {string} registerUrl 
         * @param {string} redirectUrl 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCompanyInvite(companyId: number, email: string, language: string, registerEmail: string, acceptEmail: string, from: string, registerUrl: string, redirectUrl: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InviteResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCompanyInvite(companyId, email, language, registerEmail, acceptEmail, from, registerUrl, redirectUrl, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.postCompanyInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {string} image 
         * @param {string} version 
         * @param {string} [pullImageSecret] 
         * @param {string} [command] 
         * @param {string} [args] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postDockerServiceProperty(serviceId: number, image: string, version: string, pullImageSecret?: string, command?: string, args?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServicePropertyResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postDockerServiceProperty(serviceId, image, version, pullImageSecret, command, args, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.postDockerServiceProperty']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} projectId 
         * @param {string} name 
         * @param {string} domain 
         * @param {number} providerId 
         * @param {number} [precedentEnvironment] 
         * @param {Array<number>} [tags] 
         * @param {string} [namespace] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postEnvironment(projectId: number, name: string, domain: string, providerId: number, precedentEnvironment?: number, tags?: Array<number>, namespace?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvironmentResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postEnvironment(projectId, name, domain, providerId, precedentEnvironment, tags, namespace, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.postEnvironment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {string} name 
         * @param {string} source 
         * @param {string} access 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postGrafanaDataSourceServiceProperty(serviceId: number, name: string, source: string, access: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServicePropertyResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postGrafanaDataSourceServiceProperty(serviceId, name, source, access, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.postGrafanaDataSourceServiceProperty']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} projectId 
         * @param {string} email 
         * @param {string} language 
         * @param {string} registerEmail 
         * @param {string} acceptEmail 
         * @param {string} from 
         * @param {string} registerUrl 
         * @param {string} redirectUrl 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postInvite(projectId: number, email: string, language: string, registerEmail: string, acceptEmail: string, from: string, registerUrl: string, redirectUrl: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InviteResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postInvite(projectId, email, language, registerEmail, acceptEmail, from, registerUrl, redirectUrl, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.postInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postK8sServiceProperty(serviceId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<K8sServicePropertyResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postK8sServiceProperty(serviceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.postK8sServiceProperty']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {PostLivenessServicePropertyLivenessTypeEnum} livenessType 
         * @param {number} [livenessInitialDelaySeconds] 
         * @param {number} [livenessPeriodSeconds] 
         * @param {number} [livenessTimeoutSeconds] 
         * @param {number} [livenessSuccessThreshold] 
         * @param {number} [livenessFailureThreshold] 
         * @param {string} [livenessPath] 
         * @param {number} [livenessPort] 
         * @param {PostLivenessServicePropertyLivenessSchemeEnum} [livenessScheme] 
         * @param {Array<string>} [livenessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postLivenessServiceProperty(serviceId: number, livenessType: PostLivenessServicePropertyLivenessTypeEnum, livenessInitialDelaySeconds?: number, livenessPeriodSeconds?: number, livenessTimeoutSeconds?: number, livenessSuccessThreshold?: number, livenessFailureThreshold?: number, livenessPath?: string, livenessPort?: number, livenessScheme?: PostLivenessServicePropertyLivenessSchemeEnum, livenessCommand?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServicePropertyResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postLivenessServiceProperty(serviceId, livenessType, livenessInitialDelaySeconds, livenessPeriodSeconds, livenessTimeoutSeconds, livenessSuccessThreshold, livenessFailureThreshold, livenessPath, livenessPort, livenessScheme, livenessCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.postLivenessServiceProperty']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {string} path 
         * @param {string} host 
         * @param {boolean} redirectWWW 
         * @param {number} portMappingPropertyid 
         * @param {string} [basicAuthUser] 
         * @param {string} [basicAuthPassword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postPathServiceProperty(serviceId: number, path: string, host: string, redirectWWW: boolean, portMappingPropertyid: number, basicAuthUser?: string, basicAuthPassword?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServicePropertyResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postPathServiceProperty(serviceId, path, host, redirectWWW, portMappingPropertyid, basicAuthUser, basicAuthPassword, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.postPathServiceProperty']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {number} port 
         * @param {number} containerPort 
         * @param {PostPortMappingServicePropertyFlowTypeEnum} flowType 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postPortMappingServiceProperty(serviceId: number, port: number, containerPort: number, flowType: PostPortMappingServicePropertyFlowTypeEnum, name: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServicePropertyResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postPortMappingServiceProperty(serviceId, port, containerPort, flowType, name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.postPortMappingServiceProperty']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {string} path 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postPrometheusServiceProperty(serviceId: number, path: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServicePropertyResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postPrometheusServiceProperty(serviceId, path, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.postPrometheusServiceProperty']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {PostReadinessServicePropertyReadinessTypeEnum} readinessType 
         * @param {number} [readinessInitialDelaySeconds] 
         * @param {number} [readinessPeriodSeconds] 
         * @param {number} [readinessTimeoutSeconds] 
         * @param {number} [readinessSuccessThreshold] 
         * @param {number} [readinessFailureThreshold] 
         * @param {string} [readinessPath] 
         * @param {number} [readinessPort] 
         * @param {PostReadinessServicePropertyReadinessSchemeEnum} [readinessScheme] 
         * @param {Array<string>} [readinessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postReadinessServiceProperty(serviceId: number, readinessType: PostReadinessServicePropertyReadinessTypeEnum, readinessInitialDelaySeconds?: number, readinessPeriodSeconds?: number, readinessTimeoutSeconds?: number, readinessSuccessThreshold?: number, readinessFailureThreshold?: number, readinessPath?: string, readinessPort?: number, readinessScheme?: PostReadinessServicePropertyReadinessSchemeEnum, readinessCommand?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServicePropertyResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postReadinessServiceProperty(serviceId, readinessType, readinessInitialDelaySeconds, readinessPeriodSeconds, readinessTimeoutSeconds, readinessSuccessThreshold, readinessFailureThreshold, readinessPath, readinessPort, readinessScheme, readinessCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.postReadinessServiceProperty']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} projectId 
         * @param {number} environmentId 
         * @param {number} major 
         * @param {number} minor 
         * @param {number} patch 
         * @param {string} cause 
         * @param {Array<string>} recipes 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postRelease(projectId: number, environmentId: number, major: number, minor: number, patch: number, cause: string, recipes: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReleaseResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postRelease(projectId, environmentId, major, minor, patch, cause, recipes, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.postRelease']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {string} runAsUser 
         * @param {string} runAsGroup 
         * @param {boolean} [runAsNonRoot] 
         * @param {boolean} [privileged] 
         * @param {boolean} [allowPrivilegeEscalation] 
         * @param {boolean} [readOnlyRootFilesystem] 
         * @param {PostSecurityServicePropertyProcMountEnum} [procMount] 
         * @param {Array<PostSecurityServicePropertyAddCapabilitiesEnum>} [addCapabilities] 
         * @param {Array<PostSecurityServicePropertyDropCapabilitiesEnum>} [dropCapabilities] 
         * @param {string} [seLinuxLevel] 
         * @param {string} [seLinuxRole] 
         * @param {string} [seLinuxType] 
         * @param {string} [seLinuxUser] 
         * @param {PostSecurityServicePropertySeccompProfileTypeEnum} [seccompProfileType] 
         * @param {string} [seccompLocalhostProfile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postSecurityServiceProperty(serviceId: number, runAsUser: string, runAsGroup: string, runAsNonRoot?: boolean, privileged?: boolean, allowPrivilegeEscalation?: boolean, readOnlyRootFilesystem?: boolean, procMount?: PostSecurityServicePropertyProcMountEnum, addCapabilities?: Array<PostSecurityServicePropertyAddCapabilitiesEnum>, dropCapabilities?: Array<PostSecurityServicePropertyDropCapabilitiesEnum>, seLinuxLevel?: string, seLinuxRole?: string, seLinuxType?: string, seLinuxUser?: string, seccompProfileType?: PostSecurityServicePropertySeccompProfileTypeEnum, seccompLocalhostProfile?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServicePropertyResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postSecurityServiceProperty(serviceId, runAsUser, runAsGroup, runAsNonRoot, privileged, allowPrivilegeEscalation, readOnlyRootFilesystem, procMount, addCapabilities, dropCapabilities, seLinuxLevel, seLinuxRole, seLinuxType, seLinuxUser, seccompProfileType, seccompLocalhostProfile, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.postSecurityServiceProperty']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postUser(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postUser(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.postUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} projectId 
         * @param {number} releaseId 
         * @param {number} environmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async promoteRelease(projectId: number, releaseId: number, environmentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReleaseResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.promoteRelease(projectId, releaseId, environmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.promoteRelease']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} userId 
         * @param {string} firstname 
         * @param {string} lastname 
         * @param {PutActivateCompanyUserTitleEnum} title 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putActivateCompanyUser(userId: number, firstname: string, lastname: string, title: PutActivateCompanyUserTitleEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putActivateCompanyUser(userId, firstname, lastname, title, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.putActivateCompanyUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} userId 
         * @param {string} companyName 
         * @param {string} firstname 
         * @param {string} lastname 
         * @param {PutActivateUserTitleEnum} title 
         * @param {number} [companyPhone] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putActivateUser(userId: number, companyName: string, firstname: string, lastname: string, title: PutActivateUserTitleEnum, companyPhone?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putActivateUser(userId, companyName, firstname, lastname, title, companyPhone, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.putActivateUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} propertyId 
         * @param {string} image 
         * @param {string} version 
         * @param {string} [pullImageSecret] 
         * @param {string} [command] 
         * @param {string} [args] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putDockerServiceProperty(propertyId: number, image: string, version: string, pullImageSecret?: string, command?: string, args?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServicePropertyResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putDockerServiceProperty(propertyId, image, version, pullImageSecret, command, args, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.putDockerServiceProperty']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} environmentId 
         * @param {string} name 
         * @param {string} domain 
         * @param {number} provider 
         * @param {number} [precedentEnvironment] 
         * @param {Array<number>} [tags] 
         * @param {string} [namespace] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putEnvironment(environmentId: number, name: string, domain: string, provider: number, precedentEnvironment?: number, tags?: Array<number>, namespace?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putEnvironment(environmentId, name, domain, provider, precedentEnvironment, tags, namespace, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.putEnvironment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} propertyId 
         * @param {string} name 
         * @param {string} source 
         * @param {string} access 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putGrafanaDataSourceServiceProperty(propertyId: number, name: string, source: string, access: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServicePropertyResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putGrafanaDataSourceServiceProperty(propertyId, name, source, access, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.putGrafanaDataSourceServiceProperty']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} propertyId 
         * @param {PutLivenessProbeServicePropertyLivenessTypeEnum} livenessType 
         * @param {number} [livenessInitialDelaySeconds] 
         * @param {number} [livenessPeriodSeconds] 
         * @param {number} [livenessTimeoutSeconds] 
         * @param {number} [livenessSuccessThreshold] 
         * @param {number} [livenessFailureThreshold] 
         * @param {string} [livenessPath] 
         * @param {number} [livenessPort] 
         * @param {PutLivenessProbeServicePropertyLivenessSchemeEnum} [livenessScheme] 
         * @param {Array<string>} [livenessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putLivenessProbeServiceProperty(propertyId: number, livenessType: PutLivenessProbeServicePropertyLivenessTypeEnum, livenessInitialDelaySeconds?: number, livenessPeriodSeconds?: number, livenessTimeoutSeconds?: number, livenessSuccessThreshold?: number, livenessFailureThreshold?: number, livenessPath?: string, livenessPort?: number, livenessScheme?: PutLivenessProbeServicePropertyLivenessSchemeEnum, livenessCommand?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServicePropertyResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putLivenessProbeServiceProperty(propertyId, livenessType, livenessInitialDelaySeconds, livenessPeriodSeconds, livenessTimeoutSeconds, livenessSuccessThreshold, livenessFailureThreshold, livenessPath, livenessPort, livenessScheme, livenessCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.putLivenessProbeServiceProperty']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} propertyId 
         * @param {string} path 
         * @param {string} host 
         * @param {boolean} redirectWWW 
         * @param {number} portMappingPropertyId 
         * @param {string} [basicAuthUser] 
         * @param {string} [basicAuthPassword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putPathServiceProperty(propertyId: number, path: string, host: string, redirectWWW: boolean, portMappingPropertyId: number, basicAuthUser?: string, basicAuthPassword?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServicePropertyResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putPathServiceProperty(propertyId, path, host, redirectWWW, portMappingPropertyId, basicAuthUser, basicAuthPassword, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.putPathServiceProperty']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} propertyId 
         * @param {number} port 
         * @param {number} containerPort 
         * @param {PutPortMappingServicePropertyFlowTypeEnum} flowType 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putPortMappingServiceProperty(propertyId: number, port: number, containerPort: number, flowType: PutPortMappingServicePropertyFlowTypeEnum, name: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServicePropertyResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putPortMappingServiceProperty(propertyId, port, containerPort, flowType, name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.putPortMappingServiceProperty']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} projectId 
         * @param {Array<string>} [recipes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putProjectRecipes(projectId: number, recipes?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putProjectRecipes(projectId, recipes, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.putProjectRecipes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} propertyId 
         * @param {string} path 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putPrometheusServiceProperty(propertyId: number, path: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServicePropertyResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putPrometheusServiceProperty(propertyId, path, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.putPrometheusServiceProperty']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} propertyId 
         * @param {PutReadinessProbeServicePropertyReadinessTypeEnum} readinessType 
         * @param {number} [readinessInitialDelaySeconds] 
         * @param {number} [readinessPeriodSeconds] 
         * @param {number} [readinessTimeoutSeconds] 
         * @param {number} [readinessSuccessThreshold] 
         * @param {number} [readinessFailureThreshold] 
         * @param {string} [readinessPath] 
         * @param {number} [readinessPort] 
         * @param {PutReadinessProbeServicePropertyReadinessSchemeEnum} [readinessScheme] 
         * @param {Array<string>} [readinessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putReadinessProbeServiceProperty(propertyId: number, readinessType: PutReadinessProbeServicePropertyReadinessTypeEnum, readinessInitialDelaySeconds?: number, readinessPeriodSeconds?: number, readinessTimeoutSeconds?: number, readinessSuccessThreshold?: number, readinessFailureThreshold?: number, readinessPath?: string, readinessPort?: number, readinessScheme?: PutReadinessProbeServicePropertyReadinessSchemeEnum, readinessCommand?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServicePropertyResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putReadinessProbeServiceProperty(propertyId, readinessType, readinessInitialDelaySeconds, readinessPeriodSeconds, readinessTimeoutSeconds, readinessSuccessThreshold, readinessFailureThreshold, readinessPath, readinessPort, readinessScheme, readinessCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.putReadinessProbeServiceProperty']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} propertyId 
         * @param {string} runAsUser 
         * @param {string} runAsGroup 
         * @param {boolean} [runAsNonRoot] 
         * @param {boolean} [privileged] 
         * @param {boolean} [allowPrivilegeEscalation] 
         * @param {boolean} [readOnlyRootFilesystem] 
         * @param {PutSecurityServicePropertyProcMountEnum} [procMount] 
         * @param {Array<PutSecurityServicePropertyAddCapabilitiesEnum>} [addCapabilities] 
         * @param {Array<PutSecurityServicePropertyDropCapabilitiesEnum>} [dropCapabilities] 
         * @param {string} [seLinuxLevel] 
         * @param {string} [seLinuxRole] 
         * @param {string} [seLinuxType] 
         * @param {string} [seLinuxUser] 
         * @param {PutSecurityServicePropertySeccompProfileTypeEnum} [seccompProfileType] 
         * @param {string} [seccompLocalhostProfile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putSecurityServiceProperty(propertyId: number, runAsUser: string, runAsGroup: string, runAsNonRoot?: boolean, privileged?: boolean, allowPrivilegeEscalation?: boolean, readOnlyRootFilesystem?: boolean, procMount?: PutSecurityServicePropertyProcMountEnum, addCapabilities?: Array<PutSecurityServicePropertyAddCapabilitiesEnum>, dropCapabilities?: Array<PutSecurityServicePropertyDropCapabilitiesEnum>, seLinuxLevel?: string, seLinuxRole?: string, seLinuxType?: string, seLinuxUser?: string, seccompProfileType?: PutSecurityServicePropertySeccompProfileTypeEnum, seccompLocalhostProfile?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServicePropertyResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putSecurityServiceProperty(propertyId, runAsUser, runAsGroup, runAsNonRoot, privileged, allowPrivilegeEscalation, readOnlyRootFilesystem, procMount, addCapabilities, dropCapabilities, seLinuxLevel, seLinuxRole, seLinuxType, seLinuxUser, seccompProfileType, seccompLocalhostProfile, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.putSecurityServiceProperty']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} roleId 
         * @param {number} privilegeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setRolePrivilege(roleId: number, privilegeId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setRolePrivilege(roleId, privilegeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.setRolePrivilege']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} environmentVariableId 
         * @param {string} key 
         * @param {string} [value] 
         * @param {number} [secretId] 
         * @param {number} [parameterId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEnvironmentVariable(environmentVariableId: number, key: string, value?: string, secretId?: number, parameterId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvironmentVariableResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEnvironmentVariable(environmentVariableId, key, value, secretId, parameterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.updateEnvironmentVariable']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} propertyId 
         * @param {number} replicaCount 
         * @param {number} cpuLimit 
         * @param {number} memoryLimit 
         * @param {number} cpuRequest 
         * @param {number} memoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateK8sServicePropertyEnvironment(propertyId: number, replicaCount: number, cpuLimit: number, memoryLimit: number, cpuRequest: number, memoryRequest: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<K8sServicePropertyEnvironmentResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateK8sServicePropertyEnvironment(propertyId, replicaCount, cpuLimit, memoryLimit, cpuRequest, memoryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.updateK8sServicePropertyEnvironment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} mountId 
         * @param {string} pathExpression 
         * @param {string} mount 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMount(mountId: number, pathExpression: string, mount: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MountResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMount(mountId, pathExpression, mount, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.updateMount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} parameterId 
         * @param {string} key 
         * @param {string} value 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateParameter(parameterId: number, key: string, value: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ParameterResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateParameter(parameterId, key, value, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.updateParameter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} parameterEnvironmentValueId 
         * @param {string} value 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateParameterEnvironmentValue(parameterEnvironmentValueId: number, value: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ParameterEnvironmentValueResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateParameterEnvironmentValue(parameterEnvironmentValueId, value, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.updateParameterEnvironmentValue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} projectId 
         * @param {string} description 
         * @param {string} [adminUrl] 
         * @param {string} [shortname] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProject(projectId: number, description: string, adminUrl?: string, shortname?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProject(projectId, description, adminUrl, shortname, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.updateProject']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} projectId 
         * @param {string} themeColor 
         * @param {string} themeBackgroundColor 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProjectTheme(projectId: number, themeColor: string, themeBackgroundColor: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectThemeResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProjectTheme(projectId, themeColor, themeBackgroundColor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.updateProjectTheme']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} roleId 
         * @param {string} name 
         * @param {boolean} isPublic 
         * @param {Array<number>} privileges 
         * @param {string} description 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRole(roleId: number, name: string, isPublic: boolean, privileges: Array<number>, description: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRole(roleId, name, isPublic, privileges, description, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.updateRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} secretId 
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSecret(secretId: number, key: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SecretResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSecret(secretId, key, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.updateSecret']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {string} name 
         * @param {string} description 
         * @param {UpdateServiceTypeEnum} type 
         * @param {Array<number>} [dependencies] 
         * @param {Array<number>} [otherDependencies] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateService(serviceId: number, name: string, description: string, type: UpdateServiceTypeEnum, dependencies?: Array<number>, otherDependencies?: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateService(serviceId, name, description, type, dependencies, otherDependencies, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.updateService']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} volumeId 
         * @param {string} name 
         * @param {string} size 
         * @param {string} mount 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateVolume(volumeId: number, name: string, size: string, mount: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VolumeResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateVolume(volumeId, name, size, mount, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.updateVolume']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} projectId 
         * @param {UploadMaskableIconRequest} [uploadMaskableIconRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadAppletouchIcon(projectId: number, uploadMaskableIconRequest?: UploadMaskableIconRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectThemeResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadAppletouchIcon(projectId, uploadMaskableIconRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.uploadAppletouchIcon']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} projectId 
         * @param {UploadMaskableIconRequest} [uploadMaskableIconRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadFavIcon(projectId: number, uploadMaskableIconRequest?: UploadMaskableIconRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectThemeResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadFavIcon(projectId, uploadMaskableIconRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.uploadFavIcon']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} projectId 
         * @param {UploadMaskableIconRequest} [uploadMaskableIconRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadIcon(projectId: number, uploadMaskableIconRequest?: UploadMaskableIconRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectThemeResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadIcon(projectId, uploadMaskableIconRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.uploadIcon']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} projectId 
         * @param {UploadMaskableIconRequest} [uploadMaskableIconRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadLogo(projectId: number, uploadMaskableIconRequest?: UploadMaskableIconRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectThemeResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadLogo(projectId, uploadMaskableIconRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.uploadLogo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} projectId 
         * @param {UploadMaskableIconRequest} [uploadMaskableIconRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadMaskableIcon(projectId: number, uploadMaskableIconRequest?: UploadMaskableIconRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectThemeResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadMaskableIcon(projectId, uploadMaskableIconRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.uploadMaskableIcon']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async user(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.user(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.user']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} projectId 
         * @param {Array<string>} recipes 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyRecipe(projectId: number, recipes: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyRecipe(projectId, recipes, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.verifyRecipe']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminControllerApi - factory interface
 * @export
 */
export const AdminControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} serviceId 
         * @param {string} key 
         * @param {string} [value] 
         * @param {number} [secretId] 
         * @param {number} [parameterId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEnvironmentVariable(serviceId: number, key: string, value?: string, secretId?: number, parameterId?: number, options?: RawAxiosRequestConfig): AxiosPromise<EnvironmentVariableResource> {
            return localVarFp.createEnvironmentVariable(serviceId, key, value, secretId, parameterId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} propertyId 
         * @param {number} environmentId 
         * @param {number} replicaCount 
         * @param {number} cpuLimit 
         * @param {number} memoryLimit 
         * @param {number} cpuRequest 
         * @param {number} memoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createK8sServicePropertyEnvironment(propertyId: number, environmentId: number, replicaCount: number, cpuLimit: number, memoryLimit: number, cpuRequest: number, memoryRequest: number, options?: RawAxiosRequestConfig): AxiosPromise<K8sServicePropertyEnvironmentResource> {
            return localVarFp.createK8sServicePropertyEnvironment(propertyId, environmentId, replicaCount, cpuLimit, memoryLimit, cpuRequest, memoryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {string} pathExpression 
         * @param {string} mount 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMount(serviceId: number, pathExpression: string, mount: string, options?: RawAxiosRequestConfig): AxiosPromise<MountResource> {
            return localVarFp.createMount(serviceId, pathExpression, mount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createParameter(serviceId: number, key: string, options?: RawAxiosRequestConfig): AxiosPromise<ParameterResource> {
            return localVarFp.createParameter(serviceId, key, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} parameterId 
         * @param {number} environmentId 
         * @param {string} value 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createParameterEnvironmentValue(parameterId: number, environmentId: number, value: string, options?: RawAxiosRequestConfig): AxiosPromise<ParameterEnvironmentValueResource> {
            return localVarFp.createParameterEnvironmentValue(parameterId, environmentId, value, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} projectId 
         * @param {Array<string>} names 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPrivileges(projectId: number, names: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<Array<PrivilegeResource>> {
            return localVarFp.createPrivileges(projectId, names, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} userId 
         * @param {string} name 
         * @param {string} description 
         * @param {string} [adminUrl] 
         * @param {string} [shortname] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProject(userId: number, name: string, description: string, adminUrl?: string, shortname?: string, options?: RawAxiosRequestConfig): AxiosPromise<ProjectResource> {
            return localVarFp.createProject(userId, name, description, adminUrl, shortname, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} projectId 
         * @param {string} name 
         * @param {boolean} isPublic 
         * @param {Array<number>} privileges 
         * @param {string} description 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRole(projectId: number, name: string, isPublic: boolean, privileges: Array<number>, description: string, options?: RawAxiosRequestConfig): AxiosPromise<RoleResource> {
            return localVarFp.createRole(projectId, name, isPublic, privileges, description, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSecret(serviceId: number, key: string, options?: RawAxiosRequestConfig): AxiosPromise<SecretResource> {
            return localVarFp.createSecret(serviceId, key, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} projectId 
         * @param {string} name 
         * @param {string} description 
         * @param {CreateServiceTypeEnum} type 
         * @param {Array<number>} [dependencies] 
         * @param {Array<number>} [otherDependencies] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createService(projectId: number, name: string, description: string, type: CreateServiceTypeEnum, dependencies?: Array<number>, otherDependencies?: Array<number>, options?: RawAxiosRequestConfig): AxiosPromise<ServiceResource> {
            return localVarFp.createService(projectId, name, description, type, dependencies, otherDependencies, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} companyId 
         * @param {Array<string>} names 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTags(companyId: number, names: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<Array<TagResource>> {
            return localVarFp.createTags(companyId, names, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {string} name 
         * @param {string} size 
         * @param {string} mount 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVolume(serviceId: number, name: string, size: string, mount: string, options?: RawAxiosRequestConfig): AxiosPromise<VolumeResource> {
            return localVarFp.createVolume(serviceId, name, size, mount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEnvironment(id: number, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.deleteEnvironment(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} environmentVariableId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEnvironmentVariable(environmentVariableId: number, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.deleteEnvironmentVariable(environmentVariableId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} mountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMount(mountId: number, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.deleteMount(mountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} parameterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteParameter(parameterId: number, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.deleteParameter(parameterId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProperty(propertyId: number, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.deleteProperty(propertyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} secretId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSecret(secretId: number, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.deleteSecret(secretId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteService(serviceId: number, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.deleteService(serviceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} volumeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVolume(volumeId: number, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.deleteVolume(volumeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyAdmins(companyId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<UserResource>> {
            return localVarFp.getCompanyAdmins(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyInvites(companyId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<InviteResource>> {
            return localVarFp.getCompanyInvites(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyMembers(companyId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<UserResource>> {
            return localVarFp.getCompanyMembers(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyProjects(companyId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<ProjectResource>> {
            return localVarFp.getCompanyProjects(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyRecipes(companyId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.getCompanyRecipes(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDockerServiceProperty(propertyId: number, options?: RawAxiosRequestConfig): AxiosPromise<DockerServicePropertyResource> {
            return localVarFp.getDockerServiceProperty(propertyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnvironments(projectId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<EnvironmentResource>> {
            return localVarFp.getEnvironments(projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGrafanaDataSourceServiceProperty(propertyId: number, options?: RawAxiosRequestConfig): AxiosPromise<GrafanaDataSourceServicePropertyResource> {
            return localVarFp.getGrafanaDataSourceServiceProperty(propertyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getK8sServiceProperty(propertyId: number, options?: RawAxiosRequestConfig): AxiosPromise<K8sServicePropertyResource> {
            return localVarFp.getK8sServiceProperty(propertyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLivenessProbeServiceProperty(propertyId: number, options?: RawAxiosRequestConfig): AxiosPromise<LivenessProbeServicePropertyResource> {
            return localVarFp.getLivenessProbeServiceProperty(propertyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessages(userId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<MessageResource>> {
            return localVarFp.getMessages(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPathServiceProperty(propertyId: number, options?: RawAxiosRequestConfig): AxiosPromise<PathServicePropertyResource> {
            return localVarFp.getPathServiceProperty(propertyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortMappingServiceProperty(propertyId: number, options?: RawAxiosRequestConfig): AxiosPromise<PortMappingServicePropertyResource> {
            return localVarFp.getPortMappingServiceProperty(propertyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectInvites(projectId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<InviteResource>> {
            return localVarFp.getProjectInvites(projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectMembers(projectId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<UserResource>> {
            return localVarFp.getProjectMembers(projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectOptions(projectId: number, options?: RawAxiosRequestConfig): AxiosPromise<ProjectOptionsResource> {
            return localVarFp.getProjectOptions(projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectPrivileges(projectId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<PrivilegeResource>> {
            return localVarFp.getProjectPrivileges(projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectRoles(projectId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<RoleResource>> {
            return localVarFp.getProjectRoles(projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectServices(projectId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<ServiceResource>> {
            return localVarFp.getProjectServices(projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectTheme(projectId: number, options?: RawAxiosRequestConfig): AxiosPromise<ProjectThemeResource> {
            return localVarFp.getProjectTheme(projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrometheusServiceProperty(propertyId: number, options?: RawAxiosRequestConfig): AxiosPromise<PrometheusServicePropertyResource> {
            return localVarFp.getPrometheusServiceProperty(propertyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReadinessProbeServiceProperty(propertyId: number, options?: RawAxiosRequestConfig): AxiosPromise<ReadinessProbeServicePropertyResource> {
            return localVarFp.getReadinessProbeServiceProperty(propertyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} projectId 
         * @param {Array<string>} recipes 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecipe(projectId: number, recipes: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getRecipe(projectId, recipes, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} releaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReleaseConsensus(releaseId: number, options?: RawAxiosRequestConfig): AxiosPromise<ConsensusResource> {
            return localVarFp.getReleaseConsensus(releaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSecurityServiceProperty(propertyId: number, options?: RawAxiosRequestConfig): AxiosPromise<SecurityServicePropertyResource> {
            return localVarFp.getSecurityServiceProperty(propertyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceEnvironmentVariables(serviceId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<EnvironmentVariableResource>> {
            return localVarFp.getServiceEnvironmentVariables(serviceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceExpressionKeyEnvironmentMatrix(serviceId: number, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: KeyEnriched; }> {
            return localVarFp.getServiceExpressionKeyEnvironmentMatrix(serviceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceMounts(serviceId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<MountResource>> {
            return localVarFp.getServiceMounts(serviceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceParameters(serviceId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<ParameterResource>> {
            return localVarFp.getServiceParameters(serviceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceParametersMatrix(serviceId: number, options?: RawAxiosRequestConfig): AxiosPromise<ServiceParametersMatrixResource> {
            return localVarFp.getServiceParametersMatrix(serviceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceProperties(serviceId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<ServicePropertyResource>> {
            return localVarFp.getServiceProperties(serviceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceSecrets(serviceId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<SecretResource>> {
            return localVarFp.getServiceSecrets(serviceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceVolumes(serviceId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<VolumeResource>> {
            return localVarFp.getServiceVolumes(serviceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCompany(userId: number, options?: RawAxiosRequestConfig): AxiosPromise<CompanyResource> {
            return localVarFp.getUserCompany(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserProjects(userId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<ProjectResource>> {
            return localVarFp.getUserProjects(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} userId 
         * @param {number} messageId 
         * @param {string} message 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAnswer(userId: number, messageId: number, message: string, options?: RawAxiosRequestConfig): AxiosPromise<MessageResource> {
            return localVarFp.postAnswer(userId, messageId, message, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} companyId 
         * @param {string} email 
         * @param {string} language 
         * @param {string} registerEmail 
         * @param {string} acceptEmail 
         * @param {string} from 
         * @param {string} registerUrl 
         * @param {string} redirectUrl 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCompanyInvite(companyId: number, email: string, language: string, registerEmail: string, acceptEmail: string, from: string, registerUrl: string, redirectUrl: string, options?: RawAxiosRequestConfig): AxiosPromise<InviteResource> {
            return localVarFp.postCompanyInvite(companyId, email, language, registerEmail, acceptEmail, from, registerUrl, redirectUrl, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {string} image 
         * @param {string} version 
         * @param {string} [pullImageSecret] 
         * @param {string} [command] 
         * @param {string} [args] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDockerServiceProperty(serviceId: number, image: string, version: string, pullImageSecret?: string, command?: string, args?: string, options?: RawAxiosRequestConfig): AxiosPromise<ServicePropertyResource> {
            return localVarFp.postDockerServiceProperty(serviceId, image, version, pullImageSecret, command, args, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} projectId 
         * @param {string} name 
         * @param {string} domain 
         * @param {number} providerId 
         * @param {number} [precedentEnvironment] 
         * @param {Array<number>} [tags] 
         * @param {string} [namespace] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postEnvironment(projectId: number, name: string, domain: string, providerId: number, precedentEnvironment?: number, tags?: Array<number>, namespace?: string, options?: RawAxiosRequestConfig): AxiosPromise<EnvironmentResource> {
            return localVarFp.postEnvironment(projectId, name, domain, providerId, precedentEnvironment, tags, namespace, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {string} name 
         * @param {string} source 
         * @param {string} access 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postGrafanaDataSourceServiceProperty(serviceId: number, name: string, source: string, access: string, options?: RawAxiosRequestConfig): AxiosPromise<ServicePropertyResource> {
            return localVarFp.postGrafanaDataSourceServiceProperty(serviceId, name, source, access, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} projectId 
         * @param {string} email 
         * @param {string} language 
         * @param {string} registerEmail 
         * @param {string} acceptEmail 
         * @param {string} from 
         * @param {string} registerUrl 
         * @param {string} redirectUrl 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postInvite(projectId: number, email: string, language: string, registerEmail: string, acceptEmail: string, from: string, registerUrl: string, redirectUrl: string, options?: RawAxiosRequestConfig): AxiosPromise<InviteResource> {
            return localVarFp.postInvite(projectId, email, language, registerEmail, acceptEmail, from, registerUrl, redirectUrl, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postK8sServiceProperty(serviceId: number, options?: RawAxiosRequestConfig): AxiosPromise<K8sServicePropertyResource> {
            return localVarFp.postK8sServiceProperty(serviceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {PostLivenessServicePropertyLivenessTypeEnum} livenessType 
         * @param {number} [livenessInitialDelaySeconds] 
         * @param {number} [livenessPeriodSeconds] 
         * @param {number} [livenessTimeoutSeconds] 
         * @param {number} [livenessSuccessThreshold] 
         * @param {number} [livenessFailureThreshold] 
         * @param {string} [livenessPath] 
         * @param {number} [livenessPort] 
         * @param {PostLivenessServicePropertyLivenessSchemeEnum} [livenessScheme] 
         * @param {Array<string>} [livenessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postLivenessServiceProperty(serviceId: number, livenessType: PostLivenessServicePropertyLivenessTypeEnum, livenessInitialDelaySeconds?: number, livenessPeriodSeconds?: number, livenessTimeoutSeconds?: number, livenessSuccessThreshold?: number, livenessFailureThreshold?: number, livenessPath?: string, livenessPort?: number, livenessScheme?: PostLivenessServicePropertyLivenessSchemeEnum, livenessCommand?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<ServicePropertyResource> {
            return localVarFp.postLivenessServiceProperty(serviceId, livenessType, livenessInitialDelaySeconds, livenessPeriodSeconds, livenessTimeoutSeconds, livenessSuccessThreshold, livenessFailureThreshold, livenessPath, livenessPort, livenessScheme, livenessCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {string} path 
         * @param {string} host 
         * @param {boolean} redirectWWW 
         * @param {number} portMappingPropertyid 
         * @param {string} [basicAuthUser] 
         * @param {string} [basicAuthPassword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPathServiceProperty(serviceId: number, path: string, host: string, redirectWWW: boolean, portMappingPropertyid: number, basicAuthUser?: string, basicAuthPassword?: string, options?: RawAxiosRequestConfig): AxiosPromise<ServicePropertyResource> {
            return localVarFp.postPathServiceProperty(serviceId, path, host, redirectWWW, portMappingPropertyid, basicAuthUser, basicAuthPassword, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {number} port 
         * @param {number} containerPort 
         * @param {PostPortMappingServicePropertyFlowTypeEnum} flowType 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPortMappingServiceProperty(serviceId: number, port: number, containerPort: number, flowType: PostPortMappingServicePropertyFlowTypeEnum, name: string, options?: RawAxiosRequestConfig): AxiosPromise<ServicePropertyResource> {
            return localVarFp.postPortMappingServiceProperty(serviceId, port, containerPort, flowType, name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {string} path 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPrometheusServiceProperty(serviceId: number, path: string, options?: RawAxiosRequestConfig): AxiosPromise<ServicePropertyResource> {
            return localVarFp.postPrometheusServiceProperty(serviceId, path, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {PostReadinessServicePropertyReadinessTypeEnum} readinessType 
         * @param {number} [readinessInitialDelaySeconds] 
         * @param {number} [readinessPeriodSeconds] 
         * @param {number} [readinessTimeoutSeconds] 
         * @param {number} [readinessSuccessThreshold] 
         * @param {number} [readinessFailureThreshold] 
         * @param {string} [readinessPath] 
         * @param {number} [readinessPort] 
         * @param {PostReadinessServicePropertyReadinessSchemeEnum} [readinessScheme] 
         * @param {Array<string>} [readinessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postReadinessServiceProperty(serviceId: number, readinessType: PostReadinessServicePropertyReadinessTypeEnum, readinessInitialDelaySeconds?: number, readinessPeriodSeconds?: number, readinessTimeoutSeconds?: number, readinessSuccessThreshold?: number, readinessFailureThreshold?: number, readinessPath?: string, readinessPort?: number, readinessScheme?: PostReadinessServicePropertyReadinessSchemeEnum, readinessCommand?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<ServicePropertyResource> {
            return localVarFp.postReadinessServiceProperty(serviceId, readinessType, readinessInitialDelaySeconds, readinessPeriodSeconds, readinessTimeoutSeconds, readinessSuccessThreshold, readinessFailureThreshold, readinessPath, readinessPort, readinessScheme, readinessCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} projectId 
         * @param {number} environmentId 
         * @param {number} major 
         * @param {number} minor 
         * @param {number} patch 
         * @param {string} cause 
         * @param {Array<string>} recipes 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRelease(projectId: number, environmentId: number, major: number, minor: number, patch: number, cause: string, recipes: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<ReleaseResource> {
            return localVarFp.postRelease(projectId, environmentId, major, minor, patch, cause, recipes, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {string} runAsUser 
         * @param {string} runAsGroup 
         * @param {boolean} [runAsNonRoot] 
         * @param {boolean} [privileged] 
         * @param {boolean} [allowPrivilegeEscalation] 
         * @param {boolean} [readOnlyRootFilesystem] 
         * @param {PostSecurityServicePropertyProcMountEnum} [procMount] 
         * @param {Array<PostSecurityServicePropertyAddCapabilitiesEnum>} [addCapabilities] 
         * @param {Array<PostSecurityServicePropertyDropCapabilitiesEnum>} [dropCapabilities] 
         * @param {string} [seLinuxLevel] 
         * @param {string} [seLinuxRole] 
         * @param {string} [seLinuxType] 
         * @param {string} [seLinuxUser] 
         * @param {PostSecurityServicePropertySeccompProfileTypeEnum} [seccompProfileType] 
         * @param {string} [seccompLocalhostProfile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postSecurityServiceProperty(serviceId: number, runAsUser: string, runAsGroup: string, runAsNonRoot?: boolean, privileged?: boolean, allowPrivilegeEscalation?: boolean, readOnlyRootFilesystem?: boolean, procMount?: PostSecurityServicePropertyProcMountEnum, addCapabilities?: Array<PostSecurityServicePropertyAddCapabilitiesEnum>, dropCapabilities?: Array<PostSecurityServicePropertyDropCapabilitiesEnum>, seLinuxLevel?: string, seLinuxRole?: string, seLinuxType?: string, seLinuxUser?: string, seccompProfileType?: PostSecurityServicePropertySeccompProfileTypeEnum, seccompLocalhostProfile?: string, options?: RawAxiosRequestConfig): AxiosPromise<ServicePropertyResource> {
            return localVarFp.postSecurityServiceProperty(serviceId, runAsUser, runAsGroup, runAsNonRoot, privileged, allowPrivilegeEscalation, readOnlyRootFilesystem, procMount, addCapabilities, dropCapabilities, seLinuxLevel, seLinuxRole, seLinuxType, seLinuxUser, seccompProfileType, seccompLocalhostProfile, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUser(options?: RawAxiosRequestConfig): AxiosPromise<UserResource> {
            return localVarFp.postUser(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} projectId 
         * @param {number} releaseId 
         * @param {number} environmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promoteRelease(projectId: number, releaseId: number, environmentId: number, options?: RawAxiosRequestConfig): AxiosPromise<ReleaseResource> {
            return localVarFp.promoteRelease(projectId, releaseId, environmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} userId 
         * @param {string} firstname 
         * @param {string} lastname 
         * @param {PutActivateCompanyUserTitleEnum} title 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putActivateCompanyUser(userId: number, firstname: string, lastname: string, title: PutActivateCompanyUserTitleEnum, options?: RawAxiosRequestConfig): AxiosPromise<UserResource> {
            return localVarFp.putActivateCompanyUser(userId, firstname, lastname, title, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} userId 
         * @param {string} companyName 
         * @param {string} firstname 
         * @param {string} lastname 
         * @param {PutActivateUserTitleEnum} title 
         * @param {number} [companyPhone] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putActivateUser(userId: number, companyName: string, firstname: string, lastname: string, title: PutActivateUserTitleEnum, companyPhone?: number, options?: RawAxiosRequestConfig): AxiosPromise<UserResource> {
            return localVarFp.putActivateUser(userId, companyName, firstname, lastname, title, companyPhone, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} propertyId 
         * @param {string} image 
         * @param {string} version 
         * @param {string} [pullImageSecret] 
         * @param {string} [command] 
         * @param {string} [args] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putDockerServiceProperty(propertyId: number, image: string, version: string, pullImageSecret?: string, command?: string, args?: string, options?: RawAxiosRequestConfig): AxiosPromise<ServicePropertyResource> {
            return localVarFp.putDockerServiceProperty(propertyId, image, version, pullImageSecret, command, args, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} environmentId 
         * @param {string} name 
         * @param {string} domain 
         * @param {number} provider 
         * @param {number} [precedentEnvironment] 
         * @param {Array<number>} [tags] 
         * @param {string} [namespace] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putEnvironment(environmentId: number, name: string, domain: string, provider: number, precedentEnvironment?: number, tags?: Array<number>, namespace?: string, options?: RawAxiosRequestConfig): AxiosPromise<ProjectResource> {
            return localVarFp.putEnvironment(environmentId, name, domain, provider, precedentEnvironment, tags, namespace, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} propertyId 
         * @param {string} name 
         * @param {string} source 
         * @param {string} access 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putGrafanaDataSourceServiceProperty(propertyId: number, name: string, source: string, access: string, options?: RawAxiosRequestConfig): AxiosPromise<ServicePropertyResource> {
            return localVarFp.putGrafanaDataSourceServiceProperty(propertyId, name, source, access, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} propertyId 
         * @param {PutLivenessProbeServicePropertyLivenessTypeEnum} livenessType 
         * @param {number} [livenessInitialDelaySeconds] 
         * @param {number} [livenessPeriodSeconds] 
         * @param {number} [livenessTimeoutSeconds] 
         * @param {number} [livenessSuccessThreshold] 
         * @param {number} [livenessFailureThreshold] 
         * @param {string} [livenessPath] 
         * @param {number} [livenessPort] 
         * @param {PutLivenessProbeServicePropertyLivenessSchemeEnum} [livenessScheme] 
         * @param {Array<string>} [livenessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putLivenessProbeServiceProperty(propertyId: number, livenessType: PutLivenessProbeServicePropertyLivenessTypeEnum, livenessInitialDelaySeconds?: number, livenessPeriodSeconds?: number, livenessTimeoutSeconds?: number, livenessSuccessThreshold?: number, livenessFailureThreshold?: number, livenessPath?: string, livenessPort?: number, livenessScheme?: PutLivenessProbeServicePropertyLivenessSchemeEnum, livenessCommand?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<ServicePropertyResource> {
            return localVarFp.putLivenessProbeServiceProperty(propertyId, livenessType, livenessInitialDelaySeconds, livenessPeriodSeconds, livenessTimeoutSeconds, livenessSuccessThreshold, livenessFailureThreshold, livenessPath, livenessPort, livenessScheme, livenessCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} propertyId 
         * @param {string} path 
         * @param {string} host 
         * @param {boolean} redirectWWW 
         * @param {number} portMappingPropertyId 
         * @param {string} [basicAuthUser] 
         * @param {string} [basicAuthPassword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putPathServiceProperty(propertyId: number, path: string, host: string, redirectWWW: boolean, portMappingPropertyId: number, basicAuthUser?: string, basicAuthPassword?: string, options?: RawAxiosRequestConfig): AxiosPromise<ServicePropertyResource> {
            return localVarFp.putPathServiceProperty(propertyId, path, host, redirectWWW, portMappingPropertyId, basicAuthUser, basicAuthPassword, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} propertyId 
         * @param {number} port 
         * @param {number} containerPort 
         * @param {PutPortMappingServicePropertyFlowTypeEnum} flowType 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putPortMappingServiceProperty(propertyId: number, port: number, containerPort: number, flowType: PutPortMappingServicePropertyFlowTypeEnum, name: string, options?: RawAxiosRequestConfig): AxiosPromise<ServicePropertyResource> {
            return localVarFp.putPortMappingServiceProperty(propertyId, port, containerPort, flowType, name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} projectId 
         * @param {Array<string>} [recipes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putProjectRecipes(projectId: number, recipes?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<ProjectResource> {
            return localVarFp.putProjectRecipes(projectId, recipes, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} propertyId 
         * @param {string} path 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putPrometheusServiceProperty(propertyId: number, path: string, options?: RawAxiosRequestConfig): AxiosPromise<ServicePropertyResource> {
            return localVarFp.putPrometheusServiceProperty(propertyId, path, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} propertyId 
         * @param {PutReadinessProbeServicePropertyReadinessTypeEnum} readinessType 
         * @param {number} [readinessInitialDelaySeconds] 
         * @param {number} [readinessPeriodSeconds] 
         * @param {number} [readinessTimeoutSeconds] 
         * @param {number} [readinessSuccessThreshold] 
         * @param {number} [readinessFailureThreshold] 
         * @param {string} [readinessPath] 
         * @param {number} [readinessPort] 
         * @param {PutReadinessProbeServicePropertyReadinessSchemeEnum} [readinessScheme] 
         * @param {Array<string>} [readinessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putReadinessProbeServiceProperty(propertyId: number, readinessType: PutReadinessProbeServicePropertyReadinessTypeEnum, readinessInitialDelaySeconds?: number, readinessPeriodSeconds?: number, readinessTimeoutSeconds?: number, readinessSuccessThreshold?: number, readinessFailureThreshold?: number, readinessPath?: string, readinessPort?: number, readinessScheme?: PutReadinessProbeServicePropertyReadinessSchemeEnum, readinessCommand?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<ServicePropertyResource> {
            return localVarFp.putReadinessProbeServiceProperty(propertyId, readinessType, readinessInitialDelaySeconds, readinessPeriodSeconds, readinessTimeoutSeconds, readinessSuccessThreshold, readinessFailureThreshold, readinessPath, readinessPort, readinessScheme, readinessCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} propertyId 
         * @param {string} runAsUser 
         * @param {string} runAsGroup 
         * @param {boolean} [runAsNonRoot] 
         * @param {boolean} [privileged] 
         * @param {boolean} [allowPrivilegeEscalation] 
         * @param {boolean} [readOnlyRootFilesystem] 
         * @param {PutSecurityServicePropertyProcMountEnum} [procMount] 
         * @param {Array<PutSecurityServicePropertyAddCapabilitiesEnum>} [addCapabilities] 
         * @param {Array<PutSecurityServicePropertyDropCapabilitiesEnum>} [dropCapabilities] 
         * @param {string} [seLinuxLevel] 
         * @param {string} [seLinuxRole] 
         * @param {string} [seLinuxType] 
         * @param {string} [seLinuxUser] 
         * @param {PutSecurityServicePropertySeccompProfileTypeEnum} [seccompProfileType] 
         * @param {string} [seccompLocalhostProfile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putSecurityServiceProperty(propertyId: number, runAsUser: string, runAsGroup: string, runAsNonRoot?: boolean, privileged?: boolean, allowPrivilegeEscalation?: boolean, readOnlyRootFilesystem?: boolean, procMount?: PutSecurityServicePropertyProcMountEnum, addCapabilities?: Array<PutSecurityServicePropertyAddCapabilitiesEnum>, dropCapabilities?: Array<PutSecurityServicePropertyDropCapabilitiesEnum>, seLinuxLevel?: string, seLinuxRole?: string, seLinuxType?: string, seLinuxUser?: string, seccompProfileType?: PutSecurityServicePropertySeccompProfileTypeEnum, seccompLocalhostProfile?: string, options?: RawAxiosRequestConfig): AxiosPromise<ServicePropertyResource> {
            return localVarFp.putSecurityServiceProperty(propertyId, runAsUser, runAsGroup, runAsNonRoot, privileged, allowPrivilegeEscalation, readOnlyRootFilesystem, procMount, addCapabilities, dropCapabilities, seLinuxLevel, seLinuxRole, seLinuxType, seLinuxUser, seccompProfileType, seccompLocalhostProfile, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} roleId 
         * @param {number} privilegeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setRolePrivilege(roleId: number, privilegeId: number, options?: RawAxiosRequestConfig): AxiosPromise<RoleResource> {
            return localVarFp.setRolePrivilege(roleId, privilegeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} environmentVariableId 
         * @param {string} key 
         * @param {string} [value] 
         * @param {number} [secretId] 
         * @param {number} [parameterId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEnvironmentVariable(environmentVariableId: number, key: string, value?: string, secretId?: number, parameterId?: number, options?: RawAxiosRequestConfig): AxiosPromise<EnvironmentVariableResource> {
            return localVarFp.updateEnvironmentVariable(environmentVariableId, key, value, secretId, parameterId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} propertyId 
         * @param {number} replicaCount 
         * @param {number} cpuLimit 
         * @param {number} memoryLimit 
         * @param {number} cpuRequest 
         * @param {number} memoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateK8sServicePropertyEnvironment(propertyId: number, replicaCount: number, cpuLimit: number, memoryLimit: number, cpuRequest: number, memoryRequest: number, options?: RawAxiosRequestConfig): AxiosPromise<K8sServicePropertyEnvironmentResource> {
            return localVarFp.updateK8sServicePropertyEnvironment(propertyId, replicaCount, cpuLimit, memoryLimit, cpuRequest, memoryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} mountId 
         * @param {string} pathExpression 
         * @param {string} mount 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMount(mountId: number, pathExpression: string, mount: string, options?: RawAxiosRequestConfig): AxiosPromise<MountResource> {
            return localVarFp.updateMount(mountId, pathExpression, mount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} parameterId 
         * @param {string} key 
         * @param {string} value 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateParameter(parameterId: number, key: string, value: string, options?: RawAxiosRequestConfig): AxiosPromise<ParameterResource> {
            return localVarFp.updateParameter(parameterId, key, value, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} parameterEnvironmentValueId 
         * @param {string} value 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateParameterEnvironmentValue(parameterEnvironmentValueId: number, value: string, options?: RawAxiosRequestConfig): AxiosPromise<ParameterEnvironmentValueResource> {
            return localVarFp.updateParameterEnvironmentValue(parameterEnvironmentValueId, value, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} projectId 
         * @param {string} description 
         * @param {string} [adminUrl] 
         * @param {string} [shortname] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProject(projectId: number, description: string, adminUrl?: string, shortname?: string, options?: RawAxiosRequestConfig): AxiosPromise<ProjectResource> {
            return localVarFp.updateProject(projectId, description, adminUrl, shortname, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} projectId 
         * @param {string} themeColor 
         * @param {string} themeBackgroundColor 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProjectTheme(projectId: number, themeColor: string, themeBackgroundColor: string, options?: RawAxiosRequestConfig): AxiosPromise<ProjectThemeResource> {
            return localVarFp.updateProjectTheme(projectId, themeColor, themeBackgroundColor, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} roleId 
         * @param {string} name 
         * @param {boolean} isPublic 
         * @param {Array<number>} privileges 
         * @param {string} description 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRole(roleId: number, name: string, isPublic: boolean, privileges: Array<number>, description: string, options?: RawAxiosRequestConfig): AxiosPromise<RoleResource> {
            return localVarFp.updateRole(roleId, name, isPublic, privileges, description, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} secretId 
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSecret(secretId: number, key: string, options?: RawAxiosRequestConfig): AxiosPromise<SecretResource> {
            return localVarFp.updateSecret(secretId, key, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} serviceId 
         * @param {string} name 
         * @param {string} description 
         * @param {UpdateServiceTypeEnum} type 
         * @param {Array<number>} [dependencies] 
         * @param {Array<number>} [otherDependencies] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateService(serviceId: number, name: string, description: string, type: UpdateServiceTypeEnum, dependencies?: Array<number>, otherDependencies?: Array<number>, options?: RawAxiosRequestConfig): AxiosPromise<ServiceResource> {
            return localVarFp.updateService(serviceId, name, description, type, dependencies, otherDependencies, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} volumeId 
         * @param {string} name 
         * @param {string} size 
         * @param {string} mount 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVolume(volumeId: number, name: string, size: string, mount: string, options?: RawAxiosRequestConfig): AxiosPromise<VolumeResource> {
            return localVarFp.updateVolume(volumeId, name, size, mount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} projectId 
         * @param {UploadMaskableIconRequest} [uploadMaskableIconRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAppletouchIcon(projectId: number, uploadMaskableIconRequest?: UploadMaskableIconRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProjectThemeResource> {
            return localVarFp.uploadAppletouchIcon(projectId, uploadMaskableIconRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} projectId 
         * @param {UploadMaskableIconRequest} [uploadMaskableIconRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFavIcon(projectId: number, uploadMaskableIconRequest?: UploadMaskableIconRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProjectThemeResource> {
            return localVarFp.uploadFavIcon(projectId, uploadMaskableIconRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} projectId 
         * @param {UploadMaskableIconRequest} [uploadMaskableIconRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadIcon(projectId: number, uploadMaskableIconRequest?: UploadMaskableIconRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProjectThemeResource> {
            return localVarFp.uploadIcon(projectId, uploadMaskableIconRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} projectId 
         * @param {UploadMaskableIconRequest} [uploadMaskableIconRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadLogo(projectId: number, uploadMaskableIconRequest?: UploadMaskableIconRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProjectThemeResource> {
            return localVarFp.uploadLogo(projectId, uploadMaskableIconRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} projectId 
         * @param {UploadMaskableIconRequest} [uploadMaskableIconRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadMaskableIcon(projectId: number, uploadMaskableIconRequest?: UploadMaskableIconRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProjectThemeResource> {
            return localVarFp.uploadMaskableIcon(projectId, uploadMaskableIconRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        user(options?: RawAxiosRequestConfig): AxiosPromise<UserResource> {
            return localVarFp.user(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} projectId 
         * @param {Array<string>} recipes 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyRecipe(projectId: number, recipes: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.verifyRecipe(projectId, recipes, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminControllerApi - object-oriented interface
 * @export
 * @class AdminControllerApi
 * @extends {BaseAPI}
 */
export class AdminControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} serviceId 
     * @param {string} key 
     * @param {string} [value] 
     * @param {number} [secretId] 
     * @param {number} [parameterId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public createEnvironmentVariable(serviceId: number, key: string, value?: string, secretId?: number, parameterId?: number, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).createEnvironmentVariable(serviceId, key, value, secretId, parameterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} propertyId 
     * @param {number} environmentId 
     * @param {number} replicaCount 
     * @param {number} cpuLimit 
     * @param {number} memoryLimit 
     * @param {number} cpuRequest 
     * @param {number} memoryRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public createK8sServicePropertyEnvironment(propertyId: number, environmentId: number, replicaCount: number, cpuLimit: number, memoryLimit: number, cpuRequest: number, memoryRequest: number, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).createK8sServicePropertyEnvironment(propertyId, environmentId, replicaCount, cpuLimit, memoryLimit, cpuRequest, memoryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} serviceId 
     * @param {string} pathExpression 
     * @param {string} mount 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public createMount(serviceId: number, pathExpression: string, mount: string, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).createMount(serviceId, pathExpression, mount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} serviceId 
     * @param {string} key 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public createParameter(serviceId: number, key: string, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).createParameter(serviceId, key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} parameterId 
     * @param {number} environmentId 
     * @param {string} value 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public createParameterEnvironmentValue(parameterId: number, environmentId: number, value: string, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).createParameterEnvironmentValue(parameterId, environmentId, value, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} projectId 
     * @param {Array<string>} names 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public createPrivileges(projectId: number, names: Array<string>, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).createPrivileges(projectId, names, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} userId 
     * @param {string} name 
     * @param {string} description 
     * @param {string} [adminUrl] 
     * @param {string} [shortname] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public createProject(userId: number, name: string, description: string, adminUrl?: string, shortname?: string, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).createProject(userId, name, description, adminUrl, shortname, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} projectId 
     * @param {string} name 
     * @param {boolean} isPublic 
     * @param {Array<number>} privileges 
     * @param {string} description 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public createRole(projectId: number, name: string, isPublic: boolean, privileges: Array<number>, description: string, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).createRole(projectId, name, isPublic, privileges, description, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} serviceId 
     * @param {string} key 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public createSecret(serviceId: number, key: string, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).createSecret(serviceId, key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} projectId 
     * @param {string} name 
     * @param {string} description 
     * @param {CreateServiceTypeEnum} type 
     * @param {Array<number>} [dependencies] 
     * @param {Array<number>} [otherDependencies] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public createService(projectId: number, name: string, description: string, type: CreateServiceTypeEnum, dependencies?: Array<number>, otherDependencies?: Array<number>, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).createService(projectId, name, description, type, dependencies, otherDependencies, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} companyId 
     * @param {Array<string>} names 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public createTags(companyId: number, names: Array<string>, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).createTags(companyId, names, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} serviceId 
     * @param {string} name 
     * @param {string} size 
     * @param {string} mount 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public createVolume(serviceId: number, name: string, size: string, mount: string, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).createVolume(serviceId, name, size, mount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public deleteEnvironment(id: number, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).deleteEnvironment(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} environmentVariableId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public deleteEnvironmentVariable(environmentVariableId: number, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).deleteEnvironmentVariable(environmentVariableId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} mountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public deleteMount(mountId: number, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).deleteMount(mountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} parameterId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public deleteParameter(parameterId: number, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).deleteParameter(parameterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} propertyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public deleteProperty(propertyId: number, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).deleteProperty(propertyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} secretId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public deleteSecret(secretId: number, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).deleteSecret(secretId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} serviceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public deleteService(serviceId: number, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).deleteService(serviceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} volumeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public deleteVolume(volumeId: number, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).deleteVolume(volumeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public getCompanyAdmins(companyId: number, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).getCompanyAdmins(companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public getCompanyInvites(companyId: number, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).getCompanyInvites(companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public getCompanyMembers(companyId: number, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).getCompanyMembers(companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public getCompanyProjects(companyId: number, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).getCompanyProjects(companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public getCompanyRecipes(companyId: number, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).getCompanyRecipes(companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} propertyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public getDockerServiceProperty(propertyId: number, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).getDockerServiceProperty(propertyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} projectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public getEnvironments(projectId: number, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).getEnvironments(projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} propertyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public getGrafanaDataSourceServiceProperty(propertyId: number, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).getGrafanaDataSourceServiceProperty(propertyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} propertyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public getK8sServiceProperty(propertyId: number, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).getK8sServiceProperty(propertyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} propertyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public getLivenessProbeServiceProperty(propertyId: number, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).getLivenessProbeServiceProperty(propertyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public getMessages(userId: number, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).getMessages(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} propertyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public getPathServiceProperty(propertyId: number, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).getPathServiceProperty(propertyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} propertyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public getPortMappingServiceProperty(propertyId: number, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).getPortMappingServiceProperty(propertyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} projectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public getProjectInvites(projectId: number, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).getProjectInvites(projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} projectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public getProjectMembers(projectId: number, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).getProjectMembers(projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} projectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public getProjectOptions(projectId: number, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).getProjectOptions(projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} projectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public getProjectPrivileges(projectId: number, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).getProjectPrivileges(projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} projectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public getProjectRoles(projectId: number, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).getProjectRoles(projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} projectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public getProjectServices(projectId: number, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).getProjectServices(projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} projectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public getProjectTheme(projectId: number, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).getProjectTheme(projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} propertyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public getPrometheusServiceProperty(propertyId: number, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).getPrometheusServiceProperty(propertyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} propertyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public getReadinessProbeServiceProperty(propertyId: number, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).getReadinessProbeServiceProperty(propertyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} projectId 
     * @param {Array<string>} recipes 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public getRecipe(projectId: number, recipes: Array<string>, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).getRecipe(projectId, recipes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} releaseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public getReleaseConsensus(releaseId: number, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).getReleaseConsensus(releaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} propertyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public getSecurityServiceProperty(propertyId: number, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).getSecurityServiceProperty(propertyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} serviceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public getServiceEnvironmentVariables(serviceId: number, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).getServiceEnvironmentVariables(serviceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} serviceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public getServiceExpressionKeyEnvironmentMatrix(serviceId: number, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).getServiceExpressionKeyEnvironmentMatrix(serviceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} serviceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public getServiceMounts(serviceId: number, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).getServiceMounts(serviceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} serviceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public getServiceParameters(serviceId: number, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).getServiceParameters(serviceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} serviceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public getServiceParametersMatrix(serviceId: number, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).getServiceParametersMatrix(serviceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} serviceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public getServiceProperties(serviceId: number, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).getServiceProperties(serviceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} serviceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public getServiceSecrets(serviceId: number, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).getServiceSecrets(serviceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} serviceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public getServiceVolumes(serviceId: number, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).getServiceVolumes(serviceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public getUserCompany(userId: number, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).getUserCompany(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public getUserProjects(userId: number, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).getUserProjects(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} userId 
     * @param {number} messageId 
     * @param {string} message 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public postAnswer(userId: number, messageId: number, message: string, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).postAnswer(userId, messageId, message, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} companyId 
     * @param {string} email 
     * @param {string} language 
     * @param {string} registerEmail 
     * @param {string} acceptEmail 
     * @param {string} from 
     * @param {string} registerUrl 
     * @param {string} redirectUrl 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public postCompanyInvite(companyId: number, email: string, language: string, registerEmail: string, acceptEmail: string, from: string, registerUrl: string, redirectUrl: string, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).postCompanyInvite(companyId, email, language, registerEmail, acceptEmail, from, registerUrl, redirectUrl, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} serviceId 
     * @param {string} image 
     * @param {string} version 
     * @param {string} [pullImageSecret] 
     * @param {string} [command] 
     * @param {string} [args] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public postDockerServiceProperty(serviceId: number, image: string, version: string, pullImageSecret?: string, command?: string, args?: string, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).postDockerServiceProperty(serviceId, image, version, pullImageSecret, command, args, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} projectId 
     * @param {string} name 
     * @param {string} domain 
     * @param {number} providerId 
     * @param {number} [precedentEnvironment] 
     * @param {Array<number>} [tags] 
     * @param {string} [namespace] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public postEnvironment(projectId: number, name: string, domain: string, providerId: number, precedentEnvironment?: number, tags?: Array<number>, namespace?: string, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).postEnvironment(projectId, name, domain, providerId, precedentEnvironment, tags, namespace, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} serviceId 
     * @param {string} name 
     * @param {string} source 
     * @param {string} access 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public postGrafanaDataSourceServiceProperty(serviceId: number, name: string, source: string, access: string, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).postGrafanaDataSourceServiceProperty(serviceId, name, source, access, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} projectId 
     * @param {string} email 
     * @param {string} language 
     * @param {string} registerEmail 
     * @param {string} acceptEmail 
     * @param {string} from 
     * @param {string} registerUrl 
     * @param {string} redirectUrl 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public postInvite(projectId: number, email: string, language: string, registerEmail: string, acceptEmail: string, from: string, registerUrl: string, redirectUrl: string, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).postInvite(projectId, email, language, registerEmail, acceptEmail, from, registerUrl, redirectUrl, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} serviceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public postK8sServiceProperty(serviceId: number, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).postK8sServiceProperty(serviceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} serviceId 
     * @param {PostLivenessServicePropertyLivenessTypeEnum} livenessType 
     * @param {number} [livenessInitialDelaySeconds] 
     * @param {number} [livenessPeriodSeconds] 
     * @param {number} [livenessTimeoutSeconds] 
     * @param {number} [livenessSuccessThreshold] 
     * @param {number} [livenessFailureThreshold] 
     * @param {string} [livenessPath] 
     * @param {number} [livenessPort] 
     * @param {PostLivenessServicePropertyLivenessSchemeEnum} [livenessScheme] 
     * @param {Array<string>} [livenessCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public postLivenessServiceProperty(serviceId: number, livenessType: PostLivenessServicePropertyLivenessTypeEnum, livenessInitialDelaySeconds?: number, livenessPeriodSeconds?: number, livenessTimeoutSeconds?: number, livenessSuccessThreshold?: number, livenessFailureThreshold?: number, livenessPath?: string, livenessPort?: number, livenessScheme?: PostLivenessServicePropertyLivenessSchemeEnum, livenessCommand?: Array<string>, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).postLivenessServiceProperty(serviceId, livenessType, livenessInitialDelaySeconds, livenessPeriodSeconds, livenessTimeoutSeconds, livenessSuccessThreshold, livenessFailureThreshold, livenessPath, livenessPort, livenessScheme, livenessCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} serviceId 
     * @param {string} path 
     * @param {string} host 
     * @param {boolean} redirectWWW 
     * @param {number} portMappingPropertyid 
     * @param {string} [basicAuthUser] 
     * @param {string} [basicAuthPassword] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public postPathServiceProperty(serviceId: number, path: string, host: string, redirectWWW: boolean, portMappingPropertyid: number, basicAuthUser?: string, basicAuthPassword?: string, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).postPathServiceProperty(serviceId, path, host, redirectWWW, portMappingPropertyid, basicAuthUser, basicAuthPassword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} serviceId 
     * @param {number} port 
     * @param {number} containerPort 
     * @param {PostPortMappingServicePropertyFlowTypeEnum} flowType 
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public postPortMappingServiceProperty(serviceId: number, port: number, containerPort: number, flowType: PostPortMappingServicePropertyFlowTypeEnum, name: string, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).postPortMappingServiceProperty(serviceId, port, containerPort, flowType, name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} serviceId 
     * @param {string} path 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public postPrometheusServiceProperty(serviceId: number, path: string, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).postPrometheusServiceProperty(serviceId, path, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} serviceId 
     * @param {PostReadinessServicePropertyReadinessTypeEnum} readinessType 
     * @param {number} [readinessInitialDelaySeconds] 
     * @param {number} [readinessPeriodSeconds] 
     * @param {number} [readinessTimeoutSeconds] 
     * @param {number} [readinessSuccessThreshold] 
     * @param {number} [readinessFailureThreshold] 
     * @param {string} [readinessPath] 
     * @param {number} [readinessPort] 
     * @param {PostReadinessServicePropertyReadinessSchemeEnum} [readinessScheme] 
     * @param {Array<string>} [readinessCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public postReadinessServiceProperty(serviceId: number, readinessType: PostReadinessServicePropertyReadinessTypeEnum, readinessInitialDelaySeconds?: number, readinessPeriodSeconds?: number, readinessTimeoutSeconds?: number, readinessSuccessThreshold?: number, readinessFailureThreshold?: number, readinessPath?: string, readinessPort?: number, readinessScheme?: PostReadinessServicePropertyReadinessSchemeEnum, readinessCommand?: Array<string>, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).postReadinessServiceProperty(serviceId, readinessType, readinessInitialDelaySeconds, readinessPeriodSeconds, readinessTimeoutSeconds, readinessSuccessThreshold, readinessFailureThreshold, readinessPath, readinessPort, readinessScheme, readinessCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} projectId 
     * @param {number} environmentId 
     * @param {number} major 
     * @param {number} minor 
     * @param {number} patch 
     * @param {string} cause 
     * @param {Array<string>} recipes 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public postRelease(projectId: number, environmentId: number, major: number, minor: number, patch: number, cause: string, recipes: Array<string>, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).postRelease(projectId, environmentId, major, minor, patch, cause, recipes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} serviceId 
     * @param {string} runAsUser 
     * @param {string} runAsGroup 
     * @param {boolean} [runAsNonRoot] 
     * @param {boolean} [privileged] 
     * @param {boolean} [allowPrivilegeEscalation] 
     * @param {boolean} [readOnlyRootFilesystem] 
     * @param {PostSecurityServicePropertyProcMountEnum} [procMount] 
     * @param {Array<PostSecurityServicePropertyAddCapabilitiesEnum>} [addCapabilities] 
     * @param {Array<PostSecurityServicePropertyDropCapabilitiesEnum>} [dropCapabilities] 
     * @param {string} [seLinuxLevel] 
     * @param {string} [seLinuxRole] 
     * @param {string} [seLinuxType] 
     * @param {string} [seLinuxUser] 
     * @param {PostSecurityServicePropertySeccompProfileTypeEnum} [seccompProfileType] 
     * @param {string} [seccompLocalhostProfile] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public postSecurityServiceProperty(serviceId: number, runAsUser: string, runAsGroup: string, runAsNonRoot?: boolean, privileged?: boolean, allowPrivilegeEscalation?: boolean, readOnlyRootFilesystem?: boolean, procMount?: PostSecurityServicePropertyProcMountEnum, addCapabilities?: Array<PostSecurityServicePropertyAddCapabilitiesEnum>, dropCapabilities?: Array<PostSecurityServicePropertyDropCapabilitiesEnum>, seLinuxLevel?: string, seLinuxRole?: string, seLinuxType?: string, seLinuxUser?: string, seccompProfileType?: PostSecurityServicePropertySeccompProfileTypeEnum, seccompLocalhostProfile?: string, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).postSecurityServiceProperty(serviceId, runAsUser, runAsGroup, runAsNonRoot, privileged, allowPrivilegeEscalation, readOnlyRootFilesystem, procMount, addCapabilities, dropCapabilities, seLinuxLevel, seLinuxRole, seLinuxType, seLinuxUser, seccompProfileType, seccompLocalhostProfile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public postUser(options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).postUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} projectId 
     * @param {number} releaseId 
     * @param {number} environmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public promoteRelease(projectId: number, releaseId: number, environmentId: number, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).promoteRelease(projectId, releaseId, environmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} userId 
     * @param {string} firstname 
     * @param {string} lastname 
     * @param {PutActivateCompanyUserTitleEnum} title 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public putActivateCompanyUser(userId: number, firstname: string, lastname: string, title: PutActivateCompanyUserTitleEnum, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).putActivateCompanyUser(userId, firstname, lastname, title, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} userId 
     * @param {string} companyName 
     * @param {string} firstname 
     * @param {string} lastname 
     * @param {PutActivateUserTitleEnum} title 
     * @param {number} [companyPhone] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public putActivateUser(userId: number, companyName: string, firstname: string, lastname: string, title: PutActivateUserTitleEnum, companyPhone?: number, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).putActivateUser(userId, companyName, firstname, lastname, title, companyPhone, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} propertyId 
     * @param {string} image 
     * @param {string} version 
     * @param {string} [pullImageSecret] 
     * @param {string} [command] 
     * @param {string} [args] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public putDockerServiceProperty(propertyId: number, image: string, version: string, pullImageSecret?: string, command?: string, args?: string, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).putDockerServiceProperty(propertyId, image, version, pullImageSecret, command, args, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} environmentId 
     * @param {string} name 
     * @param {string} domain 
     * @param {number} provider 
     * @param {number} [precedentEnvironment] 
     * @param {Array<number>} [tags] 
     * @param {string} [namespace] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public putEnvironment(environmentId: number, name: string, domain: string, provider: number, precedentEnvironment?: number, tags?: Array<number>, namespace?: string, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).putEnvironment(environmentId, name, domain, provider, precedentEnvironment, tags, namespace, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} propertyId 
     * @param {string} name 
     * @param {string} source 
     * @param {string} access 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public putGrafanaDataSourceServiceProperty(propertyId: number, name: string, source: string, access: string, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).putGrafanaDataSourceServiceProperty(propertyId, name, source, access, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} propertyId 
     * @param {PutLivenessProbeServicePropertyLivenessTypeEnum} livenessType 
     * @param {number} [livenessInitialDelaySeconds] 
     * @param {number} [livenessPeriodSeconds] 
     * @param {number} [livenessTimeoutSeconds] 
     * @param {number} [livenessSuccessThreshold] 
     * @param {number} [livenessFailureThreshold] 
     * @param {string} [livenessPath] 
     * @param {number} [livenessPort] 
     * @param {PutLivenessProbeServicePropertyLivenessSchemeEnum} [livenessScheme] 
     * @param {Array<string>} [livenessCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public putLivenessProbeServiceProperty(propertyId: number, livenessType: PutLivenessProbeServicePropertyLivenessTypeEnum, livenessInitialDelaySeconds?: number, livenessPeriodSeconds?: number, livenessTimeoutSeconds?: number, livenessSuccessThreshold?: number, livenessFailureThreshold?: number, livenessPath?: string, livenessPort?: number, livenessScheme?: PutLivenessProbeServicePropertyLivenessSchemeEnum, livenessCommand?: Array<string>, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).putLivenessProbeServiceProperty(propertyId, livenessType, livenessInitialDelaySeconds, livenessPeriodSeconds, livenessTimeoutSeconds, livenessSuccessThreshold, livenessFailureThreshold, livenessPath, livenessPort, livenessScheme, livenessCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} propertyId 
     * @param {string} path 
     * @param {string} host 
     * @param {boolean} redirectWWW 
     * @param {number} portMappingPropertyId 
     * @param {string} [basicAuthUser] 
     * @param {string} [basicAuthPassword] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public putPathServiceProperty(propertyId: number, path: string, host: string, redirectWWW: boolean, portMappingPropertyId: number, basicAuthUser?: string, basicAuthPassword?: string, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).putPathServiceProperty(propertyId, path, host, redirectWWW, portMappingPropertyId, basicAuthUser, basicAuthPassword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} propertyId 
     * @param {number} port 
     * @param {number} containerPort 
     * @param {PutPortMappingServicePropertyFlowTypeEnum} flowType 
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public putPortMappingServiceProperty(propertyId: number, port: number, containerPort: number, flowType: PutPortMappingServicePropertyFlowTypeEnum, name: string, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).putPortMappingServiceProperty(propertyId, port, containerPort, flowType, name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} projectId 
     * @param {Array<string>} [recipes] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public putProjectRecipes(projectId: number, recipes?: Array<string>, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).putProjectRecipes(projectId, recipes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} propertyId 
     * @param {string} path 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public putPrometheusServiceProperty(propertyId: number, path: string, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).putPrometheusServiceProperty(propertyId, path, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} propertyId 
     * @param {PutReadinessProbeServicePropertyReadinessTypeEnum} readinessType 
     * @param {number} [readinessInitialDelaySeconds] 
     * @param {number} [readinessPeriodSeconds] 
     * @param {number} [readinessTimeoutSeconds] 
     * @param {number} [readinessSuccessThreshold] 
     * @param {number} [readinessFailureThreshold] 
     * @param {string} [readinessPath] 
     * @param {number} [readinessPort] 
     * @param {PutReadinessProbeServicePropertyReadinessSchemeEnum} [readinessScheme] 
     * @param {Array<string>} [readinessCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public putReadinessProbeServiceProperty(propertyId: number, readinessType: PutReadinessProbeServicePropertyReadinessTypeEnum, readinessInitialDelaySeconds?: number, readinessPeriodSeconds?: number, readinessTimeoutSeconds?: number, readinessSuccessThreshold?: number, readinessFailureThreshold?: number, readinessPath?: string, readinessPort?: number, readinessScheme?: PutReadinessProbeServicePropertyReadinessSchemeEnum, readinessCommand?: Array<string>, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).putReadinessProbeServiceProperty(propertyId, readinessType, readinessInitialDelaySeconds, readinessPeriodSeconds, readinessTimeoutSeconds, readinessSuccessThreshold, readinessFailureThreshold, readinessPath, readinessPort, readinessScheme, readinessCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} propertyId 
     * @param {string} runAsUser 
     * @param {string} runAsGroup 
     * @param {boolean} [runAsNonRoot] 
     * @param {boolean} [privileged] 
     * @param {boolean} [allowPrivilegeEscalation] 
     * @param {boolean} [readOnlyRootFilesystem] 
     * @param {PutSecurityServicePropertyProcMountEnum} [procMount] 
     * @param {Array<PutSecurityServicePropertyAddCapabilitiesEnum>} [addCapabilities] 
     * @param {Array<PutSecurityServicePropertyDropCapabilitiesEnum>} [dropCapabilities] 
     * @param {string} [seLinuxLevel] 
     * @param {string} [seLinuxRole] 
     * @param {string} [seLinuxType] 
     * @param {string} [seLinuxUser] 
     * @param {PutSecurityServicePropertySeccompProfileTypeEnum} [seccompProfileType] 
     * @param {string} [seccompLocalhostProfile] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public putSecurityServiceProperty(propertyId: number, runAsUser: string, runAsGroup: string, runAsNonRoot?: boolean, privileged?: boolean, allowPrivilegeEscalation?: boolean, readOnlyRootFilesystem?: boolean, procMount?: PutSecurityServicePropertyProcMountEnum, addCapabilities?: Array<PutSecurityServicePropertyAddCapabilitiesEnum>, dropCapabilities?: Array<PutSecurityServicePropertyDropCapabilitiesEnum>, seLinuxLevel?: string, seLinuxRole?: string, seLinuxType?: string, seLinuxUser?: string, seccompProfileType?: PutSecurityServicePropertySeccompProfileTypeEnum, seccompLocalhostProfile?: string, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).putSecurityServiceProperty(propertyId, runAsUser, runAsGroup, runAsNonRoot, privileged, allowPrivilegeEscalation, readOnlyRootFilesystem, procMount, addCapabilities, dropCapabilities, seLinuxLevel, seLinuxRole, seLinuxType, seLinuxUser, seccompProfileType, seccompLocalhostProfile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} roleId 
     * @param {number} privilegeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public setRolePrivilege(roleId: number, privilegeId: number, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).setRolePrivilege(roleId, privilegeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} environmentVariableId 
     * @param {string} key 
     * @param {string} [value] 
     * @param {number} [secretId] 
     * @param {number} [parameterId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public updateEnvironmentVariable(environmentVariableId: number, key: string, value?: string, secretId?: number, parameterId?: number, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).updateEnvironmentVariable(environmentVariableId, key, value, secretId, parameterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} propertyId 
     * @param {number} replicaCount 
     * @param {number} cpuLimit 
     * @param {number} memoryLimit 
     * @param {number} cpuRequest 
     * @param {number} memoryRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public updateK8sServicePropertyEnvironment(propertyId: number, replicaCount: number, cpuLimit: number, memoryLimit: number, cpuRequest: number, memoryRequest: number, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).updateK8sServicePropertyEnvironment(propertyId, replicaCount, cpuLimit, memoryLimit, cpuRequest, memoryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} mountId 
     * @param {string} pathExpression 
     * @param {string} mount 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public updateMount(mountId: number, pathExpression: string, mount: string, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).updateMount(mountId, pathExpression, mount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} parameterId 
     * @param {string} key 
     * @param {string} value 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public updateParameter(parameterId: number, key: string, value: string, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).updateParameter(parameterId, key, value, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} parameterEnvironmentValueId 
     * @param {string} value 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public updateParameterEnvironmentValue(parameterEnvironmentValueId: number, value: string, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).updateParameterEnvironmentValue(parameterEnvironmentValueId, value, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} projectId 
     * @param {string} description 
     * @param {string} [adminUrl] 
     * @param {string} [shortname] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public updateProject(projectId: number, description: string, adminUrl?: string, shortname?: string, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).updateProject(projectId, description, adminUrl, shortname, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} projectId 
     * @param {string} themeColor 
     * @param {string} themeBackgroundColor 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public updateProjectTheme(projectId: number, themeColor: string, themeBackgroundColor: string, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).updateProjectTheme(projectId, themeColor, themeBackgroundColor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} roleId 
     * @param {string} name 
     * @param {boolean} isPublic 
     * @param {Array<number>} privileges 
     * @param {string} description 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public updateRole(roleId: number, name: string, isPublic: boolean, privileges: Array<number>, description: string, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).updateRole(roleId, name, isPublic, privileges, description, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} secretId 
     * @param {string} key 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public updateSecret(secretId: number, key: string, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).updateSecret(secretId, key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} serviceId 
     * @param {string} name 
     * @param {string} description 
     * @param {UpdateServiceTypeEnum} type 
     * @param {Array<number>} [dependencies] 
     * @param {Array<number>} [otherDependencies] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public updateService(serviceId: number, name: string, description: string, type: UpdateServiceTypeEnum, dependencies?: Array<number>, otherDependencies?: Array<number>, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).updateService(serviceId, name, description, type, dependencies, otherDependencies, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} volumeId 
     * @param {string} name 
     * @param {string} size 
     * @param {string} mount 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public updateVolume(volumeId: number, name: string, size: string, mount: string, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).updateVolume(volumeId, name, size, mount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} projectId 
     * @param {UploadMaskableIconRequest} [uploadMaskableIconRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public uploadAppletouchIcon(projectId: number, uploadMaskableIconRequest?: UploadMaskableIconRequest, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).uploadAppletouchIcon(projectId, uploadMaskableIconRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} projectId 
     * @param {UploadMaskableIconRequest} [uploadMaskableIconRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public uploadFavIcon(projectId: number, uploadMaskableIconRequest?: UploadMaskableIconRequest, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).uploadFavIcon(projectId, uploadMaskableIconRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} projectId 
     * @param {UploadMaskableIconRequest} [uploadMaskableIconRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public uploadIcon(projectId: number, uploadMaskableIconRequest?: UploadMaskableIconRequest, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).uploadIcon(projectId, uploadMaskableIconRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} projectId 
     * @param {UploadMaskableIconRequest} [uploadMaskableIconRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public uploadLogo(projectId: number, uploadMaskableIconRequest?: UploadMaskableIconRequest, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).uploadLogo(projectId, uploadMaskableIconRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} projectId 
     * @param {UploadMaskableIconRequest} [uploadMaskableIconRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public uploadMaskableIcon(projectId: number, uploadMaskableIconRequest?: UploadMaskableIconRequest, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).uploadMaskableIcon(projectId, uploadMaskableIconRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public user(options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).user(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} projectId 
     * @param {Array<string>} recipes 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public verifyRecipe(projectId: number, recipes: Array<string>, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).verifyRecipe(projectId, recipes, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const CreateServiceTypeEnum = {
    Backend: 'BACKEND',
    Gui: 'GUI'
} as const;
export type CreateServiceTypeEnum = typeof CreateServiceTypeEnum[keyof typeof CreateServiceTypeEnum];
/**
 * @export
 */
export const PostLivenessServicePropertyLivenessTypeEnum = {
    Http: 'http',
    Tcp: 'tcp',
    Exec: 'exec'
} as const;
export type PostLivenessServicePropertyLivenessTypeEnum = typeof PostLivenessServicePropertyLivenessTypeEnum[keyof typeof PostLivenessServicePropertyLivenessTypeEnum];
/**
 * @export
 */
export const PostLivenessServicePropertyLivenessSchemeEnum = {
    Http: 'http',
    Https: 'https'
} as const;
export type PostLivenessServicePropertyLivenessSchemeEnum = typeof PostLivenessServicePropertyLivenessSchemeEnum[keyof typeof PostLivenessServicePropertyLivenessSchemeEnum];
/**
 * @export
 */
export const PostPortMappingServicePropertyFlowTypeEnum = {
    Http: 'http',
    Https: 'https',
    Tcp: 'tcp',
    Passthrough: 'passthrough',
    Udp: 'udp'
} as const;
export type PostPortMappingServicePropertyFlowTypeEnum = typeof PostPortMappingServicePropertyFlowTypeEnum[keyof typeof PostPortMappingServicePropertyFlowTypeEnum];
/**
 * @export
 */
export const PostReadinessServicePropertyReadinessTypeEnum = {
    Http: 'http',
    Tcp: 'tcp',
    Exec: 'exec'
} as const;
export type PostReadinessServicePropertyReadinessTypeEnum = typeof PostReadinessServicePropertyReadinessTypeEnum[keyof typeof PostReadinessServicePropertyReadinessTypeEnum];
/**
 * @export
 */
export const PostReadinessServicePropertyReadinessSchemeEnum = {
    Http: 'http',
    Https: 'https'
} as const;
export type PostReadinessServicePropertyReadinessSchemeEnum = typeof PostReadinessServicePropertyReadinessSchemeEnum[keyof typeof PostReadinessServicePropertyReadinessSchemeEnum];
/**
 * @export
 */
export const PostSecurityServicePropertyProcMountEnum = {
    Default: 'Default',
    Unmasked: 'Unmasked'
} as const;
export type PostSecurityServicePropertyProcMountEnum = typeof PostSecurityServicePropertyProcMountEnum[keyof typeof PostSecurityServicePropertyProcMountEnum];
/**
 * @export
 */
export const PostSecurityServicePropertyAddCapabilitiesEnum = {
    All: 'ALL',
    NetBindService: 'NET_BIND_SERVICE',
    IpcLock: 'IPC_LOCK',
    SysTime: 'SYS_TIME',
    SysAdmin: 'SYS_ADMIN',
    AuditWrite: 'AUDIT_WRITE',
    Chown: 'CHOWN',
    DacOverride: 'DAC_OVERRIDE',
    Fowner: 'FOWNER',
    Fsetid: 'FSETID',
    Kill: 'KILL',
    Mknod: 'MKNOD',
    NetRaw: 'NET_RAW',
    Setfcap: 'SETFCAP',
    Setgid: 'SETGID',
    Setuid: 'SETUID',
    Setpcap: 'SETPCAP',
    SysChroot: 'SYS_CHROOT',
    SysPtrace: 'SYS_PTRACE',
    SysModule: 'SYS_MODULE',
    SysNice: 'SYS_NICE',
    SysResource: 'SYS_RESOURCE',
    SysTtyConfig: 'SYS_TTY_CONFIG'
} as const;
export type PostSecurityServicePropertyAddCapabilitiesEnum = typeof PostSecurityServicePropertyAddCapabilitiesEnum[keyof typeof PostSecurityServicePropertyAddCapabilitiesEnum];
/**
 * @export
 */
export const PostSecurityServicePropertyDropCapabilitiesEnum = {
    All: 'ALL',
    NetBindService: 'NET_BIND_SERVICE',
    IpcLock: 'IPC_LOCK',
    SysTime: 'SYS_TIME',
    SysAdmin: 'SYS_ADMIN',
    AuditWrite: 'AUDIT_WRITE',
    Chown: 'CHOWN',
    DacOverride: 'DAC_OVERRIDE',
    Fowner: 'FOWNER',
    Fsetid: 'FSETID',
    Kill: 'KILL',
    Mknod: 'MKNOD',
    NetRaw: 'NET_RAW',
    Setfcap: 'SETFCAP',
    Setgid: 'SETGID',
    Setuid: 'SETUID',
    Setpcap: 'SETPCAP',
    SysChroot: 'SYS_CHROOT',
    SysPtrace: 'SYS_PTRACE',
    SysModule: 'SYS_MODULE',
    SysNice: 'SYS_NICE',
    SysResource: 'SYS_RESOURCE',
    SysTtyConfig: 'SYS_TTY_CONFIG'
} as const;
export type PostSecurityServicePropertyDropCapabilitiesEnum = typeof PostSecurityServicePropertyDropCapabilitiesEnum[keyof typeof PostSecurityServicePropertyDropCapabilitiesEnum];
/**
 * @export
 */
export const PostSecurityServicePropertySeccompProfileTypeEnum = {
    RuntimeDefault: 'RuntimeDefault',
    Localhost: 'Localhost',
    Unconfined: 'Unconfined'
} as const;
export type PostSecurityServicePropertySeccompProfileTypeEnum = typeof PostSecurityServicePropertySeccompProfileTypeEnum[keyof typeof PostSecurityServicePropertySeccompProfileTypeEnum];
/**
 * @export
 */
export const PutActivateCompanyUserTitleEnum = {
    SoftwareEngineer: 'SOFTWARE_ENGINEER',
    Freelance: 'FREELANCE',
    Entrepreneur: 'ENTREPRENEUR',
    Architect: 'ARCHITECT',
    ChiefTechnologyOfficer: 'CHIEF_TECHNOLOGY_OFFICER',
    Other: 'OTHER'
} as const;
export type PutActivateCompanyUserTitleEnum = typeof PutActivateCompanyUserTitleEnum[keyof typeof PutActivateCompanyUserTitleEnum];
/**
 * @export
 */
export const PutActivateUserTitleEnum = {
    SoftwareEngineer: 'SOFTWARE_ENGINEER',
    Freelance: 'FREELANCE',
    Entrepreneur: 'ENTREPRENEUR',
    Architect: 'ARCHITECT',
    ChiefTechnologyOfficer: 'CHIEF_TECHNOLOGY_OFFICER',
    Other: 'OTHER'
} as const;
export type PutActivateUserTitleEnum = typeof PutActivateUserTitleEnum[keyof typeof PutActivateUserTitleEnum];
/**
 * @export
 */
export const PutLivenessProbeServicePropertyLivenessTypeEnum = {
    Http: 'http',
    Tcp: 'tcp',
    Exec: 'exec'
} as const;
export type PutLivenessProbeServicePropertyLivenessTypeEnum = typeof PutLivenessProbeServicePropertyLivenessTypeEnum[keyof typeof PutLivenessProbeServicePropertyLivenessTypeEnum];
/**
 * @export
 */
export const PutLivenessProbeServicePropertyLivenessSchemeEnum = {
    Http: 'http',
    Https: 'https'
} as const;
export type PutLivenessProbeServicePropertyLivenessSchemeEnum = typeof PutLivenessProbeServicePropertyLivenessSchemeEnum[keyof typeof PutLivenessProbeServicePropertyLivenessSchemeEnum];
/**
 * @export
 */
export const PutPortMappingServicePropertyFlowTypeEnum = {
    Http: 'http',
    Https: 'https',
    Tcp: 'tcp',
    Passthrough: 'passthrough',
    Udp: 'udp'
} as const;
export type PutPortMappingServicePropertyFlowTypeEnum = typeof PutPortMappingServicePropertyFlowTypeEnum[keyof typeof PutPortMappingServicePropertyFlowTypeEnum];
/**
 * @export
 */
export const PutReadinessProbeServicePropertyReadinessTypeEnum = {
    Http: 'http',
    Tcp: 'tcp',
    Exec: 'exec'
} as const;
export type PutReadinessProbeServicePropertyReadinessTypeEnum = typeof PutReadinessProbeServicePropertyReadinessTypeEnum[keyof typeof PutReadinessProbeServicePropertyReadinessTypeEnum];
/**
 * @export
 */
export const PutReadinessProbeServicePropertyReadinessSchemeEnum = {
    Http: 'http',
    Https: 'https'
} as const;
export type PutReadinessProbeServicePropertyReadinessSchemeEnum = typeof PutReadinessProbeServicePropertyReadinessSchemeEnum[keyof typeof PutReadinessProbeServicePropertyReadinessSchemeEnum];
/**
 * @export
 */
export const PutSecurityServicePropertyProcMountEnum = {
    Default: 'Default',
    Unmasked: 'Unmasked'
} as const;
export type PutSecurityServicePropertyProcMountEnum = typeof PutSecurityServicePropertyProcMountEnum[keyof typeof PutSecurityServicePropertyProcMountEnum];
/**
 * @export
 */
export const PutSecurityServicePropertyAddCapabilitiesEnum = {
    All: 'ALL',
    NetBindService: 'NET_BIND_SERVICE',
    IpcLock: 'IPC_LOCK',
    SysTime: 'SYS_TIME',
    SysAdmin: 'SYS_ADMIN',
    AuditWrite: 'AUDIT_WRITE',
    Chown: 'CHOWN',
    DacOverride: 'DAC_OVERRIDE',
    Fowner: 'FOWNER',
    Fsetid: 'FSETID',
    Kill: 'KILL',
    Mknod: 'MKNOD',
    NetRaw: 'NET_RAW',
    Setfcap: 'SETFCAP',
    Setgid: 'SETGID',
    Setuid: 'SETUID',
    Setpcap: 'SETPCAP',
    SysChroot: 'SYS_CHROOT',
    SysPtrace: 'SYS_PTRACE',
    SysModule: 'SYS_MODULE',
    SysNice: 'SYS_NICE',
    SysResource: 'SYS_RESOURCE',
    SysTtyConfig: 'SYS_TTY_CONFIG'
} as const;
export type PutSecurityServicePropertyAddCapabilitiesEnum = typeof PutSecurityServicePropertyAddCapabilitiesEnum[keyof typeof PutSecurityServicePropertyAddCapabilitiesEnum];
/**
 * @export
 */
export const PutSecurityServicePropertyDropCapabilitiesEnum = {
    All: 'ALL',
    NetBindService: 'NET_BIND_SERVICE',
    IpcLock: 'IPC_LOCK',
    SysTime: 'SYS_TIME',
    SysAdmin: 'SYS_ADMIN',
    AuditWrite: 'AUDIT_WRITE',
    Chown: 'CHOWN',
    DacOverride: 'DAC_OVERRIDE',
    Fowner: 'FOWNER',
    Fsetid: 'FSETID',
    Kill: 'KILL',
    Mknod: 'MKNOD',
    NetRaw: 'NET_RAW',
    Setfcap: 'SETFCAP',
    Setgid: 'SETGID',
    Setuid: 'SETUID',
    Setpcap: 'SETPCAP',
    SysChroot: 'SYS_CHROOT',
    SysPtrace: 'SYS_PTRACE',
    SysModule: 'SYS_MODULE',
    SysNice: 'SYS_NICE',
    SysResource: 'SYS_RESOURCE',
    SysTtyConfig: 'SYS_TTY_CONFIG'
} as const;
export type PutSecurityServicePropertyDropCapabilitiesEnum = typeof PutSecurityServicePropertyDropCapabilitiesEnum[keyof typeof PutSecurityServicePropertyDropCapabilitiesEnum];
/**
 * @export
 */
export const PutSecurityServicePropertySeccompProfileTypeEnum = {
    RuntimeDefault: 'RuntimeDefault',
    Localhost: 'Localhost',
    Unconfined: 'Unconfined'
} as const;
export type PutSecurityServicePropertySeccompProfileTypeEnum = typeof PutSecurityServicePropertySeccompProfileTypeEnum[keyof typeof PutSecurityServicePropertySeccompProfileTypeEnum];
/**
 * @export
 */
export const UpdateServiceTypeEnum = {
    Backend: 'BACKEND',
    Gui: 'GUI'
} as const;
export type UpdateServiceTypeEnum = typeof UpdateServiceTypeEnum[keyof typeof UpdateServiceTypeEnum];


/**
 * PublicControllerApi - axios parameter creator
 * @export
 */
export const PublicControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} token 
         * @param {number} id 
         * @param {string} base64redirectUrl 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptRoleInvite: async (token: string, id: number, base64redirectUrl: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('acceptRoleInvite', 'token', token)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('acceptRoleInvite', 'id', id)
            // verify required parameter 'base64redirectUrl' is not null or undefined
            assertParamExists('acceptRoleInvite', 'base64redirectUrl', base64redirectUrl)
            const localVarPath = `/public/invite/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }

            if (base64redirectUrl !== undefined) {
                localVarQueryParameter['base64redirectUrl'] = base64redirectUrl;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticated: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/public/authenticated`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} password 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword: async (password: string, token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'password' is not null or undefined
            assertParamExists('changePassword', 'password', password)
            // verify required parameter 'token' is not null or undefined
            assertParamExists('changePassword', 'token', token)
            const localVarPath = `/public/changePassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (password !== undefined) {
                localVarQueryParameter['password'] = password;
            }

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} token 
         * @param {string} base64loginUrl 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmUserAccount: async (token: string, base64loginUrl: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('confirmUserAccount', 'token', token)
            // verify required parameter 'base64loginUrl' is not null or undefined
            assertParamExists('confirmUserAccount', 'base64loginUrl', base64loginUrl)
            const localVarPath = `/public/confirmAccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }

            if (base64loginUrl !== undefined) {
                localVarQueryParameter['base64loginUrl'] = base64loginUrl;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectIcon: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProjectIcon', 'id', id)
            const localVarPath = `/public/projecticon/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectTheme1: async (projectId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getProjectTheme1', 'projectId', projectId)
            const localVarPath = `/public/project/{projectId}/theme`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviders: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/public/providers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicProjectRoles: async (projectId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getPublicProjectRoles', 'projectId', projectId)
            const localVarPath = `/public/project/{projectId}/roles`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServicePropertyTypes: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/public/propertiestypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleFoo: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/public/foo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleFoo1: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/public/foo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleFoo2: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/public/foo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleFoo3: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/public/foo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleFoo4: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/public/foo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleFoo5: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/public/foo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'HEAD', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleFoo6: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/public/foo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email 
         * @param {string} password 
         * @param {number} role 
         * @param {string} redirectUrl 
         * @param {string} mail 
         * @param {string} language 
         * @param {string} from 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register: async (email: string, password: string, role: number, redirectUrl: string, mail: string, language: string, from: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('register', 'email', email)
            // verify required parameter 'password' is not null or undefined
            assertParamExists('register', 'password', password)
            // verify required parameter 'role' is not null or undefined
            assertParamExists('register', 'role', role)
            // verify required parameter 'redirectUrl' is not null or undefined
            assertParamExists('register', 'redirectUrl', redirectUrl)
            // verify required parameter 'mail' is not null or undefined
            assertParamExists('register', 'mail', mail)
            // verify required parameter 'language' is not null or undefined
            assertParamExists('register', 'language', language)
            // verify required parameter 'from' is not null or undefined
            assertParamExists('register', 'from', from)
            const localVarPath = `/public/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (password !== undefined) {
                localVarQueryParameter['password'] = password;
            }

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }

            if (redirectUrl !== undefined) {
                localVarQueryParameter['redirectUrl'] = redirectUrl;
            }

            if (mail !== undefined) {
                localVarQueryParameter['mail'] = mail;
            }

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword: async (email: string, language: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('resetPassword', 'email', email)
            // verify required parameter 'language' is not null or undefined
            assertParamExists('resetPassword', 'language', language)
            const localVarPath = `/public/resetPassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PublicControllerApi - functional programming interface
 * @export
 */
export const PublicControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PublicControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} token 
         * @param {number} id 
         * @param {string} base64redirectUrl 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptRoleInvite(token: string, id: number, base64redirectUrl: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptRoleInvite(token, id, base64redirectUrl, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicControllerApi.acceptRoleInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authenticated(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authenticated(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicControllerApi.authenticated']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} password 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changePassword(password: string, token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changePassword(password, token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicControllerApi.changePassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} token 
         * @param {string} base64loginUrl 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmUserAccount(token: string, base64loginUrl: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirmUserAccount(token, base64loginUrl, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicControllerApi.confirmUserAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjectIcon(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjectIcon(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicControllerApi.getProjectIcon']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjectTheme1(projectId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectThemeResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjectTheme1(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicControllerApi.getProjectTheme1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProviders(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProviderResource>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProviders(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicControllerApi.getProviders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublicProjectRoles(projectId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RoleResource>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPublicProjectRoles(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicControllerApi.getPublicProjectRoles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getServicePropertyTypes(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ServicePropertyTypeResource>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getServicePropertyTypes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicControllerApi.getServicePropertyTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async handleFoo(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.handleFoo(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicControllerApi.handleFoo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async handleFoo1(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.handleFoo1(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicControllerApi.handleFoo1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async handleFoo2(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.handleFoo2(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicControllerApi.handleFoo2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async handleFoo3(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.handleFoo3(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicControllerApi.handleFoo3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async handleFoo4(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.handleFoo4(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicControllerApi.handleFoo4']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async handleFoo5(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.handleFoo5(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicControllerApi.handleFoo5']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async handleFoo6(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.handleFoo6(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicControllerApi.handleFoo6']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} email 
         * @param {string} password 
         * @param {number} role 
         * @param {string} redirectUrl 
         * @param {string} mail 
         * @param {string} language 
         * @param {string} from 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async register(email: string, password: string, role: number, redirectUrl: string, mail: string, language: string, from: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentityResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.register(email, password, role, redirectUrl, mail, language, from, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicControllerApi.register']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} email 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetPassword(email: string, language: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetPassword(email, language, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicControllerApi.resetPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PublicControllerApi - factory interface
 * @export
 */
export const PublicControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PublicControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} token 
         * @param {number} id 
         * @param {string} base64redirectUrl 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptRoleInvite(token: string, id: number, base64redirectUrl: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.acceptRoleInvite(token, id, base64redirectUrl, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticated(options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.authenticated(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} password 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword(password: string, token: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.changePassword(password, token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} token 
         * @param {string} base64loginUrl 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmUserAccount(token: string, base64loginUrl: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.confirmUserAccount(token, base64loginUrl, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectIcon(id: number, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getProjectIcon(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectTheme1(projectId: number, options?: RawAxiosRequestConfig): AxiosPromise<ProjectThemeResource> {
            return localVarFp.getProjectTheme1(projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviders(options?: RawAxiosRequestConfig): AxiosPromise<Array<ProviderResource>> {
            return localVarFp.getProviders(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicProjectRoles(projectId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<RoleResource>> {
            return localVarFp.getPublicProjectRoles(projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServicePropertyTypes(options?: RawAxiosRequestConfig): AxiosPromise<Array<ServicePropertyTypeResource>> {
            return localVarFp.getServicePropertyTypes(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleFoo(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.handleFoo(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleFoo1(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.handleFoo1(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleFoo2(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.handleFoo2(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleFoo3(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.handleFoo3(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleFoo4(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.handleFoo4(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleFoo5(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.handleFoo5(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleFoo6(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.handleFoo6(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} email 
         * @param {string} password 
         * @param {number} role 
         * @param {string} redirectUrl 
         * @param {string} mail 
         * @param {string} language 
         * @param {string} from 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register(email: string, password: string, role: number, redirectUrl: string, mail: string, language: string, from: string, options?: RawAxiosRequestConfig): AxiosPromise<IdentityResource> {
            return localVarFp.register(email, password, role, redirectUrl, mail, language, from, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} email 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword(email: string, language: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.resetPassword(email, language, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PublicControllerApi - object-oriented interface
 * @export
 * @class PublicControllerApi
 * @extends {BaseAPI}
 */
export class PublicControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} token 
     * @param {number} id 
     * @param {string} base64redirectUrl 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicControllerApi
     */
    public acceptRoleInvite(token: string, id: number, base64redirectUrl: string, options?: RawAxiosRequestConfig) {
        return PublicControllerApiFp(this.configuration).acceptRoleInvite(token, id, base64redirectUrl, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicControllerApi
     */
    public authenticated(options?: RawAxiosRequestConfig) {
        return PublicControllerApiFp(this.configuration).authenticated(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} password 
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicControllerApi
     */
    public changePassword(password: string, token: string, options?: RawAxiosRequestConfig) {
        return PublicControllerApiFp(this.configuration).changePassword(password, token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} token 
     * @param {string} base64loginUrl 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicControllerApi
     */
    public confirmUserAccount(token: string, base64loginUrl: string, options?: RawAxiosRequestConfig) {
        return PublicControllerApiFp(this.configuration).confirmUserAccount(token, base64loginUrl, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicControllerApi
     */
    public getProjectIcon(id: number, options?: RawAxiosRequestConfig) {
        return PublicControllerApiFp(this.configuration).getProjectIcon(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} projectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicControllerApi
     */
    public getProjectTheme1(projectId: number, options?: RawAxiosRequestConfig) {
        return PublicControllerApiFp(this.configuration).getProjectTheme1(projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicControllerApi
     */
    public getProviders(options?: RawAxiosRequestConfig) {
        return PublicControllerApiFp(this.configuration).getProviders(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} projectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicControllerApi
     */
    public getPublicProjectRoles(projectId: number, options?: RawAxiosRequestConfig) {
        return PublicControllerApiFp(this.configuration).getPublicProjectRoles(projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicControllerApi
     */
    public getServicePropertyTypes(options?: RawAxiosRequestConfig) {
        return PublicControllerApiFp(this.configuration).getServicePropertyTypes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicControllerApi
     */
    public handleFoo(options?: RawAxiosRequestConfig) {
        return PublicControllerApiFp(this.configuration).handleFoo(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicControllerApi
     */
    public handleFoo1(options?: RawAxiosRequestConfig) {
        return PublicControllerApiFp(this.configuration).handleFoo1(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicControllerApi
     */
    public handleFoo2(options?: RawAxiosRequestConfig) {
        return PublicControllerApiFp(this.configuration).handleFoo2(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicControllerApi
     */
    public handleFoo3(options?: RawAxiosRequestConfig) {
        return PublicControllerApiFp(this.configuration).handleFoo3(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicControllerApi
     */
    public handleFoo4(options?: RawAxiosRequestConfig) {
        return PublicControllerApiFp(this.configuration).handleFoo4(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicControllerApi
     */
    public handleFoo5(options?: RawAxiosRequestConfig) {
        return PublicControllerApiFp(this.configuration).handleFoo5(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicControllerApi
     */
    public handleFoo6(options?: RawAxiosRequestConfig) {
        return PublicControllerApiFp(this.configuration).handleFoo6(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} email 
     * @param {string} password 
     * @param {number} role 
     * @param {string} redirectUrl 
     * @param {string} mail 
     * @param {string} language 
     * @param {string} from 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicControllerApi
     */
    public register(email: string, password: string, role: number, redirectUrl: string, mail: string, language: string, from: string, options?: RawAxiosRequestConfig) {
        return PublicControllerApiFp(this.configuration).register(email, password, role, redirectUrl, mail, language, from, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} email 
     * @param {string} language 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicControllerApi
     */
    public resetPassword(email: string, language: string, options?: RawAxiosRequestConfig) {
        return PublicControllerApiFp(this.configuration).resetPassword(email, language, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SuControllerApi - axios parameter creator
 * @export
 */
export const SuControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmationToken: async (email: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('confirmationToken', 'email', email)
            const localVarPath = `/su/confirmationToken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email 
         * @param {string} password 
         * @param {Array<number>} roles 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIdentity: async (email: string, password: string, roles: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('createIdentity', 'email', email)
            // verify required parameter 'password' is not null or undefined
            assertParamExists('createIdentity', 'password', password)
            // verify required parameter 'roles' is not null or undefined
            assertParamExists('createIdentity', 'roles', roles)
            const localVarPath = `/su/identity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (password !== undefined) {
                localVarQueryParameter['password'] = password;
            }

            if (roles) {
                localVarQueryParameter['roles'] = roles;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] Page you want to retrieve (0..N)
         * @param {number} [size] Number of records per page.
         * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIdentitiesPaginated: async (page?: number, size?: number, sort?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/su/identities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort.join(COLLECTION_FORMATS.csv);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIdentityByEmail: async (email: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('getIdentityByEmail', 'email', email)
            const localVarPath = `/su/identity/{email}`
                .replace(`{${"email"}}`, encodeURIComponent(String(email)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoles1: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/su/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} identityId 
         * @param {number} roleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setIdentityRole: async (identityId: number, roleId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityId' is not null or undefined
            assertParamExists('setIdentityRole', 'identityId', identityId)
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('setIdentityRole', 'roleId', roleId)
            const localVarPath = `/su/identity/{identityId}/roles`
                .replace(`{${"identityId"}}`, encodeURIComponent(String(identityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (roleId !== undefined) {
                localVarQueryParameter['roleId'] = roleId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} identityId 
         * @param {Array<number>} roles 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIdentity: async (identityId: number, roles: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityId' is not null or undefined
            assertParamExists('updateIdentity', 'identityId', identityId)
            // verify required parameter 'roles' is not null or undefined
            assertParamExists('updateIdentity', 'roles', roles)
            const localVarPath = `/su/identity/{identityId}`
                .replace(`{${"identityId"}}`, encodeURIComponent(String(identityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (roles) {
                localVarQueryParameter['roles'] = roles;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SuControllerApi - functional programming interface
 * @export
 */
export const SuControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SuControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmationToken(email: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirmationToken(email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuControllerApi.confirmationToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} email 
         * @param {string} password 
         * @param {Array<number>} roles 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createIdentity(email: string, password: string, roles: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentityResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createIdentity(email, password, roles, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuControllerApi.createIdentity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] Page you want to retrieve (0..N)
         * @param {number} [size] Number of records per page.
         * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIdentitiesPaginated(page?: number, size?: number, sort?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageIdentityResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIdentitiesPaginated(page, size, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuControllerApi.getIdentitiesPaginated']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIdentityByEmail(email: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentityResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIdentityByEmail(email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuControllerApi.getIdentityByEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRoles1(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RoleResource>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRoles1(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuControllerApi.getRoles1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} identityId 
         * @param {number} roleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setIdentityRole(identityId: number, roleId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentityResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setIdentityRole(identityId, roleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuControllerApi.setIdentityRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} identityId 
         * @param {Array<number>} roles 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateIdentity(identityId: number, roles: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentityResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateIdentity(identityId, roles, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuControllerApi.updateIdentity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SuControllerApi - factory interface
 * @export
 */
export const SuControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SuControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmationToken(email: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.confirmationToken(email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} email 
         * @param {string} password 
         * @param {Array<number>} roles 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIdentity(email: string, password: string, roles: Array<number>, options?: RawAxiosRequestConfig): AxiosPromise<IdentityResource> {
            return localVarFp.createIdentity(email, password, roles, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [page] Page you want to retrieve (0..N)
         * @param {number} [size] Number of records per page.
         * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIdentitiesPaginated(page?: number, size?: number, sort?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<PageIdentityResource> {
            return localVarFp.getIdentitiesPaginated(page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIdentityByEmail(email: string, options?: RawAxiosRequestConfig): AxiosPromise<IdentityResource> {
            return localVarFp.getIdentityByEmail(email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoles1(options?: RawAxiosRequestConfig): AxiosPromise<Array<RoleResource>> {
            return localVarFp.getRoles1(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} identityId 
         * @param {number} roleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setIdentityRole(identityId: number, roleId: number, options?: RawAxiosRequestConfig): AxiosPromise<IdentityResource> {
            return localVarFp.setIdentityRole(identityId, roleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} identityId 
         * @param {Array<number>} roles 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIdentity(identityId: number, roles: Array<number>, options?: RawAxiosRequestConfig): AxiosPromise<IdentityResource> {
            return localVarFp.updateIdentity(identityId, roles, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SuControllerApi - object-oriented interface
 * @export
 * @class SuControllerApi
 * @extends {BaseAPI}
 */
export class SuControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuControllerApi
     */
    public confirmationToken(email: string, options?: RawAxiosRequestConfig) {
        return SuControllerApiFp(this.configuration).confirmationToken(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} email 
     * @param {string} password 
     * @param {Array<number>} roles 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuControllerApi
     */
    public createIdentity(email: string, password: string, roles: Array<number>, options?: RawAxiosRequestConfig) {
        return SuControllerApiFp(this.configuration).createIdentity(email, password, roles, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [page] Page you want to retrieve (0..N)
     * @param {number} [size] Number of records per page.
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuControllerApi
     */
    public getIdentitiesPaginated(page?: number, size?: number, sort?: Array<string>, options?: RawAxiosRequestConfig) {
        return SuControllerApiFp(this.configuration).getIdentitiesPaginated(page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuControllerApi
     */
    public getIdentityByEmail(email: string, options?: RawAxiosRequestConfig) {
        return SuControllerApiFp(this.configuration).getIdentityByEmail(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuControllerApi
     */
    public getRoles1(options?: RawAxiosRequestConfig) {
        return SuControllerApiFp(this.configuration).getRoles1(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} identityId 
     * @param {number} roleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuControllerApi
     */
    public setIdentityRole(identityId: number, roleId: number, options?: RawAxiosRequestConfig) {
        return SuControllerApiFp(this.configuration).setIdentityRole(identityId, roleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} identityId 
     * @param {Array<number>} roles 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuControllerApi
     */
    public updateIdentity(identityId: number, roles: Array<number>, options?: RawAxiosRequestConfig) {
        return SuControllerApiFp(this.configuration).updateIdentity(identityId, roles, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserControllerApi - axios parameter creator
 * @export
 */
export const UserControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoles: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/me/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        identity: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/identity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserControllerApi - functional programming interface
 * @export
 */
export const UserControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRoles(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRoles(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.getRoles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async identity(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentityResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.identity(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.identity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserControllerApi - factory interface
 * @export
 */
export const UserControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoles(options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.getRoles(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        identity(options?: RawAxiosRequestConfig): AxiosPromise<IdentityResource> {
            return localVarFp.identity(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserControllerApi - object-oriented interface
 * @export
 * @class UserControllerApi
 * @extends {BaseAPI}
 */
export class UserControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApi
     */
    public getRoles(options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).getRoles(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApi
     */
    public identity(options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).identity(options).then((request) => request(this.axios, this.basePath));
    }
}



